<template>
  <div class="dashbord-wrp main-dashboard">
    <div class="wrp">
      <h1 class="clear pc-title">
        Dashboard
        <!-- 重新绑定deputy，后台计算比较久，如果还在计算是没数据返回的，计算期间显示这个按钮，Re-binding the pair, the background calculation takes a long time, if there is no data returned during the calculation, this button is displayed during the calculation
      就去轮询判断 /optionalList 有无this week返回，没有的话就一直转圈， Just go to poll to judge whether /optionalList returns this week, if not, keep turning around
      过一会继续请求，轮询，直到有数据了，才停止转圈并去刷新页面 After a while, continue to request and poll until there is data, then stop spinning and refresh the page-->

        <!-- <button class="estimate-button" :style="{ cursor: polling ? 'not-allowed' : 'pointer' }" v-if="calFlag" @click="pollingOperate" :disabled="polling" > Start Estimate <i class="el-icon-loading" v-if="polling"></i> </button> -->

        <!-- 最早版本的start es -->
        <!-- <button class="estimate-button" :style="{ cursor: querying ? 'not-allowed' : 'pointer' }" v-if="showButton && !calFlag" @click="queryTemporary" :disabled="querying" > Start Estimate <i class="el-icon-loading" v-if="querying"></i> </button> -->

        <!-- last week 没有数据，且选中了last week的时候显示 -->
        <!-- <button class="estimate-button" :style="{ cursor: querying ? 'not-allowed' : 'pointer' }" v-if="showLastWeekEstimateButton" @click="queryTemporary('lastweek')" :disabled="querying" > Start Estimate <i class="el-icon-loading" v-if="querying"></i> </button> -->


      </h1>

      <div class="sync-time d-none">Last sync data time: {{ getSycLastTime.sycLastTime }}</div>

      <!-- \\ -->
      <div class="w-full d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-16">
          <dayChoice v-if="weekList.length" :weekDay="weekDay" :showDeputyCycle="showDeputyCycle" :weekStart="weekStart"
          @dayChange="dayChangeEvt" @typeChange="typeChangeEvt" :currentChosen="currentChosen" :weekList="weekList"
          :dashBoardId="week" />
          <div class="current-date" v-if="currentChosen == 0">
            Week Start: {{ formattedWeekStartDate }}
          </div>
        </div>
        <template v-if="isENableRerunLabour">
          <el-button v-if="currentChosen == 1 && (currentWeekType == 'NEXT WEEK' || currentWeekType == 'LAST WEEK')"
            @click="refreshLabour" class="btn-refresh"
            :icon="refreshRosterLoading ? 'el-icon-loading' : 'el-icon-refresh'">
            <span>Refresh Roster</span>
          </el-button>
        </template>
      </div>


      <div class="overview-main-container d-flex gap-16 m-bottom-1rem">
        <dashboard-overview :isGstAdded="isGstAdded" :info="infoGuidance" :isDaily="currentChosen"
          :dataLoading="dataLoading"></dashboard-overview>
        <dashboard-overview :isGstAdded="isGstAdded" :venueId="venueId" :isDaily="currentChosen" @show-cashup="onCashupOpen"
          :currentWeekType="currentWeekType" :info="infoReports" :isEnable="currentChosen" :dataLoading="dataLoading"
          :isLoadingEod=isLoadingEod @show-reports-modal="transactionVisibility = true" @show-eod-report="openEod"
          @show-weekly-report="openWeeklyReport(1, 'Would you like to generate <br>an end of week report?')"></dashboard-overview>
      </div>
      <div class="overview-main-container d-flex gap-16 m-bottom-1rem">
        <dashboard-overview :info="infoTargetRevenue" :id="`3`" :isDaily="currentChosen"
          :isEnable="setSelectedWeek('RevenueTarget')"  :isGstAdded="isGstAdded" @show-target="editTarget"
          :dataLoading=dataLoading></dashboard-overview>
        <dashboard-overview :info="infoActualRevenue" :id="`4`" :isDaily="currentChosen"
          :isEnable="setSelectedWeek('ActualRevenue')" :isGstAdded="isGstAdded" @show-actual="enterActualIncome(0)"
          :dataLoading=dataLoading></dashboard-overview>
      </div>

      <div class="overview-main-container d-flex gap-16 m-bottom-1rem">
        <dashboard-overview :isGstAdded="isGstAdded" :info="infoTargetRoster" :id="`1`" :isDaily="currentChosen"
          :dataLoading=dataLoading></dashboard-overview>
        <dashboard-overview :isGstAdded="isGstAdded" :info="infoActualRoster" :id="`2`" :isDaily="currentChosen"
          :dataLoading=dataLoading></dashboard-overview>
      </div>

      <div class="chart" v-show="currentChosen === 0">
        <div class="black-bgd-color chart__item">

          <Echart currentType="revenue" :dailyTrendDay="dailyTrendDay" @evtFromChart="evtFromChart" :weekDay="weekDay"
            :loading="dailyTrendLoading" @done-revenue-loading="dailyTrendLoading = false" :datum="dailyTrendChartDatum"
            :showDeputyCycle="showDeputyCycle" :weekStart="weekStart" :currentDay="dailyTrendDay"
            @actual-revenue="setActualRevenue" :isThisWeek="isThisWeek" :timeZone="zoneId" />
        </div>
        <div class="black-bgd-color chart__item">
          <!-- Chart V2 -->
          <Chart v-if="isDashboardV2 && currentSelectedDate && env.NAME != 'lucas'" :date="currentSelectedDate" currentType="labour" />
          <!-- Chart Old V1 -->
          <Echart v-else currentType="labour" :dailyTrendDay="dailyTrendDay" @evtFromChart="evtFromChart" :weekDay="weekDay"
            :loading="dailyTrendLoadingLabour" @done-labour-loading="dailyTrendLoadingLabour = false"
            :datum="dailyTrendLabourChartDatum" :showDeputyCycle="showDeputyCycle" :weekStart="weekStart"
            :currentDay="dailyTrendDay" @actual-revenue="setActualRevenue" :isThisWeek="isThisWeek"
            :timeZone="zoneId" />
        </div>
      </div>

      <div v-show="currentChosen === 1">
        <ActualWeeklyOperation :weekStart="weekStart" :startDate="startDate" :currentWeek="currentWeek" :loading="loading" :list="tableData1"
          :labourHourlyRate="labourHourlyRate" />

        <WeeklyLabourTable :weekStart="weekStart" :startDate="startDate" :currentWeek="currentWeek" :loading="loading"
          :weeklyLabourHours="weeklyLabourHours" :showDeputyCycle="showDeputyCycle" :weeklyLabourCost="weeklyLabourCost"
          :isPinNeeded="isPinNeeded" :isSingleAcc="isSingleAcc" />
      </div>


      <!-- 弹框 -->
      <transition name="fade" v-if="pop">
        <div class="pop-wrp">
          <div class="frist-step" v-if="showfrist" :class="{ normal: fristbox }"
            :style="{ marginTop: showDoshii === true ? '-292px' : '-250px', }">
            <h4 class="logo">PEISO</h4>
            <h1>To understand your business</h1>
            <h2>We need to link to your following platform accounts.</h2>
            <!-- 第三方的绑定 start-->
            <div class="bind xero-unbind clear"
              v-if="isAccountingPlatformActivated && bindXero === false && bindBluesheets === false"
              style="border-bottom: none" @click="connectToAccounting()">
              Link to Accounting Platform
              <i class="el-icon-arrow-right"></i>
              <div class="link-to-btn">Connect to</div>
            </div>
            <div class="bind xero-bind clear" v-if="bindXero === true && bindBluesheets === false"
              style="border-bottom: none" @click="showXeroAsk = true">
              Link to Accounting Platform <i class="el-icon-arrow-right"></i>
              <div class="txt">Connected to {{ xeroName }}</div>
            </div>
            <div class="bind bluesheets-bind clear" v-if="bindXero === false && bindBluesheets === true"
              style="border-bottom: none" @click="showBindBluesheetsAsk = true">
              Link to Accounting Platform <i class="el-icon-arrow-right"></i>
            </div>
            <div class="bind scheduling-bind clear" v-if="!bindDeputy && !bindTanda" @click="openScheduling()">
              Link to Scheduling Platform
              <i class="el-icon-arrow-right"></i>
              <div class="link-to-btn">Connect to</div>
            </div>
            <div class="bind clear" :class="{ 'deputy-bind': bindDeputy, 'tanda-bind': bindTanda }"
              v-if="bindDeputy || bindTanda" @click="unbindScheduling">
              Link to Scheduling Platform
              <i class="el-icon-arrow-right"></i>
            </div>
            <!-- 点击未绑定的doshii 按钮 -->
            <div class="bind clear doshii-unbind" v-if="!bindDoshi && !kseriesBind && !oseriesFlag && !tevalisFlag && !redcatFlag && !idealposCsvFlag && !squareFlag && !imposCsvFlag && !bepozCsvFlag && !oolioFlag && !swiftPosFlag"
              @click="connectToRevenue()">
              Link to Revenue Platform
              <i class="el-icon-arrow-right"></i>
              <div class="link-to-btn">Connect to</div>
            </div>
            <!-- 点击已绑定的doshii 按钮 -->
            <!-- style="border-bottom: none" @click="showDoshiiAsk = true"> Link to Revenue Platform -->

            <div v-else class="bind clear" :class="{'doshii-bind' : bindDoshi, 'kseries-bind' : kseriesBind, 'oseries-bind' : oseriesFlag, 'tevalis-bind' : tevalisFlag,  'redcat-bind': redcatFlag, 'csv-bind': idealposCsvFlag, 'square-bind': squareFlag, 'csv-impos-bind': imposCsvFlag, 'csv-bepoz-bind' : bepozCsvFlag, 'csv-oolio-bind' : oolioFlag, 'swiftpos-bind' : swiftPosFlag}"
              style="border-bottom: none">Link to Revenue Platform
            </div>
            <!-- 第三方的绑定 end-->
            <div class="btns clear d-flex justify-content-center">
              <!-- <button class="dark" v-if="isPro" @click="fristClose">Next Time</button> -->
              <!-- <button class="light" :disabled="fristdisable" :class="{ usable: !fristdisable }"
              @click="fristcontinue">Continue</button> -->
              <!-- <button class="light" :disabled="fristdisable" :class="{ usable: !fristdisable }"
              @click="fristcontinue">Continue</button> -->
              <button class="light" :disabled="fristdisable" :class="{ usable: !fristdisable }"
              @click="pop = false">Close</button>
            </div>
          </div>
          <div class="second-step" v-if="secondbox">
            <h1>To understand your future, we need to understand your past.</h1>
            <h2> Please download the most recent 19 weeks ({{ pastWeek }}) of income history from your Point of Sale and
              upload the .csv file here. </h2>
            <div class="upload-con" v-if="!uploaded">
              <i class="icon" v-if="!uploading"></i>
              <h3 v-if="!uploading"> Drag the file here, or <span>Click to upload</span><br />Only Excel files can be
                uploaded </h3>
              <div class="demo">
                <el-upload v-if="!uploading" class="upload-demo" drag action="" multiple :http-request="excelUpload"
                  :show-file-list="false"> </el-upload>
              </div> <i class="el-icon-loading" v-if="uploading"></i>
            </div>
            <div class="upload-con" v-if="uploaded">
              <div class="file">
                <div class="in"></div>
                <div class="text">
                  <div class="tit">{{ name }}</div>
                  <div class="size">{{ size }}k</div>
                </div>
              </div>
              <div class="close" @click="remove"></div>
            </div>
            <div class="btns clear d-flex justify-content-center">
              <button class="dark" @click="secondback">Back</button>
              <button class="light" :disabled="seconddisable" :class="{ usable: !seconddisable }"
                @click="secondcontinue">
                Continue </button>
            </div>
          </div>
          <div class="third-step" v-if="thirdbox">
            <h1>We need to understand your profit target.</h1>
            <h2> There are a couple of ways to do so. It could either be a dollar amount, or a percentage of revenue.
            </h2>
            <div class="bind clear xero" style="border-bottom: none" @click="thirdcontinue('dollar')"> Dollar Amount <i
                class="el-icon-arrow-right"></i> </div>
            <div class="bind clear deputy" @click="thirdcontinue('percentage')"> A Percentage Of Revenue <i
                class="el-icon-arrow-right"></i> </div>
          </div>
          <div class="fouth-step" v-if="fouthbox" :class="isdollar ? 'xero-wrp' : 'deputy-wrp'">
            <h1 v-if="isdollar">What is that dollar amount?</h1>
            <div class="input-wrp" v-if="isdollar"> <span>$</span> <input type="text" v-model="dollar"
                @input="validate('dollar')" /> </div>
            <h1 v-if="!isdollar"> What is the percentage on revenue you wish to achieve as your profit? </h1>
            <div class="input-wrp" v-if="!isdollar"> <input type="text" v-model="percentage"
                @input="validate('percentage')" /> <span>%</span> </div>
            <div class="btns clear d-flex justify-content-center">
              <button class="dark" @click="fouthback">Back</button>
              <button class="light" :disabled="fouthdisable" :class="{ usable: !fouthdisable }" @click="fouthcontinue">
                Continue </button>
            </div>
          </div>
        </div>
      </transition>


      <el-dialog title="Please select from the below options" :visible.sync="showXeroAsk" :modal-append-to-body="false"
        :show-close="false" class="delsmsDio_box" :close-on-click-modal="false" width="1250px" center>
        <div class="foot_box"> <el-button @click="showXeroAsk = false" class="cardCanBtn"
            style="margin-left: 0">Cancel</el-button> <el-button @click="disXero" class="cardCanBtn">Unlink</el-button>
          <el-button @click="jumpXero" class="cardConBtn">Re-link</el-button>
        </div>
      </el-dialog>

      <el-dialog title="Please select from the below options" :visible.sync="showSchedulingAsk" :modal-append-to-body="false"
        :show-close="false" class="delsmsDio_box" :close-on-click-modal="false" width="1250px" center>
        <div class="foot_box"> <el-button @click="showSchedulingAsk = false" class="cardCanBtn"
            style="margin-left: 0">Cancel</el-button> <el-button @click="disDeputy" v-if="bindDeputy"
            class="cardCanBtn">Unlink</el-button> <el-button @click="jumpDeputy" v-if="bindDeputy"
            class="cardConBtn">Re-link</el-button> <el-button @click="disTanda" v-if="bindTanda"
            class="cardCanBtn">Unlink</el-button><!--这里--> <el-button @click="jumpTanda" v-if="bindTanda"
            class="cardConBtn">Re-link</el-button> </div>
      </el-dialog>

      <el-dialog title="Please select from the below options" :visible.sync="showDoshiiAsk" :modal-append-to-body="false"
        :show-close="false" class="delsmsDio_box" :close-on-click-modal="false" width="1250px" center>
        <div class="foot_box"> <el-button @click="showDoshiiAsk = false" class="cardCanBtn"
            style="margin-left: 0">Cancel</el-button> <el-button @click="disconnectDoshii"
            class="cardCanBtn cardCanBtn2">Unlink</el-button> </div>
      </el-dialog>

      <!-- 弹框-->
      <el-dialog title="" :visible.sync="linkSuccessXero" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio" :close-on-click-modal="false" width="660px" center>
        <div class="success_icon"></div>
        <div class="delMsg-tit">Xero account has been successfully linked!</div> <span slot="footer"
          class="dialog-footer">
          <el-button @click="linkSuccessXero = false" class="cardConBtn" style="margin-left: 0">Confirm</el-button>
        </span>
      </el-dialog>

      <el-dialog title="" :visible.sync="linkSuccessDeputy" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio" :close-on-click-modal="false" width="660px" center>
        <div class="success_icon"></div>
        <div class="delMsg-tit">{{ selectFrom === 'deputy' ? 'Deputy' : 'Tanda' }} account has been successfully linked!
        </div> <span slot="footer" class="dialog-footer"> <el-button @click="waitReload()" class="cardConBtn"
            style="margin-left: 0">Confirm</el-button> </span>
      </el-dialog>

      <!-- 弹框-->
      <el-dialog title="" :visible.sync="linkFailXero" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio" :close-on-click-modal="false" width="660px" center>
        <div class="fail_icon"></div>
        <div class="delMsg-tit">Xero account link failed. Please try again.</div> <span slot="footer"
          class="dialog-footer">
          <el-button @click="linkFailXero = false" class="cardConBtn" style="margin-left: 0">Confirm</el-button> </span>
      </el-dialog>
      <!-- Deputy account link failed. Please try again. modal -->
      <el-dialog title="" :visible.sync="linkFailDeputy" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio" :close-on-click-modal="false" width="660px" center>
        <div class="fail_icon"></div>
        <div class="delMsg-tit"> Deputy account link failed. Please try again. </div> <span slot="footer"
          class="dialog-footer"> <el-button @click="linkFailDeputy = false" class="cardConBtn"
            style="margin-left: 0">Confirm</el-button> </span>
      </el-dialog>

      <!--如果发现实际收入连续两周没有输入，那么用户登录Peiso后将立即弹出导入CSV弹出窗口，提醒用户导入之前19周的收入-->
      <div class="pop-wrp" v-if="longWeek">
        <div class="second-step">
          <h1> You have not used Peiso for a long time, please let us know about your recent. </h1>
          <h2> Please download the most recent 19 weeks ({{ pastWeek }}) of<br />income history from your Point of Sale
            and upload the .csv file here. </h2>
          <div class="upload-con" v-if="!longWeekuploaded"> <i class="icon" v-if="!longWeekuploading"></i>
            <h3 v-if="!longWeekuploading"> Drag the file here, or <span>Click to upload</span><br />Only Excel files can
              be uploaded </h3>
            <div class="demo"> <el-upload v-if="!longWeekuploading" class="upload-demo" drag action="" multiple
                :http-request="longWeekexcelUpload" :show-file-list="false"> </el-upload> </div> <i
              class="el-icon-loading" v-if="longWeekuploading"></i>
          </div>
          <div class="upload-con" v-if="longWeekuploaded">
            <div class="file">
              <div class="in"></div>
              <div class="text">
                <div class="tit">{{ longWeekname }}</div>
                <div class="size">{{ longWeeksize }}k</div>
              </div>
            </div>
            <div class="close" @click="longWeekremove"></div>
          </div>
          <div class="btns clear d-flex justify-content-center"> <button class="dark"
              @click="longWeekcancel">Cancel</button>
            <button class="light" :disabled="longWeekdisable" :class="{ usable: !longWeekdisable }"
              @click="longWeekcontinue">
              Confirm
            </button>
          </div>
        </div>
      </div>

      <transition name="fade" v-if="longWeekshowconfirm">
        <div class="pop-wrp">
          <div class="pop-confirm">
            <h1 style="padding-top: 50px; margin-bottom: 65px; text-align: center"> Data already exists on part of the
              date. Do you want to overwrite it? </h1>
            <div class="triple"> <button @click="longWeekcloseconfirm('cancel')">Cancel</button> <button
                @click="longWeekcloseconfirm('over')"> Overwrite Data </button> <button
                @click="longWeekcloseconfirm('keep')">
                Keep Original Data </button> </div>
          </div>
        </div>
      </transition>

      <!-- <el-dialog title="" :visible.sync="showTerm" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio" :close-on-click-modal="false" width="840px" center>
        <div class="delMsg-tit" style="font-size: 30px; margin-bottom: 50px"> Terms and Conditions<br />Effective 22
          November 2020 </div>
        <Terms /> <span slot="footer" class="dialog-footer"> <el-button @click="agreeTrems" class="cardConBtn"
            style="margin-left: 0">Agree <i class="el-icon-loading" v-if="agreeing"></i> </el-button> </span>
      </el-dialog> -->

      <xero :visibility="xeroVisibility" @close="xeroVisibility = false"></xero>

      <xerobindpop :visibility="xeroHasMore" @close="xeroHasMore = false" :defaultExpanded="defaultExpanded"
        :defaultData="defaultData"></xerobindpop>

      <el-dialog title="" :visible.sync="linkSelDio" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio" :close-on-click-modal="false" width="840px" center>
        <div class="linkDio-tit" style="text-align: left"> Found that this account has multiple physical addresses.
        </div>
        <div class="newMessage"> Please select the roster of the physical address you want to obtain. </div>
        <div class="search-container" style="margin-bottom: 20px">
          <el-input v-model="searchVenue" class="peiso-input-w-prefix font-16" clearable placeholder="Search">
            <template #prefix>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.7292 21.8491L13.8802 15.0002C13.3594 15.4516 12.7521 15.8031 12.0584 16.0548C11.3646 16.3066 10.6264 16.4325 9.84375 16.4325C7.96594 16.4325 6.37669 15.7814 5.07602 14.4793C3.77534 13.1772 3.125 11.6061 3.125 9.76579C3.125 7.92551 3.77604 6.35433 5.07812 5.05225C6.38021 3.75016 7.95573 3.09912 9.80469 3.09912C11.6536 3.09912 13.2248 3.75016 14.5182 5.05225C15.8116 6.35433 16.4583 7.92681 16.4583 9.76969C16.4583 10.5136 16.3368 11.2328 16.0937 11.9272C15.8507 12.6217 15.4861 13.2727 15 13.8804L21.875 20.7033L20.7292 21.8491ZM9.81771 14.87C11.2283 14.87 12.4273 14.3708 13.4147 13.3726C14.4021 12.3743 14.8958 11.172 14.8958 9.76579C14.8958 8.35954 14.4021 7.15728 13.4147 6.15902C12.4273 5.16075 11.2283 4.66162 9.81771 4.66162C8.39266 4.66162 7.18135 5.16075 6.1838 6.15902C5.18627 7.15728 4.6875 8.35954 4.6875 9.76579C4.6875 11.172 5.18627 12.3743 6.1838 13.3726C7.18135 14.3708 8.39266 14.87 9.81771 14.87Z" fill="currentColor"/>
              </svg>
            </template>
          </el-input>
        </div>
        <div class="venuelist-container">
          <div class="newSelect" v-for="(item, i) in newSelLists" :key="i" @click="chooseVenue(item)"> {{
            item.companyName }}
            <i class="el-icon-arrow-right myNewSel_icon"></i>
          </div>
        </div>

        <el-dialog width="840px" :show-close="false" class="delEmployDio" :close-on-click-modal="false"
          :visible.sync="innerSelVisible" append-to-body>
          <div>
            <div class="linkDio-tit" style="text-align: left"> Please select area </div>
            <div class="newMessage" style="margin-bottom: 50px"> Multiple choice </div>

            <div class="area-list-container">
              <div class="box-check1 clear" v-for="(item, index) in checkOptions" @click="item.checked = !item.checked"
                :key="index" :class="{ 'box-checked1': item.checked }"> {{ item.OperationalUnitName }} </div>
            </div>
          </div>
          <span slot="footer" class="new_dioFooter">
            <el-button style="width: 220px" @click=" (innerSelVisible = false), (checkList = []), (venueval = '')" class="cardCanBtn">Back</el-button>
            <el-button style="width: 220px;" @click="confirmBind" class="cardConBtn"> Continue
            </el-button>
          </span>
        </el-dialog>
      </el-dialog>

      <el-dialog title="" :visible.sync="posVisible" :modal-append-to-body="false" :show-close="false" class="posDio"
        :close-on-click-modal="false" width="840px" center>
        <div class="linkDio-tit" style="text-align: left"> Welcome to Peiso, Please select the POS brand you are using.
        </div>
        <div class="subtit"> Some brands support the use of Doshii. Once the Doshii account is linked,<br /> Peiso will
          automatically obtain income data from Doshii every day. </div>
        <div class="pos-list">
          <div :style="{ 'background-position': posList.length > 7 ? '684px 17px' : '704px 17px', }"
            @click="choosePOS(i, item.posId)" class="pos-box clear" v-for="(item, i) in posList" :key="i"
            :class="{ active: item.choose === true, selected: currentSelected === i, }">
            <div class="name">{{ item.posBrand }}</div>
            <div class="tag" v-if="item.posIsSupport === 1">Doshii Available</div>
          </div>
        </div>
        <div class="btn-next"> <button @click="chooseNext"> Next<i class="el-icon-loading" v-if="nexting"></i> </button>
        </div>
      </el-dialog>

      <el-dialog title="" :visible.sync="pinVisible" :modal-append-to-body="false" :show-close="false" class="posDio"
        :close-on-click-modal="false" width="840px" center>
        <div class="linkDio-tit" style="text-align: left">Set your PIN</div>
        <div class="subtit" style="margin-bottom: 30px; width: 110%"> when viewing some more private data, you will be
          asked to enter a PIN for viewing. </div>
        <div class="pin-input-wrp"> <input type="password" v-model="pincodes" maxlength="16"
            @input="pincodes = pincodes.replace(/\s+/g, '')" /> </div>
        <div class="btn-next"> <button @click="pinConfirm"> Confirm<i class="el-icon-loading" v-if="pinseting"></i>
          </button> </div>
      </el-dialog>

      <el-dialog style="z-index: 5" title="" :visible.sync="askIfHaveEmployee" :modal-append-to-body="false"
        :show-close="false" class="posDio z-index-9" :close-on-click-modal="false" width="840px" center>
        <div class="linkDio-tit" style="margin-bottom: 0"> Does your venue have salary employees? </div> <span
          slot="footer" class="dialog-footer"> <el-button class="ignore-btn"
            @click="decide('ignore')">Ignore</el-button>
          <el-button class="addit-btn" @click="decide('jump')">Yes, Add it now</el-button> </span>
      </el-dialog>

      <el-dialog :title="showAccountingSelect ? 'Select the Revenue Platform you want to link to' :
        showSchedulingSelect ? 'Select the Scheduling Platform you want to link to' :
          showRevenueSelect ? 'Select the Revenue Platform you want to link to' : ''"
        :visible="showAccountingSelect || showSchedulingSelect || showRevenueSelect" :modal-append-to-body="false"
        :show-close="false" class="delsmsDio_box title-left" :close-on-click-modal="false" width="840px" center>
        <div class="select-list" v-if="showAccountingSelect">
          <div class="select-item" v-for="(item, index) in accountingList" :key="item.class" v-show="item.isDisplayed"
            :class="{ 'selected-item': item.checked }" @click="selectItem(index, 'accountingList')">
            <div class="logo" :class="item.class"></div>
            {{ item.title }}
          </div>
        </div>
        <div class="foot_box" v-if="showAccountingSelect">
          <el-button @click="showAccountingSelect = false" class="cardCanBtn" style="margin-left: 0">Cancel</el-button>
          <el-button class="cardCanBtn cardCanBtn2" @click="confirmSelect('accountingList')">Confirm</el-button>
        </div>
        <div class="select-list" v-if="showSchedulingSelect">
          <div class="select-item" v-for="(item, index) in schedulingList" :key="item.class" v-show="item.isDisplayed"
            :class="{ 'selected-item': item.checked }" @click="selectItem(index, 'schedulingList')">
            <div class="logo" :class="item.class"></div>
            {{ item.title }}
          </div>
        </div>
        <div class="foot_box" v-if="showSchedulingSelect">
          <el-button @click="showSchedulingSelect = false" class="cardCanBtn" style="margin-left: 0">Cancel</el-button>
          <el-button class="cardCanBtn cardCanBtn2" @click="confirmSelect('schedulingList')">Confirm</el-button>
        </div>
        <div class="select-list" v-if="showRevenueSelect">
          <div class="select-item" v-for="(item, i) in revenueList" :key="item.class" v-show="item.isDisplayed"
            :class="{ 'selected-item': item.checked }" @click="setSelectedRevenue(i)">
            <div class="logo" :class="item.class"></div>
            <h2>{{ item.title }}</h2>
            <p v-html="item.description"></p>
          </div>
        </div>
        <div class="foot_box" v-if="showRevenueSelect">
          <el-button @click="showRevenueSelect = false" class="cardCanBtn" style="margin-left: 0">Cancel</el-button>
          <el-button v-if="!isLoadingRevenuePlatform" class="cardCanBtn cardCanBtn2"
            @click="revenueJumpTo()">Confirm</el-button>
          <el-button v-if="isLoadingRevenuePlatform" class="cardCanBtn cardCanBtn2 cursor-disable"><i
              class="el-icon-loading"></i></el-button>
        </div>
      </el-dialog>
      <!-- Please enter the actual sales, we will subtract the commission to calculate the net revenue. -->
      <el-dialog title="" :visible.sync="enterActualIncomeShow" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio pad-rgt-0" :close-on-click-modal="false" width="1420px" center>
        <TreeTable title="Daily Revenue & Expenses" :weekStart="weekStart" :currentWeek="currentWeek" :list="tableData4"
          :loading="loading2" :hasLabour="hasLabour" text="" @cancel="enterActualIncomeShow = false"
          @confirm="confirmUpdate" :requesting="tableConfirming" :showDeputyCycle="showDeputyCycle" />
      </el-dialog>

      <!-- <div style="display: none;">
        <TreeTable title="Daily Revenue & Expenses" :weekStart="weekStart" :currentWeek="currentWeek" :list="tableData6"
          :loading="loading2" :hasLabour="hasLabour" text="" :initUpdate="true" @confirmInitUpdate="confirmUpdateInit"
          :requesting="tableConfirming" />

        <TreeTable title="Edit Revenue & Expenses" :weekStart="weekStart" :currentWeek="currentWeek"
          :hasLabour="hasLabour" :list="tableData7"
          text="When encountering holidays, you can appropriately modify the forecasted Target Revenue so that Peiso can estimate it for you more reasonably."
          :initUpdate="true" @confirmInitUpdate="confirmUpdateInitTarget" :requesting="tableConfirming" />
      </div> -->

      <el-dialog title="" :visible.sync="editTargetShow" :modal-append-to-body="false" :show-close="false"
        class="delEmployDio pad-rgt-0" :close-on-click-modal="false" width="1420px" center>
        <TreeTable title="Edit Target Revenue Forecast" :weekStart="weekStart" :currentWeek="currentWeek"
          :hasLabour="hasLabour" :list="tableData5" :loading="loadingTarget"
          text=""
          @cancel="editTargetShow = false" @confirm="confirmUpdate" :requesting="tableConfirming" />
      </el-dialog>

      <!-- doshii弹窗 start -->
      <DoshiiAlert :show="doshiiBindedAlert" :list="terminalsList" />
      <!-- doshii弹窗 end -->

      <Bluesheets :showAsk="showBindBluesheetsAsk" :show="openBlueSheets" @closeShow="openBlueSheets = false"
        @closeShowAsk="showBindBluesheetsAsk = false" @done="bindBluesheets = true, blueSheetsFlag = true"
        @unBind="bindBluesheets = false, blueSheetsFlag = false" />
      <!-- NEW CHANGES EOD -->
      <template v-if="isEodSplitActivated">
        <eod v-if="eodData" @eod-change="openEod" :isLoadingEod="isLoadingEod" :show="eodVisibility"
          @closeDialog="closeEod" :info="eodData" :actualRosteredCapture="actualRoster" :weeklyData="weeklyData"
          :targetLabourData="targetLabourData" :actualLabourCost="actualLabourCost" :total="totalSummary"
          :weeklyFullTimeCost="weeklyFullTimeCost" :weeklyDay="weeklyDay" :eodHistory="eodHistory"
          :actual="actualRevenue" :employeeVariance="employeeVariance" @generate-report="generateReport"
          @refresh-eod="refreshOpenEod" :isSaveGenerate="isSaveGenerate" :settings="eodSettings" :calculatedRevenue="calculatedRevenue"></eod>
      </template>
      <template v-else>
        <!-- OLD EOD -->
        <eod-old v-if="eodData" :show="eodVisibility" @closeDialog="closeEod" :info="eodData"
          :actualRosteredCapture="actualRoster" :weeklyData="weeklyData" :targetLabourData="targetLabourData"
          :actualLabourCost="actualLabourCost" :total="totalSummary" :weeklyFullTimeCost="weeklyFullTimeCost"
          :weeklyDay="weeklyDay" :eodHistory="eodHistory" :actual="actualRevenue" :employeeVariance="employeeVariance"
          :isLoadingEod="isLoadingEod" @generate-report="generateReport" @refresh-eod="refreshOpenEod"
          :isSaveGenerate="isSaveGenerate" :settings="eodSettings" :calculatedRevenue="calculatedRevenue"></eod-old>
      </template>

      <el-dialog :visible.sync="isLoadingSaveEod" class="peiso-modal loading-dialog" :show-close="false"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="eod-loading-container">
          <div class="loading-label text-center">
            <span v-if="isLoadingType == 1">Generating and sending email EOD Report</span>
            <span v-if="isLoadingType == 2">Done! EOD successfully send.</span>
          </div>
          <el-progress class="loading-progress pink-progress" :percentage="loadingProgressValue" :stroke-width="15"
            :show-text="false" />
          <div class="loading d-flex justify-content-between">
            <span>Loading</span>
            <span>{{ `${loadingProgressValue}%` }}</span>
          </div>
        </div>
      </el-dialog>

      <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
        :pdf-quality="2" :manual-pagination="true" :paginate-elements-by-height="1400" pdf-format="a4"
        pdf-orientation="portrait" pdf-content-width="710px" :html-to-pdf-options="htmlToPdfOptions"
        @progress="onProgress" @hasStartedGeneration="hasStartedGeneration" @hasGenerated="hasGenerated"
        @hasDownloaded="hasDownloaded" ref="html2Pdf" v-if="eodPayloads">

        <section slot="pdf-content" class="pdf-content">
          <div class="eod-report-main-container" id="eod-report-main-container">
            <div class="eod-container d-flex flex-column gap-20">
              <!-- <el-button type="success" @click="convertToPDF">to PDF</el-button> -->
              <span class="title text-center">END OF THE DAY REPORT</span>

              <div class="top-content-container d-flex gap-5 flex-column">
                <div class="d-flex justify-content-between gap-5">
                  <div class="label">
                    Venue Name:
                    <span class="font-weight-bold">{{ eodPayloads.venueName }}</span>
                  </div>
                  <div class="label">
                    Date Generated:
                    <span class="font-weight-bold">{{ eodPayloads.reportDate }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between gap-5">
                  <div class="label">
                    Manager on Duty:
                    <span class="font-weight-bold">{{ eodPayloads.manager }}</span>
                  </div>
                </div>

                <div class="d-flex justify-content-between gap-5">
                  <div class="label">
                    EOD as of:
                    <span class="font-weight-bold">{{ eodParams.reportDate }}</span>
                  </div>
                </div>
              </div>

              <div class="header-title">
                END OF THE DAY SUMMARY
              </div>

              <div class="summary-container d-flex gap-16">
                <div class="content d-flex flex-column" v-if="eodPayloads.revenue">
                  <div class="d-flex wrapper">
                    <div class="label w-100">
                      Revenue Actual
                    </div>
                    <div class="value text-right w-100">
                      {{ eodPayloads.revenue.actual }}
                    </div>
                  </div>

                  <div v-if="eodPayloads.compValue != ''" class="d-flex wrapper">
                    <div class="label w-100">
                      Comp Value
                    </div>
                    <div class="value text-right w-100">
                      {{ eodPayloads.compValue }}
                    </div>
                  </div>

                  <div class="d-flex wrapper">
                    <div class="label w-100">
                      Target Revenue
                    </div>
                    <div class="value text-right w-100">
                      {{ eodPayloads.revenue.target }}
                    </div>
                  </div>

                  <div class="d-flex wrapper font-weight-bold">
                    <div class="label w-100">
                      Variance
                    </div>
                    <div class="value text-right w-100" :class="eodPayloads.revenue.isGood ? 'green' : 'red'">
                      {{ eodPayloads.revenue.variance }}
                    </div>
                  </div>
                </div>
                <div class="content d-flex flex-column" v-if="eodPayloads.labour">
                  <div class="d-flex wrapper">
                    <div class="label w-100">
                      Labour Actual
                    </div>
                    <div class="value text-right w-100">
                      {{ eodPayloads.labour.actual }}
                    </div>
                  </div>

                  <div class="d-flex wrapper">
                    <div class="label w-100">
                      Labour Target
                    </div>
                    <div class="value text-right w-100">
                      {{ eodPayloads.labour.target }}
                    </div>
                  </div>

                  <div class="d-flex wrapper font-weight-bold">
                    <div class="label w-100">
                      Variance
                    </div>
                    <div class="value text-right w-100" :class="eodPayloads.labour.isGood ? 'green' : 'red'">
                      {{ eodPayloads.labour.variance }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="summary-container d-flex">
                <div class="content d-flex flex-column">
                  <div class="other-label border-all text-center w-100">
                    Labour Cost
                  </div>
                  <div class="other-value border-all no-top text-center font-weight-bold w-100">

                    {{ eodPayloads.labourCost }}
                  </div>
                </div>
                <div class="content d-flex flex-column">
                  <div class="other-label border-all text-center w-100">
                    Food
                  </div>
                  <div class="other-value border-all no-top text-center font-weight-bold w-100">

                    {{ $box.formatMoney5(eodPayloads.food) }}
                  </div>
                </div>
                <div class="content d-flex flex-column">
                  <div class="other-label border-all no-left text-center w-100">
                    Beverage
                  </div>
                  <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">

                    {{ $box.formatMoney5(eodPayloads.beverage) }}
                  </div>
                </div>
                <div class="content d-flex flex-column">
                  <div class="other-label border-all no-left text-center w-100">
                    Cover
                  </div>
                  <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">
                    {{ eodPayloads.cover }}
                  </div>
                </div>
                <div class="content d-flex flex-column">
                  <div class="other-label border-all no-left text-center w-100">
                    SPH
                  </div>
                  <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">
                    {{ eodPayloads.sph }}
                  </div>
                </div>
              </div>

              <template v-if="eodPayloads.periodicData && eodPayloads.periodicData.length">
                <div class="header-title">
                  PERIODIC REPORT HISTORY
                </div>
                <div class="summary-container d-flex gap-16">
                  <div class="content d-flex flex-column">

                    <div class="d-flex wrapper">
                      <div class="label w-100">
                      </div>
                      <div class="value text-center w-100">
                        Actual Revenue
                      </div>
                      <div class="value text-center w-100">
                        Actual Roster
                      </div>
                      <div class="value text-center w-100">
                        Labour Cost (%)
                      </div>
                    </div>
                    <div class="d-flex wrapper" v-for="(item, i) in eodPayloads.periodicData"
                      :key="`periodicData-${i}`">
                      <div class="label w-100">
                        {{ `${item.periodicName} (${item.reportTime})` }}
                      </div>
                      <div class="value text-center w-100">
                        {{ $box.formatMoney5(item.actualRevenue) }}
                      </div>
                      <div class="value text-center w-100">
                        {{ $box.formatMoney5(item.actualRoster) }}
                      </div>
                      <div class="value text-center w-100">
                        {{ item.labourCost }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- <div class="header-title">
                STAFF WORKING WITH VARIANCE
              </div>
              <div class="summary-container d-flex gap-16">
                <div class="content d-flex flex-column">

                  <div class="d-flex wrapper" v-for="(staff, i) in eodPayloads.staffVariance"
                    :key="`staff-variance-${i}`">
                    <div class="label w-100">
                      {{ staff.employee }}
                    </div>
                    <div class="value text-right right red w-100">
                      {{ staff.varianceString }}
                    </div>
                  </div>
                  <div class="d-flex wrapper">
                    <div class="label w-100 font-weight-bold">
                      Total Variance
                    </div>
                    <div class="value text-right right font-weight-bold red w-100">
                      {{ eodPayloads.totalStaffVariance }}
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.manageServiceNote != ''">
                <span class="font-weight-bold">Manager Service Notes:</span>
                <p>
                  {{ eodPayloads.manageServiceNote }}
                </p>
              </div>

              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.bevServiceNote != ''">
                <span class="font-weight-bold">Bev Service Notes:</span>
                <p>

                  {{ eodPayloads.bevServiceNote }}
                </p>
              </div>

              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.venueVibe != ''">
                <span class="font-weight-bold">Venue Vibe / Energy FOH:</span>
                <p>
                  {{ eodPayloads.venueVibe }}
                </p>
              </div>

              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.weatherRecord != ''">
                <span class="font-weight-bold">Weather record:</span>
                <p>
                  {{ eodPayloads.weatherRecord }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.largeParties != ''">
                <span class="font-weight-bold">Large Parties / Events:</span>
                <p>
                  {{ eodPayloads.largeParties }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.vip != ''">
                <span class="font-weight-bold">VIP:</span>
                <p>
                  {{ eodPayloads.vip }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.staff != ''">
                <span class="font-weight-bold">Staff:</span>
                <p>
                  {{ eodPayloads.staff }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.training != ''">
                <span class="font-weight-bold">Training:</span>
                <p>
                  {{ eodPayloads.training }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.compExp != ''">
                <span class="font-weight-bold">Comp Explanations: </span>
                <p>
                  {{ eodPayloads.compExp }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.whs != ''">
                <span class="font-weight-bold">WHS, Employee Incidental, & Safety Notes:</span>
                <p>
                  {{ eodPayloads.whs }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.repairs != ''">
                <span class="font-weight-bold">Repairs & Maint / IT Issues:</span>
                <p>
                  {{ eodPayloads.repairs }}
                </p>
              </div>
              <div class="feedback-container d-flex flex-column gap-10" v-if="eodPayloads.otherFeedback != ''">
                <span class="font-weight-bold">OTHER: any other feedback etc.</span>
                <p>
                  {{ eodPayloads.otherFeedback }}
                </p>
              </div>

            </div>
          </div>
        </section>

      </vue-html2pdf>

      <modal-loading :open="loadingVisibility" @close-modal="loadingVisibility = false" :loadingLabel="loadingLabel"
        :loadingPecentage="loadingPecentage"></modal-loading>
      <modal-business-location :open="businessLocationVisible" :business="businessData" :isDashboardPage="true"
        @close-modal="businessLocationVisible = false"
        @flagged="flaggedToLightSpeed('kseries')"></modal-business-location>

      <modal-sites-location :open="siteLocationVisible" :sites="siteData" @close-modal="siteLocationVisible = false" @oseriesFlagged="flaggedToLightSpeed('oseries')" @redcatFlagged="completeRedcatBinding('redcat')" :isPro="isPro" :integrationType="integrationType"></modal-sites-location>

      <modal-labour-target :open="isOpenLabourTarget" @close-modal="isOpenLabourTarget = false"
        @refresh="getStatus"></modal-labour-target>
      <el-dialog title="" :visible.sync="polling" :modal-append-to-body="false" :show-close='false'
        :close-on-click-modal='false' :lock-scroll="false" class="modalMessageLoading">
        <modal-message-dialog :isLoading="polling" :isDoneLoading="donePolling" :label="messageLabel"
          :subLabel="messageSubLabel" @hide-message="doneLoading()"></modal-message-dialog>
      </el-dialog>

      <cashup-banking :open="cabVisibility" :timeZone="zoneId" @close-modal="closeCap" :currentWeek="eodParams"
        :dailyTrendDay="dailyTrendDay"></cashup-banking>

      <transaction-selection :isManualJournalActivated="isManualJournalActivated" :isDaily="currentChosen"
        :isEosActivated="infoReports.isEosActivated" :currentSelectedDate="currentSelectedDate"
        :open="transactionVisibility" @close-modal="transactionVisibility = false" @open-eod="openEod"
        @open-cashup="openCab" @open-journal="openJournal"
        @show-weekly-report="openWeeklyReport(1, 'Would you like to generate <br> an end of week report?')"
        @show-weekly-cashup="openWeeklyReport(2, 'Would you like to generate <br> Cashup weekly report?')"></transaction-selection>



      <weekly-report :isLabel="weeklyReportLabel" :isType="weeklyReportType" :open="weeklyReportVisibility"
        @close-modal="weeklyReportVisibility = false"></weekly-report>
    </div>

    <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro"
        @close-notice="closeOrLogoutVenue"></free-trial-notice>
    </el-dialog>

    <template v-if="cashUpFormat == cashupOption.FORMAT_BENNELONG">
      <cashup :open="cashupv2" :reportDate="cashupReportDate" @onChangeOpen="cashupv2 = false"></cashup>
    </template>
    <template v-else-if="cashUpFormat == cashupOption.FORMAT_OTTO">
      <cashupOtto :open="cashupv2" :reportDate="cashupReportDate" @onChangeOpen="cashupv2 = false"></cashupOtto>
    </template>
    <template v-else>
      <el-dialog :visible.sync="cashupv2" class="peiso-modal" width="1750px" :show-close="true"
        :close-on-click-modal="false" :close-on-press-escape="true">
        <cash-up-banking-v2 :reportDate="cashupReportDate" :reportDateWithFormat="reportDateWithFormat"
          @open-pin="pinDialogVisibile = true" @open-cashup-setting="openCashupSetting()" :isOpen="cashupv2"></cash-up-banking-v2>
      </el-dialog>

      <el-dialog :visible.sync="cashupSetting" class="peiso-modal" width="1200px" :show-close="true"
      :close-on-click-modal="false" :close-on-press-escape="true" @close="cashupv2 = false">

        <cashup-setting></cashup-setting>
      </el-dialog>
    </template>

    <template>
      <el-dialog :visible.sync="isOpenJournal" class="peiso-modal" width="1750px" :show-close="true"
        :close-on-click-modal="true" :close-on-press-escape="true">
        <journal-manual-entry :isOpen="isOpenJournal" @close-modal="isOpenJournal = false"
          :reportDate="journalReportDate"></journal-manual-entry>
      </el-dialog>
    </template>

    <el-dialog :visible.sync="isOpenTevalisConfiguration" :width="configurationStep == 1 ? '550px' : '1000px'"
      class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false'
      :close-on-press-escape="false">
      <tevalis-configuration @back="showRevenueSelect = true, isOpenTevalisConfiguration = false"
        :loading="isLoadingTevalis" @close="isOpenTevalisConfiguration = false" :configurationStep="configurationStep"
        :categories="categories" :sites="sites" @siteChange="getTevalisCategories" @confirm="connectToTevalis"
        @complete="completeTevalisBinding"></tevalis-configuration>
    </el-dialog>

    <handl-configuration @close-modal="isOpenHandlConfiguration = false" @handl-bind="completeHandlBinding" :open="isOpenHandlConfiguration"></handl-configuration>

    <el-dialog :visible.sync="isOpenRedcatConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<redcat-configuration @back="isOpenRedcatConfiguration = false" @redcat-bind = "redCatSiteSelectio"></redcat-configuration>
		</el-dialog>

    <el-dialog :visible.sync="isOpenSquareConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<square-configuration @back="isOpenSquareConfiguration = false" :isLoadingSquare="isLoadingSquare" :code="squareCode" @square-bind = "completeSquareBinding"></square-configuration>
		</el-dialog>

    <el-dialog :visible.sync="isOpenCsvUploadConfiguration" :title="csvTitle"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<csv-upload-configuration @back="isOpenCsvUploadConfiguration = false" :selectedRevenuePlatform="selectedRevenuePlatform" @csv-bind="csvBinding"></csv-upload-configuration>
		</el-dialog>

    <el-dialog :visible.sync="isOpenSwiftPosConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
      <swift-pos-configuration @back="isOpenSwiftPosConfiguration = false" @swiftpos-bind = "completeSwiftPosBinding"></swift-pos-configuration>
    </el-dialog>

    <el-dialog title="Oolio Configuration" :visible.sync="isOpenOolioConfiguration"  width="550px" class="peiso-modal" :show-close="false" :modal-append-to-body="false" :close-on-click-modal='false' :close-on-press-escape="false">
			<oolio-configuration @back="isOpenOolioConfiguration = false" :isLoading="isLoadingOolio" @oolio-bind="completeOolioBinding" :code="oolioCode"></oolio-configuration>
		</el-dialog>

    <pin-dialog :visible="pinDialogVisibile" :closeEscape="false" @receive="cashupAction" />
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import md5 from "js-md5";
import api from "../../api/dashboard";
import Api from "../../api/api";
import apiXero from '../../api/xero'
import xero from "../common/pop.vue";
import xerobindpop from '../common/xerobindpop.vue';
import terms from "./component/terms.vue";
import treeTable from "./component/treeTable.vue";
import doshiiAlert from "./component/doshiiAlert.vue";
import echart from "./component/echart.vue";
import Chart from "./component/chart.vue";
import revenueChart from "./component/chart/revenueChart.vue";
import labourChart from "./component/chart/labourChart.vue";
// import actualEhart from "./component/actualEhart.vue";
import weeklyLabourTable from "./component/weeklyLabourTable.vue";
import actualWeeklyOperation from "./component/actualWeeklyOperation.vue";

import modalLoading from '../modal/loading.vue';
import modalBusinessLocation from '@/components/modal/businessLocation.vue';
import cashup from '@/components/modal/cashup.vue';
import cashupOtto from '@/components/modal/cashupOtto.vue';
import modalLabourTarget from '@/components/modal/labourTarget.vue';
import transactionSelection from '@/components/modal/transactionSelection.vue';
import confirmWeeklyReport from '@/components/modal/confirmWeeklyReport.vue';
import modalSitesLocation from '../modal/siteRegisters.vue';

import modalMessageDialog from '../modal/messageDialog.vue';
import dayChoice from "./component/dayChoice.vue";
import bluesheets from "../common/bluesheets.vue";
import eod from "../common/eod.vue";
import eodOld from "../common/eodOld.vue";
import cashupBanking from '@/components/common/cashupBanking.vue';
import { mapMutations, mapState } from "vuex";
import axios from "axios";
import Utils from '../../utils/utils';
import dashboardOverview from '@/components/card/dashboard/overview';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
import cashUpBankingV2 from '@/components/modal/cashUpBankingV2';
import pinDialog from '../common/pin'
import journalManualEntry from '@/components/modal/journalManualEntry.vue';
import redcatConfiguration from '@/components/modal/redcatConfiguration.vue';
import tevalisConfiguration from '@/components/modal/tevalisConfiguration.vue';
import cashupSetting from '@/components/modal/cashupSetting.vue';
import CsvUploadConfiguration from '../modal/csvUploadConfiguration.vue';
import SquareConfiguration from '../modal/squareConfiguration.vue';
import handlConfiguration from '../modal/handlConfiguration.vue';
import SwiftPosConfiguration from '../modal/swiftPosConfiguration.vue';
import oolioConfiguration from '../modal/oolioConfiguration.vue';
import { env } from '../../env';
const CancelToken = axios.CancelToken;

export default {
  name: "headcon",
  inject: ["reload", "hidden", "show2"],
  data() {
    return {
      testVenueId: 522,
      cashupOpen: false,
      searchVenue: '',
      isPinNeeded: sessionStorage.getItem('isPinNeeded'),
      pinStatus: sessionStorage.getItem('pinstatus'),
      isSingleAcc: sessionStorage.getItem('isSingleAccount'),
      /* 2023/01/18 新增一个计算过程显示start es按钮 start */
      polling: false,
      donePolling: true,
      calFlag: false,

      messageLabel: 'Retrieving data and calculating profit.',
      messageSubLabel: 'Please wait as this process will take some time to complete.',

      /* 2023/01/18 新增一个计算过程显示start es按钮 end */
      labourHoursGuidance: null,
      revenueGuidance: null,
      showSecondSentance: false,
      revenueMessage: '',
      labourMessage: '',
      // 当前选中的是daily还是weekly
      currentChosen: 0,
      // 传到daily选择日期那里，判断当天的周是什么时候，只有last week / this week能选择天
      weekList: [],
      // Actual Weekly Operation
      tableData1: [],
      labourHourlyRate: [],
      hasLabour: true,
      dailyGGuidancePojo: {},
      getSycLastTime: { sycLastTime: '', enableFlag: '' },
      dailyTrendLoading: false,
      dailyTrendLoadingLabour: false,
      dailyTrendTrendValue: 'revenue',
      dailyTrendChartDatum: {},
      dailyTrendLabourChartDatum: {},
      dailyTrendDay: null,
      current_param: {},
      actualRevenue: 0,
      /* 2022/11/29 doshii弹窗 start */
      doshiiBindedAlert: false,
      terminalsList: [],
      /* 2022/11/29 doshii弹窗 end */
      tableConfirming: false,
      showAccountingSelect: false,
      accountingList: [],
      showSchedulingSelect: false,
      schedulingList: [],
      showRevenueSelect: false,
      revenueList: [],
      /* 2021/9/13 start */
      showDeputyCycle: false,
      showCurrentWeek: null,
      isShowDeputyCycleChecked: false,
      showOrder: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      /* 2021/9/13 end */
      venueId: sessionStorage.getItem("subVenueId"),
      venueType: sessionStorage.getItem("venueType"),
      venueId: sessionStorage.getItem("subVenueId"),
      askIfHaveEmployee: window.sessionStorage.getItem("popUpFullTimeEmployee") === "true" ? true : false,
      labourOrReveue: 1,
      xeroVisibility: false,
      xeroName: "",
      /* 2021/12/30 */
      posVisible: false,
      posList: [],
      currentSelected: null,
      currentSelectedPosid: null,
      nexting: false,
      nextimer: null,
      showDoshii: true,
      pinVisible: false,
      pincodes: "",
      pinExict: null,
      pinseting: false,
      pinTimer: null,
      deputyFlag: false,
      tandaFlag: false,
      doshiiFlag: false,
      csvTitle: '',
      idealposCsvFlag: false,
      oolioFlag: false,
      imposCsvFlag: false,
      bepozCsvFlag: false,
      blueSheetsFlag: false,
      importExcelFlag: false,
      posInfo: null,
      profitTargetFlag: false,
      xeroFlag: false,
      noData: true,
      showDoshiiAsk: false,
      /* 2021/12/30 */
      sourceDayProfitRevenueLabour: CancelToken.source(),
      sourceWeekProfitRevenueLabour: CancelToken.source(),
      sourceDailyTrendApi: CancelToken.source(),
      sourceDailyLabourTrendApi: CancelToken.source(),
      newSelList: [],
      checkOptions: [],
      checkList: [],
      linkSelDio: false,
      innerSelVisible: false,
      venueval: "",
      showTerm: false,
      agreeing: false,
      agreeTimer: null,
      linkSuccessXero: false,
      linkSuccessDeputy: false,
      linkFailXero: false,
      linkFailDeputy: false,
      showXeroAsk: false,
      showSchedulingAsk: false,
      showdot: false,
      querying: false,
      showButton: false,
      showLastWeekEstimateButton: false,
      waitXero: false,
      rosterFeedback: null,
      revenueRoster: null,
      revenueTarget: null,
      targetRoster: null,
      targetHourRoster: null,
      showTargetHourRoster: 1,
      actualRoster: null,
      actualHourRoster: null,
      actualPercentRoster: null,
      targetPercentRoster: null,
      showActualRosterHour: 1,
      weeklyLabourHours: [],
      weeklyLabourCost: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      tableData7: [],
      loading2: true,
      actual: true,
      budgeted: true,
      actuals: true,
      pop: false,
      showfrist: true,
      fristbox: true,
      fristdisable: true, // 默认是true
      bindXero: false,
      bindDeputy: false,
      bindTanda: false,
      bindDoshi: false,
      bindBluesheets: false,
      doshiiClicked: false, // 没绑定doshii的情况下，是否点了绑定
      secondbox: false,
      seconddisable: true, // 默认是true
      uploading: false,
      uploaded: false,
      tempformData: null,
      thirdbox: false,
      fouthbox: false,
      fouthdisable: true, // 默认是true
      isdollar: null,
      dollar: "",
      percentage: "",
      showlst: false,
      showlstType: null,
      dataHght: "",
      loading: false,
      timer: null,
      timer2: null,
      timer3: null,
      timer4: null,
      timer5: null,
      name: null, // 文件名
      size: null, // 文件大小
      url: null, // 文件路径
      lastWeek: "",
      longWeek: false,
      longWeekuploading: false,
      longWeekuploaded: false,
      longWeekname: null, // 文件名
      longWeeksize: null, // 文件大小
      longWeekdisable: true, // 默认是true
      longWeekshowconfirm: false,
      longWeektempFormdata: null,
      longWeektemp: null,
      pastWeek: "",
      thisweek: [],
      nextweek: [],
      currentWeek: [],
      options: [],
      optionsData: [],
      enterActualIncomeShow: false,
      loadingEnterActual: false,
      editTargetShow: false,
      showLabourHourly: true,
      loadingTarget: false,
      fourWeeksAvg: null,
      weekStart: 0,
      originalWeekStart: 0,
      selectFrom: '',
      xeroHasMore: false,
      defaultExpanded: [],
      defaultData: [],
      // 首页几个数据的转圈
      dataLoading: true,
      openBlueSheets: false,
      showBindBluesheetsAsk: false,
      oolioCode: null,
      isOpenOolioConfiguration: false,
      isLoadingOolio: false,

      intervalOfTenMinutes: null,
      intervalOfTowMinutes: null,
      dailyProfitInfo: {},
      isLoadingEod: false,
      employeeVariance: [],
      htmlToPdfOptions: {
        margin: 10,
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        html2canvas: { scale: 2 },
      },
      eodData: {},
      eodSettings: {},
      currentEodParams: {},
      eodVisibility: false,
      eodPayloads: {},
      eodParams: {},
      eodEnable: true,
      eodHistory: {},
      isLoadingSaveEod: false,
      loadingProgressValue: 0,
      isLoadingType: 0,
      isThisWeek: false,
      dayProfitRevenue: {},
      isInitialReload: true,
      webSocket: null,
      wsInput: '',
      kseriesFlag: false,
      kseriesBind: false,
      handlFlag: false,
      bindHandl: false,
      selectedWeek: null,
      isLoadingRevenuePlatform: false,
      loadingVisibility: false,
      loadingLabel: '',
      loadingPecentage: 30,
      businessData: {},
      siteData: [],
      businessLocationVisible: false,
      zoneId: null,
      isPro: false,
      isOpenLabourTarget: false,
      siteLocationVisible: false,
      oseriesFlag: false,
      targetLabourData: null,
      totalSummary: {},
      weeklyFullTimeCost: null,
      weeklyData: null,
      weeklyDay: null,
      weekDay: null,
      actualLabourCost: 0,
      weekDayList: ['', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
      cabVisibility: false,
      isCashUpActivated: false,
      isEodSplitActivated: false,
      transactionVisibility: false,
      isGstAdded: false,
      isSaveGenerate: false,
      isAccountingPlatformActivated: 0,
      infoActualRevenue: {
        title: 'Actual Revenue',
        value: null,
        displayType: 'revenue',
        isActual: true
      },
      infoTargetRevenue: {
        title: 'Target Revenue',
        value: null,
        displayType: 'revenue',
      },
      infoTargetRoster: {
        title: 'Roster',
        value: null,
        displayType: 'roster',
      },
      infoActualRoster: {
        title: 'Predicted Roster',
        value: null,
        displayType: 'roster',
        isActual: true
      },
      infoGuidance: {
        title: 'Daily Guidance',
        revenueGuidance: '',
        revenueWarn: 0,
        labourGuidance: '',
        labourWarn: 1,
        displayType: 'guidance'
      },
      infoReports: {
        isEOD: true,
        isCashUpActivated: false,
        isEosActivated: sessionStorage.getItem('isEosActivated') === 'true' ? true : false,
        displayType: 'reports'
      },

      venueDiscountDetailsPojo: null,
      isTrialEnd: false,
      initUpdateRevenue: false,
      cashupv2: false,
      isManualJournalActivated: false,
      cashupReportDate: '',
      reportDateWithFormat: '',
      weeklyReportVisibility: false,
      currentWeekType: 'THIS WEEK',
      pinDialogVisibile: false,
      isOpenJournal: false,
      journalReportDate: '',
      initUpdateRevenueTarget: false,
      cashUpFormat: 'default',
      cashupOption: {
        FORMAT_BENNELONG: 'bennelong',
        FORMAT_OTTO: 'otto',
        FORMAT_DEFAULT: 'default'
      },
      instance_type: process.env.INSTANCE_TYPE,
      squareFlag: false,
      swiftPosFlag: false,
      squareCode: null,
      isLoadingSquare: false,
      tevalisFlag: false,
      redcatFlag: false,
			isOpenTevalisConfiguration: false,
			isOpenTevalisConfigurationStepTwo: false,
      isOpenRedcatConfiguration: false,
			isLoadingTevalis: false,
			configurationStep: 1,
			categories: [],
			sites: [],
      isENableRerunLabour: process.env.IS_ENABLE_RERUN_LABOUR == '1' ? true : false,
      refreshRosterLoading: false,
      weeklyReportType: null,
      weeklyReportLabel: null,
      cashupSetting: false,
			integrationType: null,
      isGstAdded: false,
      isOpenCsvUploadConfiguration: false,
      isOpenSwiftPosConfiguration: false,
      isOpenSquareConfiguration: false,
      isOpenHandlConfiguration: false,
      manualRevenueSource: null,
      currentSelectedDate: null,
      selectedRevenuePlatform: null,
      calculatedRevenue: 0,
      startDate: null,
      env: env,
      isPastWeek: false,
      isDashboardV2: sessionStorage.getItem('isDashboardV2') === 'true' ? true : false
    };
  },
  props: {
    week: null
  },

  created() {
    this.initializeThirdPartyAPI()
    this.getPastWeek()

    /*Utils.loadingsWithText({
      text: 'Peiso is thinking deeply about your profit...',
      customClass: 'load-with-text'
    });*/

    this.$root.$on('isPro', (isPro, others) => {
      this.isAccountingPlatformActivated = others.isAccountingPlatformActivated
      this.isPro = isPro
      this.isSingleAccount = others.isSingleAccount

      const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
      if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
        this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
        this.isTrialEnd = true
      }

      if (this.importExcelFlag === false) {

        if (!this.doshiiFlag && !this.oseriesFlag && !this.bindHandl && !this.kseriesFlag) {
        } else {
          if (this.pinExict === false && this.isSingleAccount) {
            this.pincodes = "";
            this.pinVisible = true;
          }
        }
      }

    })
    let pin = window.sessionStorage.getItem("pinstatus");
    if (pin !== null) {
      this.pinExict = JSON.parse(window.sessionStorage.getItem("pinstatus"));
      //console.log(this.pinExict);
    }
    // 2021/01/31
    api.posList({
      callback: (res) => {
        if (res.data.code == 0) {
          this.posList = res.data.data;
        } else if (res.data.code == 8902) {
          sessionStorage.clear();
          this.$router.push("/login");
        } else {
          Utils.alert("", res.data.message, "error");
        }
      },
    });
    this.$root.$on('optional-list', (res) => {
      if (res.data.code == 0) {
        this.getDayTimezone(res.data.data.zoneId)
        this.calFlag = res.data.data.calFlag
        if (this.calFlag) {
          this.pollingOperate()
          return
        }
        if (res.data.data.list.length === 0) {
          this.dataLoading = false
        }

        res.data.data.list.forEach((item => {
          if (item.dashBoardId === null)
            item.dashBoardId = item.value
        }))

        if (res.data.data.syncWeekStartWithDeputy) {
          let w = res.data.data.weekStart
          if (w === 2) {
            this.showOrder = ['Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon']
          } else if (w === 3) {
            this.showOrder = ['Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue']
          } else if (w === 4) {
            this.showOrder = ['Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed']
          } else if (w === 5) {
            this.showOrder = ['Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu']
          } else if (w === 6) {
            this.showOrder = ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri']
          } else if (w === 6) {
            this.showOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
          }

        } else {
          this.showOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        }
        this.optionsData = res.data.data

        this.options = res.data.data.list;

        this.isShowDeputyCycleChecked = res.data.data.syncWeekStartWithDeputy;
        this.showDeputyCycle = res.data.data.weekStart !== 1 && res.data.data.syncWeekStartWithDeputy ? true : false;
        this.originalWeekStart = res.data.data.syncWeekStartWithDeputy
        this.weekStart = res.data.data.syncWeekStartWithDeputy ? res.data.data.weekStart : 1
        this.dailyTrendDay = res.data.data.currentWeekIndex ? res.data.data.currentWeekIndex : 1
        let week = "";
        if (res.data.data.weekStart === 1) {
          week = "Monday";
        } else if (res.data.data.weekStart === 2) {
          week = "Tuesday";
        } else if (res.data.data.weekStart === 3) {
          week = "Wednesday";
        } else if (res.data.data.weekStart === 4) {
          week = "Thursday";
        } else if (res.data.data.weekStart === 5) {
          week = "Friday";
        } else if (res.data.data.weekStart === 6) {
          week = "Saturday";
        } else if (res.data.data.weekStart === 7) {
          week = "Sunday";
        }

        this.showCurrentWeek = `
            Synchronize Peiso dashboard to the same cycle as that of deputy, the
            start cycle of each shift in your current deputy is ${this.week}.`;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    })

    if (this.week) {
      this.getWeekData(this.week)
    }

    this.loadDatum();

  },

  methods: {
    onCashupOpen() {
      this.cashupOpen = true;
    },
    sendMessage(msg) {
      if (this.webSocket) {
        this.webSocket.send(msg)
      }
    },
    // 每10分钟的循环
    openIntervalOfTenMinutes() {
      this.intervalOfTenMinutes = setInterval(() => {
        this.typeChangeEvt(this.currentChosen, 'yes', 'onlyFreshDatumNotIncludingChart', this.dailyTrendDay)
      }, 600000)
    },
    clearIntervalOfTenMinutes() {
      clearInterval(this.intervalOfTenMinutes)
    },
    // 每2分钟的循环
    openIntervalOfTowMinutes() {
      this.intervalOfTowMinutes = setInterval(() => {
        this.typeChangeEvt(this.currentChosen, 'yes', 'onlyFreshChartNotIncludingDatum', this.dailyTrendDay)
      }, 120000)
    },
    clearIntervalOfTowMinutes() {
      clearInterval(this.intervalOfTowMinutes)
    },
    getPastWeek() {
      var startTimestamp2
      var endTimestamp2
      // let week = new Date().getDay() === 0 ? 7 : new Date().getDay()
      let week = parseInt(sessionStorage.getItem('currentWeekIndex'))
      let millisecond = 86400000
      let current = new Date().getTime()

      if (week === 1) {
        startTimestamp2 = current - ((7 + 18 * 7) * millisecond)
        endTimestamp2 = current - millisecond
      } else if (week === 2) {
        startTimestamp2 = current - ((8 + 18 * 7) * millisecond)
        endTimestamp2 = current - (2 * millisecond)
      } else if (week === 3) {
        startTimestamp2 = current - ((9 + 18 * 7) * millisecond)
        endTimestamp2 = current - (3 * millisecond)
      } else if (week === 4) {
        startTimestamp2 = current - ((10 + 18 * 7) * millisecond)
        endTimestamp2 = current - (4 * millisecond)
      } else if (week === 5) {
        startTimestamp2 = current - ((11 + 18 * 7) * millisecond)
        endTimestamp2 = current - (5 * millisecond)
      } else if (week === 6) {
        startTimestamp2 = current - ((12 + 18 * 7) * millisecond)
        endTimestamp2 = current - (6 * millisecond)
      } else if (week === 7) {
        startTimestamp2 = current - ((13 + 18 * 7) * millisecond)
        endTimestamp2 = current - (7 * millisecond)
      }
      var start2 = Utils.timeFotmatYMD(startTimestamp2)
      var end2 = Utils.timeFotmatYMD(endTimestamp2)
      this.pastWeek = `${start2} - ${end2}`

    },
    /* 2023/01/18 新增一个计算过程显示start es按钮，点击轮询判断/optionalList 有无this week返回，没有的话就一直转圈，
      过一会继续请求，轮询，直到有数据了，才停止转圈并去刷新页面 start */
    pollingOperate() {
      var that = this
      if (that.polling)

        return
      that.polling = true
      that.loading = true
      that.donePolling = false;
      // Utils.loadings();
      that.pollingApi()
    },

    doneLoading() {
      this.donePolling = true;
      this.loading = false
      this.polling = false
    },
    pollingApi() {
      var that = this
      Api.getTimeList((res) => {
        if (!res || !res.data) return;

        if (res.data.code == 0) {
          this.getDayTimezone(res.data.data.zoneId)
          let calFlag = res.data.data.calFlag
          if (calFlag)
            setTimeout(() => {
              that.pollingApi()
            }, 3000)
          else {
            that.polling = false
            that.donePolling = true;
            // Utils.loadings(2);
            that.reload()
          }
        } else if (res.data.code == 8902) {
          sessionStorage.clear();
          this.$router.push("/login");
        } else {
          Utils.alert("", res.data.message, "error");
        }
      });
    },
    /* 2023/01/18 新增一个计算过程显示start es按钮，点击轮询判断/optionalList 有无this week返回，没有的话就一直转圈，
      过一会继续请求，轮询，直到有数据了，才停止转圈并去刷新页面 end */
    waitReload() {
      this.linkSuccessDeputy = false
      setTimeout(() => {
        this.reload()
      }, 2000)
    },

    confirmUpdateInitTarget(params) {
      api.updateActualIncome({
        params: params,
        callback: (res) => {
        },
      });
    },

    confirmUpdateInit(params) {
      if (this.tableConfirming)
        return
      api.updateActualIncome({
        params: params,
        callback: (res) => {
        },
      });
    },
    confirmUpdate(params) {
      if (this.tableConfirming)
        return
      this.tableConfirming = true
      api.updateActualIncome({
        params: params,
        callback: this.updateCallback,
      });
    },
    updateCallback(res) {
      this.tableConfirming = false
      if (!res || !res.data) return;
      var that = this;
      that.enterActualIncomeShow = false;
      that.loadingEnterActual = false;
      that.loadingTarget = false
      if (res.data.code == 0) {
        this.enterActualIncomeShow = false
        this.editTargetShow = false
        this.show2();
        this.closeDashboard();
        this.reload2(this.dailyTrendDay);
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    openScheduling() {
      var that = this
      // that.schedulingList.forEach((e, i) => {
      //   e.checked = false
      // })
      that.showSchedulingSelect = true
      if (!this.schedulingList.length) {
        this.schedulingList = [
          {
            title: 'Deputy',
            class: 'deputy',
            checked: true,
            isDisplayed: true,
          },
          {
            title: 'Tanda',
            class: 'tanda',
            checked: false,
            // isDisplayed: this.isPro ? true : false,
            isDisplayed: true,
          }
        ]
      }
    },
    connectToAccounting() {
      this.showAccountingSelect = true
      if (!this.accountingList.length) {
        this.accountingList = [
          {
            title: 'Xero',
            class: 'xero',
            checked: true,
            isDisplayed: this.isPro ? true : false,
          },
          {
            title: 'Bluesheets',
            class: 'bluesheets',
            checked: false,
            isDisplayed: this.isPro ? true : false,
          }
        ]
      }
    },


    selectItem(index, type) {
      var that = this
      if (type === 'schedulingList') {
        that.schedulingList.forEach((e, i) => {
          e.checked = index === i ? true : false
        })
      } else if (type === 'accountingList') {
        that.accountingList.forEach((e, i) => {
          e.checked = index === i ? true : false
        })
      }
    },
    confirmSelect(type) {
      var that = this
      if (type === 'schedulingList') {
        let current = that.schedulingList.find(e => {
          return e.checked
        })
        if (!current) {
          Utils.alert("", 'Please choose one', "error");
          return
        }
        that.showSchedulingSelect = false
        if (current.title === 'Deputy')
          that.jumpDeputy()
        else
          that.jumpTanda()
      } else if (type === 'accountingList') {
        let current = that.accountingList.find(e => {
          return e.checked
        })
        if (!current) {
          Utils.alert("", 'Please choose one', "error");
          return
        }
        that.showAccountingSelect = false
        if (current.title === 'Xero')
          that.jumpXero()
        else if (current.title === 'Bluesheets') {
          this.openBlueSheets = true
        }

      }
    },
    unbindScheduling() {
      // 判断一下是解绑哪一个
      this.showSchedulingAsk = true
    },
    decide(type) {
      var that = this;
      window.sessionStorage.removeItem("popUpFullTimeEmployee");
      if (type === "ignore") {
        that.askIfHaveEmployee = false;
        setTimeout(() => {
          that.reload()
        }, 2000)
      } else {
        that.$router.push("/rosterAndemployee");
      }
    },
    /* 2021/12/30 */
    chooseNext() {
      var that = this;
      if (that.nexting) return;
      if (this.currentSelected === null) {
        // 202231
        that.posVisible = false;
        that.currentSelected = null;
        that.currentSelectedPosid = null;
        that.showDoshii = true;
        if (
          that.importExcelFlag === true && that.profitTargetFlag === true && that.pinExict === false
        ) {
          this.pincodes = "";
          this.pinVisible = true;
        }
        api.skipStep({
          params: 1,
          callback: (res) => {
            if (res.data.code != 0) Utils.alert("", res.data.message, "error");
          },
        });
        return;
      }
      that.nexting = true;
      that.nextimer = setTimeout(() => {
        that.nexting = false;
      }, 60000);
      api.posUpdate({
        params: {
          posId: that.currentSelectedPosid,
        },
        callback: (res) => {
          that.nexting = false;
          if (res.data.code == 0) {
            that.posVisible = false;
            that.currentSelected = null;
            that.currentSelectedPosid = null;
            // 如果选择的POS不支持Doshii，那么将还是按照最初的流程，手动上传19周收入
            if (!item.doshii) {
              that.showDoshii = false;
            }
            // 如果选择的POS支持Doshii，会提示进入Doshii管理后台发起连接请求。
            else if (item.doshii) {
              that.showDoshii = true;
            }
            if (
              that.importExcelFlag === true &&
              that.profitTargetFlag === true &&
              that.pinExict === false
            ) {
              this.pincodes = "";
              this.pinVisible = true;
            }
          } else {
            Utils.alert("", res.data.message, "error");
          }
        },
      });
    },
    choosePOS(i, id) {
      this.currentSelected = i;
      this.currentSelectedPosid = id;
    },
    jumpDoshii() {
      window.open("https://dashboard.doshii.io/venues");

      this.doshiiClicked = true;
      api.clickBindDoshii({
        callback: (res) => {
          if (res.data.code !== 0) {
            Utils.alert("", res.data.message, "error");
          }
        },
      });
    },
    disconnectDoshii() {
      var that = this;
      Utils.loadings();
      api.unsubscribed({
        callback: (res) => {
          Utils.loadings(2);
          if (res.data.code === 0) {
            that.showDoshiiAsk = false;
            that.bindDoshi = false;

            window.sessionStorage.setItem("doshiiLinked", "0");
          } else if (res.data.code == 8902) {
            sessionStorage.clear();
            that.$router.push("/login");
          } else {
            Utils.alert("", res.data.message, "error");
          }
        },
      });
    },
    pinConfirm() {
      var that = this;
      if (that.pinseting) return;
      if (that.pincodes.length < 4) {
        Utils.alert("", "Please enter 4-16 digits", "error");
        return;
      }
      that.pinseting = true;
      that.pinTimer = setTimeout(() => {
        that.pinseting = false;
      }, 60000);
      api.pinAdd({
        params: that.pincodes,
        callback: (res) => {
          clearTimeout(that.pinTimer);
          that.pinseting = false;
          if (res.data.code === 0) {
            that.pinVisible = false;
            window.sessionStorage.setItem("pinstatus", true);
            window.sessionStorage.setItem("pin", md5(that.pincodes));
            that.pinExict = true;
            that.askIfHaveEmployee = true;
            // this.reload()
          } else if (res.data.code == 8902) {
            sessionStorage.clear();
            that.$router.push("/login");
          } else {
            Utils.alert("", res.data.message, "error");
          }
        },
      });
    },
    /* 2021/12/30 */
    async loadDatum(current) {
      if (current) {
        api.dot({
          params: {
            monDateTime: current.monDateTime,
            sunDateTime: current.sunDateTime
          },
          callback: this.dotCallback
        });
      }
      else {
        api.progress({ callback: this.proCallback });
        // 获取提示语接口，判断实际收入连续两周没有输入，那么用户登录Peiso后将立即弹出导入CSV弹出窗口
      }
    },
    agreeTrems() {
      if (this.agreeing) return;
      this.agreeing = true;
      this.agreeTimer = setTimeout(() => {
        this.agreeing = false;
      }, 60000);
      api.termsAndConditions({
        callback: (res) => {
          clearTimeout(this.agreeTimer);
          this.agreeing = false;
          if (res.data.code === 0) {
            this.showTerm = false;
          } else if (res.data.code == 8902) {
            sessionStorage.clear();
            this.$router.push("/login");
          } else {
            Utils.alert("", res.data.message, "error");
          }
        },
      });
    },
    reload2(day) {
      this.typeChangeEvt(this.currentChosen, 'yes', null, day)
      // 首页数据
      /*if (this.options.length > 0) {
        this.requestDatum(this.options, this.week);
      } else {
        Api.getTimeList((res) => {
          if (!res || !res.data) return;
          if (res.data.code == 0) {
            res.data.data.list.forEach((item => {
              if (item.dashBoardId === null)
                item.dashBoardId = item.value
            }))
            this.requestDatum(res.data.data.list, this.week);
          } else if (res.data.code == 8902) {
            sessionStorage.clear();
            this.$router.push("/login");
          } else {
            Utils.alert("", res.data.message, "error");
          }
        });
      }*/
    },
    ...mapMutations(["closeDashboard"]),

    dotCallback(res) {
      if (res.data.code === 0) {
        if (res.data.data === true) this.showdot = true;
        else this.showdot = false;
      }
    },
    queryTemporary(from) {
      if (this.querying)
        return
      Utils.loadings();
      this.querying = true;
      if (from === 'lastweek') {
        api.queryTemporaryLastWeek({ callback: this.queryCallbackLastWeek });
        return
      }
      api.queryTemporary({ callback: this.queryCallback });
    },
    queryCallbackLastWeek(res) {
      var that = this;
      Utils.loadings(2);
      that.querying = false;
      if (res.data.code === 0) {
        that.showLastWeekEstimateButton = false;
        this.reload();
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    queryCallback(res) {
      var that = this;
      Utils.loadings(2);
      that.querying = false;
      if (res.data.code === 0) {
        that.showButton = false;
        this.reload();
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    fristClose() {
      // 需要在这里判断有没有上传
      this.showfrist = false;
      if (this.importExcelFlag === false) this.secondbox = true;
      else this.pop = false;
      api.skipStep({
        params: 2,
        callback: (res) => {
          if (res.data.code != 0) Utils.alert("", res.data.message, "error");
        },
      });
    },
    fristcontinue() {
      // 需要在这里判断有没有上传
      this.showfrist = false;
      if (!this.importExcelFlag && !this.kseriesBind && !this.oseriesFlag && !this.handlFlag && !this.tevalisFlag && !this.redcatFlag && !this.idealposCsvFlag && !this.squareFlag && !this.imposCsvFlag && !this.bepozCsvFlag && !this.swiftPosFlag) {
        // 在这里判断，如果doshii绑定了，直接去第二步
        if (this.bindDoshi) {
          this.secondbox = true;
        } else {
          // 如果没绑定doshii，是否点击过doshii，如果点击过了，就去第三步
          // 这种情况就不能再去调用上传文件接口了，在第四步的保存直接调用api.save
          if (this.doshiiClicked) {
            this.thirdbox = true;
          } else {
            // 没点击过依然去第二步
            this.secondbox = true;
          }
        }
      } else {
        this.pop = false;
        if (this.kseriesBind || this.oseriesFlag || this.handlFlag || this.tevalisFlag || this.redcatFlag || this.idealposCsvFlag || this.squareFlag || this.imposCsvFlag || this.bepozCsvFlag || this.swiftPosFlag) {
          location.reload()
        }
      }
    },
    secondback() {
      this.showfrist = true;
      this.secondbox = false;
    },
    secondcontinue() {
      this.secondbox = false;
      this.thirdbox = true;
    },
    thirdcontinue(type) {
      this.thirdbox = false;
      this.fouthbox = true;
      if (type == "dollar") {
        this.isdollar = true;
        if (this.dollar === "") {
          this.fouthdisable = true;
        }
      } else {
        this.isdollar = false;
        if (this.percentage === "") {
          this.fouthdisable = true;
        }
      }
    },
    fouthback() {
      this.thirdbox = true;
      this.fouthbox = false;
      this.isdollar = null;
    },
    // 最后传预期值
    fouthcontinue() {
      var that = this;
      // that.uploading = true
      // 如果跳过了上传文件，直接调用api.save
      if (this.doshiiClicked) {
        if (this.isdollar === true) {
          api.save({
            params: {
              profitTarget: parseInt(this.dollar),
              profitTargetType: 0,
              type: 0,
            },
            callback: this.saveCallback,
          });
        } else {
          api.save({
            params: {
              profitTarget: parseFloat(this.percentage) / 100,
              profitTargetType: 1,
              type: 0,
            },
            callback: this.saveCallback,
          });
        }
        if (that.pinExict === false && that.venueType === "2") {
          that.pincodes = "";
          that.pinVisible = true;
        }
      } else {
        if (!this.importExcelFlag) {
          Utils.loadings();
          api.upload({
            params: this.tempformData,
            type: 0,
            callback: this.uploadCallback,
          });
        }
        else {
          if (this.isdollar === true) {
            api.save({
              params: {
                profitTarget: parseInt(this.dollar),
                profitTargetType: 0,
                type: 0,
              },
              callback: this.saveCallback,
            });
          } else {
            api.save({
              params: {
                profitTarget: parseFloat(this.percentage) / 100,
                profitTargetType: 1,
                type: 0,
              },
              callback: this.saveCallback,
            });
          }
          // 2021/12/30
          // 如果pin值不存在
          if (that.pinExict === false && that.venueType === "2") {
            that.pincodes = "";
            that.pinVisible = true;
          }
        }
      }
    },
    saveCallback(res) {
      if (res.data.code === 0) {
        this.pop = false;
        setTimout(() => {
          this.reload()
          Utils.loadings(2);
        }, 2000)
      } else if (res.data.code == 8902) {
        Utils.loadings(2);
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.loadings(2);
        Utils.alert("", res.data.message, "error");
      }
    },
    enterActualIncome() {
      /*if (type === 0 && this.showButton === true)
        return*/
      let _params = {
        incomeType: 0,
      };
      let current = "";
      this.options.forEach((i) => {
        if (i.dashBoardId === this.week || i.value === this.week) {
          _params.monDateTime = i.monDateTime;
          _params.sunDateTime = i.sunDateTime;
          current = i.value;
        }
      });
      if (current === "" && this.week === -1) {
        current = "THIS WEEK";
      }
      if (current === "" && this.week === -2) {
        current = "LAST WEEK";
      }
      if (current === "" && this.week === -3) {
        current = "NEXT WEEK";
      }

      // if (current !== "THIS WEEK" && current !== "LAST WEEK") return;
      if (current == "NEXT WEEK") return;
      if (!_params.monDateTime) {
        this.enterActualIncomeShow = true;
        this.tableData4 = [];
        this.noData = true;
        this.loading2 = false;
        return;
      } else {
        this.noData = false;
      }
      this.enterActualIncomeShow = true;
      this.tableData4 = [];
      this.loading2 = true;
      api.getActualIncome({
        params: _params,
        callback: this.actualIncomeCallback,
      });
      //this.hidden();
    },

    initUpdateWeeklyRevenue() {
      let _params = {
        incomeType: 0,
      };
      let current = ''
      this.options.forEach((i) => {
        if (i.dashBoardId === this.week) {
          _params.monDateTime = i.monDateTime;
          _params.sunDateTime = i.sunDateTime;
          current = i.value;
        }
      });

      if (current && current == 'LAST WEEK') {
        this.initUpdateRevenue = true;
        this.tableData6 = [];
        api.getActualIncome({
          params: _params,
          callback: this.updateWeekActualRevenue,
        });
      } else {

      }
    },
    updateWeekActualRevenue(res) {
      const actualIncome = res.data.data.list
      let actualIncomePayload = []

      // get all actual income data
      actualIncome.forEach(item => {
        item.actualIncomeList.forEach(list => {
          actualIncomePayload.push(list)
        })
      })

      // run enterActualIncome endpoint to change the value displayed in dashboard
      this.confirmUpdateInitTarget(actualIncomePayload)
    },
    initUpdateTargetRevenue() {
      let _params = {
        incomeType: 1,
      };
      let current = "";

      this.options.forEach((i) => {
        if (i.dashBoardId === this.week || i.value === this.week) {
          _params.monDateTime = i.monDateTime;
          _params.sunDateTime = i.sunDateTime;
          current = i.value;
        }
      });

      if (!_params.monDateTime) return;

      if (current === "LAST WEEK") return;

      this.initUpdateRevenueTarget = true;
      this.tableData7 = [];
      api.getActualIncome({
        params: _params,
        callback: this.targetIncomeCallback,
      });
    },

    actualUpdateCallback(res) {
      var that = this;
      this.loadingEnterActual = false;
      if (res.data.code == 0) {
        this.enterActualIncomeShow = false;
        this.show2();
        this.closeDashboard();
        this.reload2(this.dailyTrendDay);
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    actualIncomeCallback(res) {

      var that = this;
      that.loading2 = false;
      that.hasLabour = false
      if (res.data.code == 0) {
        let data = res.data.data
        var overall = {
          mon: Utils.checkValueExists(data.total.mon),
          tue: Utils.checkValueExists(data.total.tue),
          wed: Utils.checkValueExists(data.total.wed),
          thu: Utils.checkValueExists(data.total.thu),
          fri: Utils.checkValueExists(data.total.fri),
          sat: Utils.checkValueExists(data.total.sat),
          sun: Utils.checkValueExists(data.total.sun),
        }
        var overallList = Object.values(overall)
        var totalOverAll = overallList.reduce((a, b) => {
          return a + b
        }, 0)
        let tableDatum = [{ left: 'Total', mon: overall.mon, tues: overall.tue, wed: overall.wed, thu: overall.thu, fri: overall.fri, sat: overall.sat, sun: overall.sun, shrink: false, color: 'green', son: [], total: totalOverAll }]
        // if (data.list && data.list[0]) {
        if (data.list.length) {
          data.list.forEach((item) => {
            let temp = []
            let checkIncomeNameExist = {};
            // if (item.actualIncomeList && item.actualIncomeList[0]) {
            if (item.actualIncomeList.length) {
              item.actualIncomeList.forEach(i => {

                var total = {
                  mon: Utils.checkValueExists(i.mon),
                  tue: Utils.checkValueExists(i.tue),
                  wed: Utils.checkValueExists(i.wed),
                  thu: Utils.checkValueExists(i.thu),
                  fri: Utils.checkValueExists(i.fri),
                  sat: Utils.checkValueExists(i.sat),
                  sun: Utils.checkValueExists(i.sun),
                }

                let totalIncome = Utils.checkValue(i.mon) + Utils.checkValue(i.tue) + Utils.checkValue(i.wed) + Utils.checkValue(i.thu) + Utils.checkValue(i.fri) + Utils.checkValue(i.sat) + Utils.checkValue(i.sun)

                if (i.incomeName == 'KSeries Revenue' && this.isThisWeek) {
                  let dayNumber = Utils.dateTimeGeneratorWithDay(new Date(), this.zoneId)
                  dayNumber = new Date(dayNumber).getDay()
                  dayNumber = dayNumber ? dayNumber : 7
                  let getDay = this.weekDayList[dayNumber]
                  total[getDay] = sessionStorage.getItem('revenueToday')

                }
                if (!checkIncomeNameExist[i.incomeName]) {
                  const incomeName = i.incomeName.split(' ');

                  if (i.incomeName && (incomeName[1] && incomeName[1] == 'Revenue') || i.incomeName == 'O Series') {
                    temp.unshift({ shrink: false, parentRevenue: i.parentRevenue ? i.parentRevenue : null, left: i.incomeName, mon: total.mon, tues: total.tue, wed: total.wed, thu: total.thu, fri: total.fri, sat: total.sat, sun: total.sun, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, withDollar: item.expensesType !== 3 ? true : false, color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''), monDateTime: i.monDateTime, sunDateTime: i.sunDateTime, revenueType: i.revenueType, incomeType: i.incomeType, id: i.id, incomeId: i.incomeId, expensesType: item.expensesType, incomeCommission: i.incomeCommission, ofDoshii: i.revenueFrom === 0 ? false : true, total: totalIncome ? totalIncome : null, revenueFrom: i.revenueFrom })
                  } else {
                    if ((this.kseriesBind || this.oseriesFlag || this.bindHandl) && i.incomeName !== 'Revenue') {
                      temp.push({ shrink: false, parentRevenue: i.parentRevenue ? i.parentRevenue : null, left: i.incomeName, mon: total.mon, tues: total.tue, wed: total.wed, thu: total.thu, fri: total.fri, sat: total.sat, sun: total.sun, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, withDollar: item.expensesType !== 3 ? true : false, color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''), monDateTime: i.monDateTime, sunDateTime: i.sunDateTime, revenueType: i.revenueType, incomeType: i.incomeType, id: i.id, incomeId: i.incomeId, expensesType: item.expensesType, incomeCommission: i.incomeCommission, ofDoshii: i.revenueFrom === 0 ? false : true, total: totalIncome ? totalIncome : null, revenueFrom: i.revenueFrom })
                    } else if (!this.kseriesBind && !this.oseriesFlag && !this.bindHandl) {
                      temp.push({ shrink: false, parentRevenue: i.parentRevenue ? i.parentRevenue : null, left: i.incomeName, mon: total.mon, tues: total.tue, wed: total.wed, thu: total.thu, fri: total.fri, sat: total.sat, sun: total.sun, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, withDollar: item.expensesType !== 3 ? true : false, color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''), monDateTime: i.monDateTime, sunDateTime: i.sunDateTime, revenueType: i.revenueType, incomeType: i.incomeType, id: i.id, incomeId: i.incomeId, expensesType: item.expensesType, incomeCommission: i.incomeCommission, ofDoshii: i.revenueFrom === 0 ? false : true, total: totalIncome ? totalIncome : null, revenueFrom: i.revenueFrom })
                    }
                  }

                  checkIncomeNameExist[i.incomeName] = true;
                }




              })
            }
            // if (item.expensesType === 4) {
            //   that.hasLabour = true
            //   var totalLabour = temp[0].mon + temp[0].tue + temp[0].wed + temp[0].thu + temp[0].fri + temp[0].sat + temp[0].sun
            //   tableDatum[0].son.push({ left: 'Labour', mon: temp[0].mon, tues: temp[0].tues, wed: temp[0].wed, thu: temp[0].thu, fri: temp[0].fri, sat: temp[0].sat, sun: temp[0].sun, shrink: false, color: 'white', son: [], hideArrow: false, monDateTime: temp[0].monDateTime, sunDateTime: temp[0].sunDateTime, revenueType: temp[0].revenueType, incomeType: temp[0].incomeType, id: temp[0].id, incomeId: temp[0].incomeId, expensesType: item.expensesType, incomeCommission: temp[0].incomeCommission, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, ofDoshii: temp[0].ofDoshii, total: totalLabour })
            // }

            var totalExpenses = temp.reduce((total, value) => {
              return total + value.total
            }, 0)

            temp = temp.sort((a, b) => b.revenueFrom - a.revenueFrom);

            tableDatum[0].son.push({ left: item.expensesType === 1 ? 'Revenue' : (item.expensesType === 2 ? 'Delivery' : (item.expensesType === 3 ? 'Expenses' : (item.expensesType === 4 ? 'Labour' : ''))), mon: item.total.mon, tues: item.total.tue, wed: item.total.wed, thu: item.total.thu, fri: item.total.fri, sat: item.total.sat, sun: item.total.sun, shrink: false, color: item.expensesType !== 3 ? 'green' : 'pink', son: temp, expensesType: item.expensesType, total: totalExpenses })

          })

          that.tableData4 = tableDatum
          that.initUpdateRevenue = false;

        }
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },

    editTarget() {
      let _params = {
        incomeType: 1,
      };
      let current = "";
      this.options.forEach((i) => {
        if (i.dashBoardId === this.week || i.value === this.week) {
          _params.monDateTime = i.monDateTime;
          _params.sunDateTime = i.sunDateTime;
          current = i.value;
        }
      });

      if (!_params.monDateTime) {
        Utils.alert2('', 'Something went wrong, please contact administrator.', 'error');
        return;
      };

      if (current === "LAST WEEK") {
        Utils.alert2('', "Your can't edit last week target revenue data.", 'error');
        return;
      };

      this.editTargetShow = true;
      this.loadingTarget = true;
      this.tableData5 = [];
      api.getActualIncome({
        params: _params,
        callback: this.targetIncomeCallback,
      });
      //this.hidden();
    },
    targetIncomeCallback(res) {
      var that = this;
      that.loadingTarget = false
      that.hasLabour = false

      if (res.data.code == 0) {
        let data = res.data.data

        var totalOverAll = data.total.mon + data.total.tue + data.total.wed + data.total.thu + data.total.fri + data.total.sat + data.total.sun
        var foreCastSum = data.forecastRevenue.mon + data.forecastRevenue.tue + data.forecastRevenue.wed + data.forecastRevenue.thu + data.forecastRevenue.fri + data.forecastRevenue.sat + data.forecastRevenue.sun

        data.total.mon = Utils.checkValueExists(data.total.mon)
        data.total.tue = Utils.checkValueExists(data.total.tue)
        data.total.wed = Utils.checkValueExists(data.total.wed)
        data.total.thu = Utils.checkValueExists(data.total.thu)
        data.total.fri = Utils.checkValueExists(data.total.fri)
        data.total.sat = Utils.checkValueExists(data.total.sat)
        data.total.sun = Utils.checkValueExists(data.total.sun)

        // 11.15
        let tableDatum = [
          { left: 'Forecast Revenue', mon: data.forecastRevenue.mon, tues: data.forecastRevenue.tue, wed: data.forecastRevenue.wed, thu: data.forecastRevenue.thu, fri: data.forecastRevenue.fri, sat: data.forecastRevenue.sat, sun: data.forecastRevenue.sun, shrink: false, color: '', total: foreCastSum },

          { left: 'Total', mon: data.total.mon, tues: data.total.tue, wed: data.total.wed, thu: data.total.thu, fri: data.total.fri, sat: data.total.sat, sun: data.total.sun, shrink: false, color: 'green', son: [], total: totalOverAll }
        ]

        if (data.list && data.list[0]) {
          data.list.forEach((item) => {
            let temp = []
            if (item.actualIncomeList && item.actualIncomeList[0]) {

              item.actualIncomeList.forEach(i => {
                 const total = Utils.checkValue(i.mon) + Utils.checkValue(i.tue) + Utils.checkValue(i.wed) + Utils.checkValue(i.thu) + Utils.checkValue(i.fri) + Utils.checkValue(i.sat) + Utils.checkValue(i.sun);
                i.mon = Utils.checkValueExists(i.mon)
                i.tue = Utils.checkValueExists(i.tue)
                i.wed = Utils.checkValueExists(i.wed)
                i.thu = Utils.checkValueExists(i.thu)
                i.fri = Utils.checkValueExists(i.fri)
                i.sat = Utils.checkValueExists(i.sat)
                i.sun = Utils.checkValueExists(i.sun)
                let totalIncome = total
                temp.push({ left: i.incomeName, mon: i.mon, tues: i.tue, wed: i.wed, thu: i.thu, fri: i.fri, sat: i.sat, sun: i.sun, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, withDollar: item.expensesType !== 3 ? true : false, color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''), monDateTime: i.monDateTime, sunDateTime: i.sunDateTime, revenueType: i.revenueType, incomeType: i.incomeType, id: i.id, incomeId: i.incomeId, expensesType: item.expensesType, incomeCommission: i.incomeCommission, ofDoshii: i.revenueFrom === 0 ? false : true, total: totalIncome })
              })
            }
            // if (item.expensesType === 4) {
            //   that.hasLabour = true
            //   var totalLabour = temp[0].mon + temp[0].tue + temp[0].wed + temp[0].thu + temp[0].fri + temp[0].sat + temp[0].sun
            //   tableDatum[1].son.push({ left: 'Labour', mon: temp[0].mon, tues: temp[0].tues, wed: temp[0].wed, thu: temp[0].thu, fri: temp[0].fri, sat: temp[0].sat, sun: temp[0].sun, shrink: false, color: 'white', son: [], hideArrow: true, monDateTime: temp[0].monDateTime, sunDateTime: temp[0].sunDateTime, revenueType: temp[0].revenueType, incomeType: temp[0].incomeType, id: temp[0].id, incomeId: temp[0].incomeId, expensesType: item.expensesType, incomeCommission: temp[0].incomeCommission, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, ofDoshii: temp[0].ofDoshii, total: totalLabour })
            // }
            var totalExpenses = temp.reduce((total, value) => {
              return total + value.total
            }, 0)

            tableDatum[1].son.push({ left: item.expensesType === 1 ? 'Revenue' : (item.expensesType === 2 ? 'Delivery' : (item.expensesType === 3 ? 'Expenses' : (item.expensesType === 4 ? 'Labour' : ''))), mon: item.total.mon, tues: item.total.tue, wed: item.total.wed, thu: item.total.thu, fri: item.total.fri, sat: item.total.sat, sun: item.total.sun, shrink: false, color: item.expensesType !== 3 ? 'green' : 'pink', son: temp, expensesType: item.expensesType, total: totalExpenses })
          })

          if (this.initUpdateRevenueTarget) {
            that.tableData7 = tableDatum
            this.initUpdateRevenueTarget = false;
          } else {
            that.tableData5 = tableDatum
          }


        }
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    targetUpdateCallback(res) {
      this.loadingTarget = false;
      if (res.data.code == 0) {
        this.editTargetShow = false;
        this.show2();
        this.closeDashboard();
        this.reload2(this.dailyTrendDay);
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },

    // 上传文件
    excelUpload(e) {
      var that = this;
      this.tempformData = null;
      const name = e.file.name.split(".");
      const type = name[name.length - 1];
      if (type !== "csv") {
        Utils.alert("", "Please upload the.cvs file", "error");
        return;
      }
      that.uploading = true;
      // 在这里调接口
      var formData = new FormData();
      formData.append("file", e.file);
      api.checkType({
        params: formData,
        callback: (res) => {
          if (res.data.code == 0) {
            // 如果通过验证执行以下
            that.name = e.file.name;
            that.size = (e.file.size / 1024).toFixed(1);
            this.tempformData = formData;
            that.uploaded = true;
            that.seconddisable = false;
            that.uploading = false;
          } else {
            // 不通过验证调用
            that.uploading = false;
            that.remove();
            Utils.alert("", res.data.message, "error");
          }
        },
      });
    },
    uploadCallback(res) {
      var that = this;
      Utils.loadings(2);
      // that.uploading = false
      if (res.data.code == 0) {
        // 如果是传数值
        if (this.isdollar === true) {
          api.save({
            params: {
              profitTarget: parseInt(this.dollar),
              profitTargetType: 0,
              type: 0,
            },
            callback: this.saveCallback,
          });
        } else {
          api.save({
            params: {
              profitTarget: parseFloat(this.percentage) / 100,
              profitTargetType: 1,
              type: 0,
            },
            callback: this.saveCallback,
          });
        }
        // 2021/12/30
        // 如果pin值不存在
        if (that.pinExict === false && that.venueType === "2") {
          that.pincodes = "";
          that.pinVisible = true;
        }
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.loadings(2);
        Utils.alert("", res.data.message, "error");
      }
    },
    // 验证输入
    validate(type) {
      if (type === "dollar") {
        this.dollar = this.dollar.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1");
      } else if (type === "percentage") {
        this.percentage = this.percentage.replace(
          /^(\-)*(\d+)\.(\d).*$/,
          "$1$2.$3"
        );
      }
      if (this.dollar !== "" || this.percentage !== "") {
        this.fouthdisable = false;
      }
    },
    /*******************************  跳转去第三方 *******************************/
    disXero() {
      this.showXeroAsk = false;
      Utils.loadings();
      api.disXero({ callback: this.disXeroCallback });
    },
    disXeroCallback(res) {
      Utils.loadings(2);
      if (res.data.code == 0) {
        this.fristdisable = false;
        this.bindXero = false;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    // 跳转去第三方
    jumpXero() {
      this.showXeroAsk = false;
      this.waitXero = true;
      localStorage.removeItem("xeroCode");
      // for sandbox
      // window.open(
      //   "https://login.xero.com/identity/connect/authorize?response_type=code&client_id=20A39760C9914CFCA25A482C03598984&redirect_uri=https://sandbox-venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings  offline_access&state=xero",
      //   "_blank"
      // );
      // for online
      // window.open(
      //   "https://login.xero.com/identity/connect/authorize?response_type=code&client_id=0965E05CF1364AF9994B5A2B95AD2E3A&redirect_uri=https://venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings  offline_access&state=xero",
      //   "_blank"
      // );
      // 开始轮询
      window.open(
        process.env.XERO_URL,
        "_blank"
      );
      clearInterval(this.timer);
      this.timer = setInterval(this.longpoll, 3000);
    },
    longpoll() {
      if (!localStorage.getItem("xeroCode")) {
      } else {
        clearInterval(this.timer);
        const xeroCode = localStorage.getItem("xeroCode");
        localStorage.removeItem("xeroCode");
        api.sendXero({
          params: {
            code: xeroCode,
          },
          callback: this.xeroCallback,
        });
      }
    },
    xeroCallback(res) {
      var that = this
      this.waitXero = false;
      that.defaultExpanded = []
      that.defaultData = []
      if (res.data.code == 0) {
        this.bindXero = true;
        // Utils.alert('', res.data.message, 'success')
        // 绑定后判断是否已完成连接所有第三方
        if ((this.bindXero === true || this.bindBluesheets === true) && (this.bindDeputy === true || this.bindTanda === true)) {
          this.fristdisable = false;
        }
        this.linkSuccessXero = true;
        // 连接xero成功后, 判断有设置追踪类别就给他选，没有设置追踪类别就不出来这个弹窗直接绑定成
        apiXero.getTrackingCategories({
          callback: (res) => {
            if (res.data.code == 0) {
              if (res.data.data.length > 0)
                this.xeroHasMore = true
              res.data.data.forEach(item => {
                let children = []
                item.Options.forEach(i => {
                  children.push({
                    id: i.TrackingOptionID,
                    label: i.Name,
                    parent: item.TrackingCategoryID
                  })
                })
                that.defaultData.push({
                  id: item.TrackingCategoryID,
                  label: item.Name,
                  children: children
                })
                that.defaultExpanded.push(item.TrackingCategoryID)
              })
            } else {
              Utils.alert('', res.data.message, 'error')
            }
          }
        })

        // this.getStatus();
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        // Utils.alert('', res.data.message, 'error')
        this.linkFailXero = true;
      }
    },
    getStatus() {
      api.progress({
        callback: (res) => {
          if (res.data.code == 0) {
            this.deputyFlag = res.data.data.deputyFlag
            this.tandaFlag = res.data.data.tandaFlag
            this.doshiiFlag = res.data.data.doshiiFlag
            this.xeroFlag = res.data.data.xeroFlag
            this.blueFlag = res.data.data.blueesheetFlag
            this.kseriesFlag = (res.data.data.kseriesBind || res.data.data.kseriesFlag)
            this.kseriesBlid = res.data.data.kseriesBlid
            this.oseriesFlag = res.data.data.oseriesFlag
            this.bindHandLFlag = res.data.data.handlFlag
            this.tevalisFlag = res.data.data.tevalisFlag
            this.redcatFlag = res.data.data.redcatFlag
            this.squareFlag = res.data.data.squareFlag
            this.swiftPosFlag = res.data.data.swiftPosFlag
            this.idealposCsvFlag = res.data.data.idealposCsvFlag
            this.imposCsvFlag = res.data.data.imposCsvFlag
            this.bepozCsvFlag = res.data.data.bepozCsvFlag
            this.oolioFlag = res.data.data.oolioFlag


            this.xeroVisibility = (res.data.data.trackingCategoriesFlag === false && res.data.data.xeroFlag === true) ? true : false

            this.xeroName = res.data.data.xeroTenantName === null || res.data.data.xeroTenantName === '' ? 'Xero' : res.data.data.xeroTenantName
            this.maxAutomatedEmails = res.data.data.maxAutomatedEmails ? res.data.data.maxAutomatedEmails : 5

            if (res.data.data.posInfo) {
              this.posInfo = res.data.data.posInfo
              this.posId = res.data.data.posInfo.posId
            }
            window.sessionStorage.setItem('deputyFlag', this.deputyFlag);
            window.sessionStorage.setItem('tandaFlag', this.tandaFlag);
            window.sessionStorage.setItem('xeroFlag', this.xeroFlag);
            window.sessionStorage.setItem('handlFlag', this.bindHandLFlag);
          } else {
            Utils.alert("", res.data.message, "error");
          }
      }});
    },
    disDeputy() {
      this.showSchedulingAsk = false;
      Utils.loadings();
      api.disDeputy({ callback: this.disDeputyCallback });
    },
    disDeputyCallback(res) {
      Utils.loadings(2);
      if (res.data.code == 0) {
        this.fristdisable = false;
        this.bindDeputy = false;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    disTanda() {
      this.showSchedulingAsk = false;
      Utils.loadings();
      api.disTanda({ callback: this.disTandaCallback });
    },
    disTandaCallback(res) {
      Utils.loadings(2);
      if (res.data.code == 0) {
        this.fristdisable = false;
        this.bindTanda = false;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    jumpTanda() {
      this.showSchedulingAsk = false;
      localStorage.removeItem("tandaCode");
      // for sandbox
      /*window.open(
        "https://my.tanda.co/api/oauth/authorize?client_id=7dfadd9bafc4c400f053309d718f2c9c712eb61feb3e9c1dd3e86d3108377ffa&redirect_uri=https%3A%2F%2Fsandbox-venue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream",
        "_blank"
      );*/
      // for online
      // window.open(
      //   "https://my.tanda.co/api/oauth/authorize?client_id=c2dabdb414a28be50bbef6cfbe7109a96c38298279c88711749147373421038c&redirect_uri=https%3A%2F%2Fvenue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream",
      //   "_blank"
      // );

      window.open(
        process.env.TANDA_URL,
        "_blank"
      );

      // 开始轮询
      clearInterval(this.timer3);
      this.timer3 = setInterval(this.longpoll3, 3000);
      // localStorage.setItem("tandaCode", '6e42d1d4200ea109f0237392bd3d3588e801e01164e4656662eadfa99e8fd119')
    },
    longpoll3() {
      if (!localStorage.getItem("tandaCode")) {
      } else {
        clearInterval(this.timer3);
        const tandaCode = localStorage.getItem("tandaCode");
        localStorage.removeItem("tandaCode");
        this.newSelList = [];
        Api.sendTanda({
          params: {
            code: tandaCode,
          },
          callback: this.tandaCallback,
        });
      }
    },
    tandaCallback(res) {
      if (res.data.code == 0) {
        this.selectFrom = 'tanda';
        this.newSelList = res.data.data;
        this.linkSelDio = true;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
        // this.linkFailDeputy = true
      }
    },
    jumpDeputy() {
      this.showSchedulingAsk = false;
      localStorage.removeItem("deputyCode");
      // for sandbox
      // window.open(
      //   "https://once.deputy.com/my/oauth/login?client_id=f65b88c2bf496c5a553567322d35e7e7f1ab5d03&redirect_uri=https://sandbox-venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token",
      //   "_blank"
      // );
      // // for online
      // window.open(
      //   "https://once.deputy.com/my/oauth/login?client_id=64a567becdf815c8b223d69544c7385d24959f08&redirect_uri=https://venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token",
      //   "_blank"
      // );
      window.open(
        process.env.DEPUTY_URL,
        "_blank"
      );
      // 开始轮询
      clearInterval(this.timer2);
      this.timer2 = setInterval(this.longpoll2, 3000);
      // localStorage.setItem("deputyCode", 5454)
    },
    longpoll2() {
      if (!localStorage.getItem("deputyCode")) {
        //console.log("还没有拿到deputy的回调码");
      } else {
        clearInterval(this.timer2);
        const deputyCode = localStorage.getItem("deputyCode");
        localStorage.removeItem("deputyCode");
        // 在这里传给后台
        this.newSelList = [];
        api.sendDeputy({
          params: {
            code: deputyCode,
          },
          callback: this.deputyCallback,
        });
      }
    },
    deputyCallback(res) {
      if (res.data.code == 0) {
        this.selectFrom = 'deputy'
        this.newSelList = res.data.data;
        this.linkSelDio = true;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
        // this.linkFailDeputy = true
      }
    },
    chooseVenue(val) {
      this.venueval = val;
      // 这里区分一下
      if (this.selectFrom === 'deputy') {
        Api.getDeputyOption({
          params: {
            companyId: val.companyId,
          },
          callback: (res) => {
            if (res.data.code == 0) {
              res.data.data.forEach((item) => {
                item.checked = false;
              });
              this.checkOptions = res.data.data;
              this.innerSelVisible = true;
            } else {
              Utils.alert("", res.data.message, "error");
            }
          },
        });
      } else {
        Api.getTandaOption({
          params: {
            companyId: val.companyId,
          },
          callback: (res) => {
            if (res.data.code == 0) {
              res.data.data.forEach((item) => {
                item.checked = false;
              });
              this.checkOptions = res.data.data;
              this.innerSelVisible = true;
            } else {
              Utils.alert("", res.data.message, "error");
            }
          },
        });

      }
    },
    confirmBind() {
      let temp = [];
      this.checkOptions.forEach((item) => {
        if (item.checked) {
          temp.push({
            Company: item.Company,
            CompanyName: item.CompanyName,
            Id: item.Id,
            LabelWithCompany: item.LabelWithCompany,
            OperationalUnitName: item.OperationalUnitName,
          });
        }
      });

      // 在这里区分一下
      if (this.selectFrom === 'deputy') {
        Api.bindDeputyTrue({
          params: {
            companyId: this.venueval.companyId,
            companyName: this.venueval.companyName,
            operationalUnitInfoList: temp,
          },
          callback: (res) => {
            if (res.data.code == 0) {
              this.innerSelVisible = false;
              this.linkSelDio = false;
              this.checkList = [];
              this.checkOptions = [];
              // this.newSelList = []
              this.venueval = "";

              this.bindDeputy = true;
              // Utils.alert('', res.data.message, 'success')
              // 绑定后判断是否已完成连接所有第三方
              if (this.bindXero === true && (this.bindDeputy === true || this.bindTanda === true)) {
                this.fristdisable = false;
              }
              this.linkSuccessDeputy = true;
            } else {
              this.linkFailDeputy = true;
            }
          },
        });
      } else {
        Api.bindTandaTrue({
          params: {
            companyId: this.venueval.companyId,
            companyName: this.venueval.companyName,
            operationalUnitInfoList: temp,
          },
          callback: (res) => {
            if (res.data.code == 0) {
              this.innerSelVisible = false;
              this.linkSelDio = false;
              this.checkList = [];
              this.checkOptions = [];
              // this.newSelList = []
              this.venueval = "";

              this.bindTanda = true;
              // Utils.alert('', res.data.message, 'success')
              // 绑定后判断是否已完成连接所有第三方
              if (this.bindXero === true && (this.bindDeputy === true || this.bindTanda === true)) {
                this.fristdisable = false;
              }
              this.linkSuccessDeputy = true;
            } else {
              this.linkFailDeputy = true;
            }
          },
        });
      }
    },
    proCallback(res) {
      if (res.data.code == 0) {
        let terminalsList = res.data.data.terminalsList
        if (terminalsList) {
          this.doshiiBindedAlert = true
          this.terminalsList = terminalsList
        } else {
          this.terminalsList = []
        }

        this.cashUpFormat = res.data.data.cashUpFormat ? res.data.data.cashUpFormat : false

        this.isManualJournalActivated = res.data.data.isManualJournalActivated ? true : false;

        this.deputyFlag = res.data.data.deputyFlag;
        this.tandaFlag = res.data.data.tandaFlag;
        sessionStorage.setItem('tandaFlag', this.tandaFlag)
        sessionStorage.setItem('deputyFlag', this.deputyFlag)
        this.doshiiFlag = res.data.data.doshiiFlag;
        this.posInfo = res.data.data.posInfo;
        this.xeroFlag = res.data.data.xeroFlag;
        this.blueSheetsFlag = res.data.data.blueesheetFlag
        this.handlFlag = res.data.data.handlFlag
        this.bindHandl = res.data.data.bindHandl
        this.isEodSplitActivated = res.data.data.isEodSplitActivated

        this.isGstAdded = res.data.data.isGstAdded ? true : false

        this.idealposCsvFlag = res.data.data.idealposCsvFlag
        this.imposCsvFlag = res.data.data.imposCsvFlag
        this.bepozCsvFlag = res.data.data.bepozCsvFlag
        this.oolioFlag = res.data.data.oolioFlag

        if (res.data.data.kseriesBind || res.data.data.oseriesFlag || res.data.data.doshiiFlag || res.data.data.tevalisFlag || res.data.data.bindHandl || res.data.data.blueesheetFlag || res.data.data.xeroFlag || res.data.data.deputyFlag || res.data.data.tandaFlag || res.data.data.redcatFlag || this.idealposCsvFlag || this.squareFlag || this.imposCsvFlag || this.bepozCsvFlag || this.oolioFlag || this.swiftPosFlag) {
          this.fristdisable = false
        }

        if (res.data.data.kseriesBind || res.data.data.oseriesFlag || res.data.data.tevalisFlag || res.data.data.redcatFlag || this.idealposCsvFlag || this.squareFlag || this.imposCsvFlag || this.bepozCsvFlag || this.oolioFlag || this.swiftPosFlag) {
          this.profitTargetFlag = true
          this.importExcelFlag = true
        } else {
          this.profitTargetFlag = res.data.data.profitTargetFlag;
          this.importExcelFlag = res.data.data.importExcelFlag;
        }

        if (res.data.data.kseriesBind || res.data.data.kseriesFlag) {
          this.kseriesFlag = true
          this.kseriesBind = true
          this.websocketConnection()
        }

        if (res.data.data.oseriesFlag) {
          this.oseriesFlag = true
        }

        if (res.data.data.tevalisFlag) {
          this.tevalisFlag = true
        }

        if (res.data.data.redcatFlag) {
          this.redcatFlag = true
        }

        if (res.data.data.oolioFlag) {
          this.oolioFlag = true
        }

        if (res.data.data.squareFlag) {
          this.squareFlag = true
        }

        if (res.data.data.swiftPosFlag) {
          this.swiftPosFlag = true
        }

        if (res.data.data.isGstAdded) {
          this.isGstAdded = res.data.data.isGstAdded ? true : false;
        }

        if (this.doshiiFlag || this.deputyFlag || this.handlFlag || this.kseriesFlag || this.oseriesFlag || this.tevalisFlag || this.blueSheetsFlag || this.tandaFlag) {
          this.fristdisable = false
        }

        this.xeroVisibility =
          res.data.data.trackingCategoriesFlag === false &&
            res.data.data.xeroFlag === true
            ? true
            : false;
        this.xeroName =
          res.data.data.xeroTenantName === null ||
            res.data.data.xeroTenantName === ""
            ? "Xero"
            : res.data.data.xeroTenantName;

        this.bindXero = res.data.data.xeroFlag;
        this.bindDeputy = res.data.data.deputyFlag;
        this.bindDoshi = res.data.data.doshiiFlag;
        this.bindTanda = res.data.data.tandaFlag;
        this.bindBluesheets = res.data.data.blueesheetFlag
        this.isCashUpActivated = res.data.data.isCashUpActivated
        // this.posVisible =
        //   res.data.data.posInfo || res.data.data.skipPos ? false : true;
        // 必填项全部完成
        if (this.importExcelFlag === true && this.profitTargetFlag === true) {
          this.pop = false;
          // 如果pin值不存在
          // if (this.pinExict === false && this.isSingleAccount) {
          //   this.pincodes = "";
          //   this.pinVisible = true;
          // }
        }
        // 如果没有19周的数据，判断是否曾经跳过第一步
        if (this.importExcelFlag === false) {

          if (!this.deputyFlag && !this.doshiiFlag && !this.oseriesFlag && !this.bindHandl && !this.kseriesFlag && !this.tevalisFlag && !this.redcatFlag && !this.idealposCsvFlag && !this.squareFlag && !this.imposCsvFlag && !this.bepozCsvFlag && !this.oolioFlag && !this.swiftPosFlag) {
            this.pop = true;
            this.fristbox = true;
            // if (res.data.data.skipBind) {
            //   this.secondbox = true;
            // }
            // else {
            //   this.fristbox = true;
            // }
          }
        }
        // 如果已经上传过19周数据，可能绑定完成并点了continue，也可能点了next time跳过，只要有19周，就不需要显示第三方绑定
        // 有19周的数据，没设置后面的
        if (this.importExcelFlag === true && this.profitTargetFlag === false) {
          this.pop = true;
          this.thirdbox = true;
          this.showfrist = false;
          this.seconddisable = false;
        }

        if (!this.isPro && this.posVisible) {
          this.posVisible = false
        }

        this.infoReports.isCashUpActivated = this.isCashUpActivated

        // if (sessionStorage.getItem('deputyFlag') == 'true') {
        //   api.tip({
        //     callback: (res) => {
        //       if (res.data.code == 0) {
        //         if (res.data.data.agreeToAgreements === false) this.showTerm = true;
        //       }
        //     },
        //   });
        // }

        api.tip({
          callback: (res) => {
            if (res.data.code == 0) {
              if (res.data.data.agreeToAgreements === false) this.showTerm = true;
            }
          },
        });
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    // temporary commented by menard 3-15-24
    // datumCallback(res) {
    //   var that = this;
    //   that.loading = false;
    //   if (res.data.code == 0) {
    //     // this.fourWeeksAvg = res.data.data.fourWeeksAvg;
    //     // this.$emit("fourWeeksAvgEvt", this.fourWeeksAvg);
    //     if (res.data.data.isQueryTemporary !== null)
    //       that.showButton = res.data.data.isQueryTemporary === 0 ? true : false;

    //     that.weeklyLabourHours = []
    //     that.weeklyLabourCost = []

    //     if (res.data.data.actualLabourHours) {
    //       let actualLabourHours = res.data.data.actualLabourHours

    //       that.weeklyLabourHours.push({ type: 'hour', left: 'Actuals Labour', mon: actualLabourHours.mon, tue: actualLabourHours.tue, wed: actualLabourHours.wed, thu: actualLabourHours.thu, fri: actualLabourHours.fri, sat: actualLabourHours.sat, sun: actualLabourHours.sun, total: actualLabourHours.total, })
    //     } else {
    //       that.weeklyLabourHours.push({ type: 'hour', left: 'Actuals Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
    //     }
    //     if (res.data.data.actualLabourCost) {
    //       let actualLabourCost = res.data.data.actualLabourCost
    //       that.weeklyLabourCost.push({ type: 'cost', left: 'Actuals Labour', mon: actualLabourCost.mon, tue: actualLabourCost.tue, wed: actualLabourCost.wed, thu: actualLabourCost.thu, fri: actualLabourCost.fri, sat: actualLabourCost.sat, sun: actualLabourCost.sun, total: actualLabourCost.total })
    //     } else {
    //       that.weeklyLabourCost.push({ type: 'cost', left: 'Actuals Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
    //     }

    //     if (res.data.data.budgetedLabourHours) {
    //       let budgetedLabourHours = res.data.data.budgetedLabourHours
    //       that.weeklyLabourHours.push({ type: 'hour', left: 'Rostered Labour', mon: budgetedLabourHours.mon, tue: budgetedLabourHours.tue, wed: budgetedLabourHours.wed, thu: budgetedLabourHours.thu, fri: budgetedLabourHours.fri, sat: budgetedLabourHours.sat, sun: budgetedLabourHours.sun, total: budgetedLabourHours.total })
    //     } else {
    //       that.weeklyLabourHours.push({ type: 'hour', left: 'Rostered Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
    //     }
    //     if (res.data.data.budgetedLabourCost) {
    //       let budgetedLabourCost = res.data.data.budgetedLabourCost
    //       that.weeklyLabourCost.push({ type: 'cost', left: 'Rostered Labour', mon: budgetedLabourCost.mon, tue: budgetedLabourCost.tue, wed: budgetedLabourCost.wed, thu: budgetedLabourCost.thu, fri: budgetedLabourCost.fri, sat: budgetedLabourCost.sat, sun: budgetedLabourCost.sun, total: budgetedLabourCost.total })
    //     } else {
    //       that.weeklyLabourCost.push({ type: 'cost', left: 'Rostered Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
    //     }

    //     // Actual Weekly Operation
    //     that.tableData1 = []
    //     that.labourHourlyRate = []
    //     if (res.data.data.labour) {
    //       that.tableData1.push({ type: "hourly", left: "Labour +/-", mon: Utils.formatNewHour(res.data.data.labour.mon), monColor: res.data.data.labour.mon === null ? 'white' : (res.data.data.labour.mon <= 0 ? 'cyan' : 'red'), fri: Utils.formatNewHour(res.data.data.labour.fri), friColor: res.data.data.labour.fri === null ? 'white' : (res.data.data.labour.fri <= 0 ? 'cyan' : 'red'), sat: Utils.formatNewHour(res.data.data.labour.sat), satColor: res.data.data.labour.sat === null ? 'white' : (res.data.data.labour.sat <= 0 ? 'cyan' : 'red'), sun: Utils.formatNewHour(res.data.data.labour.sun), sunColor: res.data.data.labour.sun === null ? 'white' : (res.data.data.labour.sun <= 0 ? 'cyan' : 'red'), thu: Utils.formatNewHour(res.data.data.labour.thu), thuColor: res.data.data.labour.thu === null ? 'white' : (res.data.data.labour.thu <= 0 ? 'cyan' : 'red'), total: Utils.formatNewHour(res.data.data.labour.total), totalColor: res.data.data.labour.total === null ? 'white' : (res.data.data.labour.total <= 0 ? 'cyan' : 'red'), tue: Utils.formatNewHour(res.data.data.labour.tue), tueColor: res.data.data.labour.tue === null ? 'white' : (res.data.data.labour.tue <= 0 ? 'cyan' : 'red'), wed: Utils.formatNewHour(res.data.data.labour.wed), wedColor: res.data.data.labour.wed === null ? 'white' : (res.data.data.labour.wed <= 0 ? 'cyan' : 'red'), })
    //       that.labourHourlyRate.push({ type: "hourly", left: "Labour +/-", mon: Utils.formatNewHour(res.data.data.labour.mon), monColor: res.data.data.labour.mon === null ? 'white' : (res.data.data.labour.mon <= 0 ? 'cyan' : 'red'), fri: Utils.formatNewHour(res.data.data.labour.fri), friColor: res.data.data.labour.fri === null ? 'white' : (res.data.data.labour.fri <= 0 ? 'cyan' : 'red'), sat: Utils.formatNewHour(res.data.data.labour.sat), satColor: res.data.data.labour.sat === null ? 'white' : (res.data.data.labour.sat <= 0 ? 'cyan' : 'red'), sun: Utils.formatNewHour(res.data.data.labour.sun), sunColor: res.data.data.labour.sun === null ? 'white' : (res.data.data.labour.sun <= 0 ? 'cyan' : 'red'), thu: Utils.formatNewHour(res.data.data.labour.thu), thuColor: res.data.data.labour.thu === null ? 'white' : (res.data.data.labour.thu <= 0 ? 'cyan' : 'red'), total: Utils.formatNewHour(res.data.data.labour.total), totalColor: res.data.data.labour.total === null ? 'white' : (res.data.data.labour.total <= 0 ? 'cyan' : 'red'), tue: Utils.formatNewHour(res.data.data.labour.tue), tueColor: res.data.data.labour.tue === null ? 'white' : (res.data.data.labour.tue <= 0 ? 'cyan' : 'red'), wed: Utils.formatNewHour(res.data.data.labour.wed), wedColor: res.data.data.labour.wed === null ? 'white' : (res.data.data.labour.wed <= 0 ? 'cyan' : 'red'), })
    //       that.labourHourlyRate.push({ type: "labour", left: "Labour +/-", mon: Utils.formatMoneyActual(cost.mon), monColor: cost.mon === null ? 'white' : (cost.mon <= 0 ? 'cyan' : 'red'), fri: Utils.formatMoneyActual(cost.fri), friColor: cost.fri === null ? 'white' : (cost.fri <= 0 ? 'cyan' : 'red'), sat: Utils.formatMoneyActual(cost.sat), satColor: cost.sat === null ? 'white' : (cost.sat <= 0 ? 'cyan' : 'red'), sun: Utils.formatMoneyActual(cost.sun), sunColor: cost.sun === null ? 'white' : (cost.sun <= 0 ? 'cyan' : 'red'), thu: Utils.formatMoneyActual(cost.thu), thuColor: cost.thu === null ? 'white' : (cost.thu <= 0 ? 'cyan' : 'red'), total: Utils.formatMoneyActual(cost.total), totalColor: cost.total === null ? 'white' : (cost.total <= 0 ? 'cyan' : 'red'), tue: Utils.formatMoneyActual(cost.tue), tueColor: cost.tue === null ? 'white' : (cost.tue <= 0 ? 'cyan' : 'red'), wed: Utils.formatMoneyActual(cost.wed), wedColor: cost.wed === null ? 'white' : (cost.wed <= 0 ? 'cyan' : 'red'), })
    //     } else {
    //       that.tableData1.push({ type: "hourly", left: "Labour +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
    //       that.labourHourlyRate.push({ type: "hourly", left: "Labour +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
    //       that.labourHourlyRate.push({ type: "labour", left: "Labour +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
    //     }
    //     if (res.data.data.rev) {
    //       that.tableData1.push({ left: "Rev +/-", mon: Utils.formatMoneyActual(rev.mon), monColor: rev.mon === null ? 'white' : (rev.mon >= 0 ? 'cyan' : 'red'), fri: Utils.formatMoneyActual(rev.fri), friColor: rev.fri === null ? 'white' : (rev.fri >= 0 ? 'cyan' : 'red'), sat: Utils.formatMoneyActual(rev.sat), satColor: rev.sat === null ? 'white' : (rev.sat >= 0 ? 'cyan' : 'red'), sun: Utils.formatMoneyActual(rev.sun), sunColor: rev.sun === null ? 'white' : (rev.sun >= 0 ? 'cyan' : 'red'), thu: Utils.formatMoneyActual(rev.thu), thuColor: rev.thu === null ? 'white' : (rev.thu >= 0 ? 'cyan' : 'red'), total: Utils.formatMoneyActual(rev.total), totalColor: rev.total === null ? 'white' : (rev.total >= 0 ? 'cyan' : 'red'), tue: Utils.formatMoneyActual(rev.tue), tueColor: rev.tue === null ? 'white' : (rev.tue >= 0 ? 'cyan' : 'red'), wed: Utils.formatMoneyActual(rev.wed), wedColor: rev.wed === null ? 'white' : (rev.wed >= 0 ? 'cyan' : 'red'), })
    //     } else {
    //       that.tableData1.push({ left: "Rev +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
    //     }
    //   } else if (res.data.code == 8902) {
    //     sessionStorage.clear();
    //     this.$router.push("/login");
    //   } else {
    //     Utils.alert("", res.data.message, "error");
    //   }
    // },
    remove() {
      this.uploaded = false;
      this.name = null;
      this.size = null;
      this.seconddisable = true;
    },
    /**********新增 **********/
    // 上传文件
    longWeekexcelUpload(e) {
      var that = this;
      const name = e.file.name.split(".");
      const type = name[name.length - 1];
      if (type !== "csv") {
        Utils.alert("", "Please upload the.cvs file", "error");
        return;
      }
      // 在这里调接口
      var formData = new FormData();
      formData.append("file", e.file);
      that.longWeekname = e.file.name;
      that.longWeeksize = (e.file.size / 1024).toFixed(1);
      that.longWeektempFormdata = formData;
      that.longWeekuploaded = true;
      that.longWeekdisable = false;
    },
    longWeekcontinue() {
      var that = this;
      that.longWeekuploading = true;
      that.longWeekuploaded = false;
      api.upload({
        params: that.longWeektempFormdata,
        type: 2,
        callback: that.longWeekuploadCallback,
      });
    },
    longWeekuploadCallback(res) {
      var that = this;
      that.longWeekuploading = false;
      that.longWeekuploaded = true;
      if (res.data.code == 0) {
        // 数据正常
        that.queryTemporary();
      } else if (res.data.code === 10002) {
        // 有重复数据，展开二次确认弹框
        that.longWeekshowconfirm = true;
        that.longWeektemp = res.data.data;
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    longWeekcancel() {
      var that = this;
      if (that.longWeekuploading) {
        return;
      }
      that.longWeek = false;
      that.longWeekuploaded = false;
      that.longWeekname = null;
      that.longWeeksize = null;
      that.longWeekdisable = true;
      that.longWeektempFormdata = null;
      that.longWeektemp = null;
    },
    longWeekcloseconfirm(type) {
      if (type === "cancel") {
        this.longWeek = false;
        this.longWeekshowconfirm = false;
      } else if (type === "over") {
        Utils.loadings();
        api.over({
          params: {
            map: this.longWeektemp,
            overwriteFlag: true,
            uploadType: 0,
          },
          callback: this.longWeekcloseCallback,
        });
      } else if (type === "keep") {
        Utils.loadings();
        api.over({
          params: {
            map: this.longWeektemp,
            overwriteFlag: false,
            uploadType: 0,
          },
          callback: this.longWeekcloseCallback,
        });
      }
    },
    longWeekcloseCallback(res) {
      var that = this;
      Utils.loadings(2);
      that.longWeek = false;
      that.longWeekuploaded = false;
      that.longWeekname = null;
      that.longWeeksize = null;
      that.longWeekdisable = true;
      that.longWeekshowconfirm = false;
      that.longWeektempFormdata = null;
      that.longWeektemp = null;
      if (res.data.code == 0) {
        that.reload();
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    longWeekremove() {
      this.longWeekuploaded = false;
      this.longWeekname = null;
      this.longWeeksize = null;
      this.longWeekdisable = true;
    },
    isEmptyObject(obj) {
      return Object.entries(obj).length === 0;
    },

    checkValueExists(value) {
      return value ? value : null;
    },

    checkValueExistsNullValue(value) {
      return value ? value : null;
    },

    getWeeklyLabour(labourByDay, labourByDayTotal, title) {

      let hours = {type: 'hour', left: title,};
      let cost = {type: 'cost', left: title};

      if ((labourByDay && !this.isEmptyObject(labourByDay)) && (labourByDayTotal && !this.isEmptyObject(labourByDayTotal))) {

        for (const key in labourByDay) {
          if (Object.prototype.hasOwnProperty.call(labourByDay, key)) {
            const data = labourByDay[key];
            hours[key] = Utils.checkValueExists(data.hours);
            cost[key] = Utils.checkValueExists(data.amount);
          }
        }

        hours.total = Utils.checkValueExists(labourByDayTotal.hours);
        cost.total = Utils.checkValueExists(labourByDayTotal.amount);

        if (title === 'Salary Labour') {
          hours.isPin = true;
          hours.isHide = true;
          cost.isPin = true;
          cost.isHide = true;
        }

      } else {
        hours = { type: 'hour', left: 'Actuals Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null }
        cost = { type: 'cost', left: 'Actuals Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null }
      }

      this.weeklyLabourHours.push(hours);
      this.weeklyLabourCost.push(cost);

      return { hours, cost }
    },

    getWeeklyOperationlabour(delta, detalTotal, type='labour') {

      let hours = {type: 'hourly', left: 'Labour +/-'};
      let cost = {type: type, left: type === 'labour' ? 'Labour +/-' : 'Rev +/-'};

      if ((delta && !this.isEmptyObject(delta)) && (detalTotal && !this.isEmptyObject(detalTotal))) {

        for (const key in delta) {
          if (Object.prototype.hasOwnProperty.call(delta, key)) {

            const data = delta[key];
            if (type === 'labour') {
              const hoursVal = Utils.checkValueExists(data.hours);
              const costVal = Utils.checkValueExists(data.amount);

              hours[key] = Utils.formatNewHour(hoursVal);
              hours[key + 'Color'] = hoursVal == null ? 'white' : (hoursVal <= 0 ? 'cyan' : 'red');

              cost[key] = Utils.formatMoneyActual(costVal);
              cost[key + 'Color'] = costVal == null ? 'white' : (costVal <= 0 ? 'cyan' : 'red');

            } else {
              const netAmount = Utils.checkValueExists(data.netAmount);

              cost[key] = Utils.formatMoneyActual(netAmount);
              cost[key + 'Color'] = netAmount == null ? 'white' : (netAmount >= 0 ? 'cyan' : 'red');
            }
          }
        }

        if (type === 'labour') {
          const hoursTotal = Utils.checkValueExists(detalTotal.hours);
          const costTotal = Utils.checkValueExists(detalTotal.amount);

          hours.total = Utils.formatNewHour(hoursTotal);
          hours.totalColor = hoursTotal == null ? 'white' : (hoursTotal <= 0 ? 'cyan' : 'red');

          cost.total = Utils.formatMoneyActual(costTotal);
          cost.totalColor = costTotal == null ? 'white' : (costTotal <= 0 ? 'cyan' : 'red');

          this.tableData1.push(hours);
          this.labourHourlyRate.push(hours);
          this.labourHourlyRate.push(cost);

        } else {
          const netAmountTotal = Utils.checkValueExists(detalTotal.netAmount);
          cost.total = Utils.formatMoneyActual(netAmountTotal);
          cost.totalColor = netAmountTotal == null ? 'white' : (netAmountTotal >= 0 ? 'cyan' : 'red');

          this.tableData1.push(cost);
        }
      } else {
        if (type === 'labour') {
          hours = {type: 'hourly', left: 'Labour +/-', mon: null, monColor: 'white', tue: null, tueColor: 'white', wed: null, wedColor: 'white', thu: null, thuColor: 'white', fri: null, friColor: 'white', sat: null, satColor: 'white', sun: null, sunColor: 'white', total: null, totalColor: 'white'}
          cost = {type: type, left: 'Labour +/-', mon: null, monColor: 'white', tue: null, tueColor: 'white', wed: null, wedColor: 'white', thu: null, thuColor: 'white', fri: null, friColor: 'white', sat: null, satColor: 'white', sun: null, sunColor: 'white', total: null, totalColor: 'white'}

          this.tableData1.push(hours);
          this.labourHourlyRate.push(hours);
          this.labourHourlyRate.push(cost);

        } else {
          cost = {type: type, left: 'Rev +/-', mon: null, monColor: 'white', tue: null, tueColor: 'white', wed: null, wedColor: 'white', thu: null, thuColor: 'white', fri: null, friColor: 'white', sat: null, satColor: 'white', sun: null, sunColor: 'white', total: null, totalColor: 'white'}
          this.tableData1.push(cost);
        }
      }

      return { hours, cost }
    },

    async getWeeklyProfitRevenueLabourV2(startDate) {
      const res = await api.profitRevenueLabourV2(startDate, 'weekly');

      this.infoGuidance.title = 'Weekly Guidance'

      this.$root.$emit('set-roster-display', 1)

      if (res) {
        this.getInfoDashboardV2(res);

        this.weeklyLabourHours = []
        this.weeklyLabourCost = []

        // Actual Labour
        this.getWeeklyLabour(res.actualLabourByDay, res.actualLabourByDayTotal, 'Actuals Labour')
        // Rostered Labour
        this.getWeeklyLabour(res.rosteredLabourByDay, res.rosteredLabourByDayTotal, 'Rostered Labour')
        // Salary Labour
        this.getWeeklyLabour(res.salaryLabourByDay, res.salaryLabourByDayTotal, 'Salary Labour')


        this.tableData1 = []
        this.labourHourlyRate = []

        this.getWeeklyOperationlabour(res.labourDelta, res.labourDeltaTotal, 'labour')
        this.getWeeklyOperationlabour(res.revenueDelta, res.revenueDeltaTotal, 'revenue')
      } else {
        Utils.alert2('', 'Something went wrong, please contact administrator.', 'error')
      }

      this.dataLoading = false;

    },

    getWeeklyProfitRevenueLabour(dashBoardId, monDateTime, sunDateTime) {
      api.weekProfitRevenueLabour({
        params: {
          dashBoardId,
          monDateTime,
          sunDateTime
        },
        callback: (res) => {
          this.dataLoading = false

          if (res.data.code === 0) {

            let data = res.data.data

            this.actualRevenue = data.actualPOJO.actualRevenue.total
            this.revenueTarget = (data && data.targetPOJO) ? data.targetPOJO.revenueTarget.total : null
            this.targetRoster = (data && data.targetPOJO) ? data.targetPOJO.rosterTargetPOJO.cost.total : null
            this.targetHourRoster = (data && data.targetPOJO) ? data.targetPOJO.rosterTargetPOJO.hours.total : null
            this.actualRoster = (data && data.actualPOJO) ? data.actualPOJO.actualRosterPOJO.cost.total : null
            this.actualHourRoster = (data && data.actualPOJO) ? data.actualPOJO.actualRosterPOJO.hours.total : null


            if (this.actualRoster === null || this.actualRevenue === null) {
              this.actualPercentRoster = null
            }
            else if (this.actualRoster === 0 || this.actualRevenue === 0) {
              this.actualPercentRoster = '0.00'
            }
            else {
              this.actualPercentRoster = Utils.formatSplit((this.actualRoster / this.actualRevenue) * 100)
            }

            if (this.targetRoster === null || this.revenueTarget === null) {
              this.targetPercentRoster = null
            }
            else if (this.targetRoster === 0 || this.revenueTarget === 0) {
              this.targetPercentRoster = '0.00'
            }
            else {
              var targetPercentRoster = Utils.checkValueExists(data.targetPercentRoster)
              if (!targetPercentRoster) {
                targetPercentRoster = this.targetRoster / this.revenueTarget * 100
              }

              this.targetPercentRoster = Utils.formatSplit(targetPercentRoster)
            }

            this.infoActualRevenue.title = this.current_params.value == 'LAST WEEK' ? 'Actual Revenue' : 'Predicted Revenue'
            this.infoActualRoster.title = this.current_params.value == 'LAST WEEK' ? 'Actual Roster' : 'Predicted Roster'

            this.$root.$emit('set-roster-display', 1)
            this.infoActualRevenue.value = Utils.formatMoney5(this.actualRevenue)
            this.infoTargetRevenue.value = Utils.formatMoney5(this.revenueTarget)
            this.infoTargetRoster.value = Utils.formatMoney5(this.targetRoster)
            this.infoActualRoster.value = Utils.formatMoney5(this.actualRoster)
            this.infoTargetRoster.title = 'Target Roster'

            this.infoActualRoster.hours = this.actualHourRoster ? `${this.actualHourRoster}hrs` : '0hrs'
            this.infoActualRoster.percentage = this.targetPercentRoster ? `${Utils.formatSplit(this.actualPercentRoster)}%` : '0%'
            this.infoTargetRoster.hours = this.targetHourRoster ? `${this.targetHourRoster}hrs` : '0hrs'
            this.infoTargetRoster.percentage = this.targetPercentRoster ? `${Utils.formatSplit(this.targetPercentRoster)}%` : '0%'

            this.labourHoursGuidance = data.labourHoursGuidance
            this.revenueGuidance = data.revenueGuidance
            this.revenueMessage = data.revenueMessage
            this.labourMessage = data.labourMessage

            this.infoGuidance.title = 'Weekly Guidance'

            this.infoGuidance.revenueGuidance = this.revenueMessage
            this.infoGuidance.labourGuidance = this.labourMessage
            this.infoGuidance.revenueWarn = this.revenueGuidance > 0 ? 1 : 0

            // this.infoGuidance.labourWarn = this.labourHoursGuidance <= 0 ? 1 : 0

            // this.infoGuidance.revenueWarn = this.actualRevenue >= this.revenueTarget ? 1 : 0
            this.infoGuidance.labourWarn = this.targetRoster <= this.actualRoster ? 0 : 1
            // 按钮的显示与否
            if (data.isQueryTemporary !== undefined && data.isQueryTemporary !== null)
              this.showButton = data.isQueryTemporary === 0 ? true : false;
            // Weekly Labour 表格
            this.weeklyLabourHours = []
            this.weeklyLabourCost = []
            if (data.actualPOJO.labourPOJO.hours && !this.isEmptyObject(data.actualPOJO.labourPOJO.hours)) {
              let actualLabourHours = data.actualPOJO.labourPOJO.hours
              this.weeklyLabourHours.push({ type: 'hour', left: 'Actuals Labour', mon: Utils.nullToZero(actualLabourHours.mon), tue: Utils.nullToZero(actualLabourHours.tue), wed: Utils.nullToZero(actualLabourHours.wed), thu: Utils.nullToZero(actualLabourHours.thu), fri: Utils.nullToZero(actualLabourHours.fri), sat: Utils.nullToZero(actualLabourHours.sat), sun: Utils.nullToZero(actualLabourHours.sun), total: Utils.nullToZero(actualLabourHours.total) })
            } else {
              this.weeklyLabourHours.push({ type: 'hour', left: 'Actuals Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
            }

            if (data.actualPOJO.labourPOJO.cost && !this.isEmptyObject(data.actualPOJO.labourPOJO.cost)) {
              let actualLabourCost = data.actualPOJO.labourPOJO.cost
              this.weeklyLabourCost.push({ type: 'cost', left: 'Actuals Labour', mon: Utils.checkValueExists(actualLabourCost.mon), tue: Utils.checkValueExists(actualLabourCost.tue), wed: Utils.checkValueExists(actualLabourCost.wed), thu: Utils.checkValueExists(actualLabourCost.thu), fri: Utils.checkValueExists(actualLabourCost.fri), sat: Utils.checkValueExists(actualLabourCost.sat), sun: Utils.checkValueExists(actualLabourCost.sun), total: Utils.checkValueExists(actualLabourCost.total) })
            } else {
              this.weeklyLabourCost.push({ type: 'cost', left: 'Actuals Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
            }

            if (data.targetPOJO.labourPOJO.hours && !this.isEmptyObject(data.targetPOJO.labourPOJO.hours)) {
              let budgetedLabourHours = data.targetPOJO.labourPOJO.hours
              this.weeklyLabourHours.push({ type: 'hour', left: 'Rostered Labour', mon: Utils.nullToZero(budgetedLabourHours.mon), tue: Utils.nullToZero(budgetedLabourHours.tue), wed: Utils.nullToZero(budgetedLabourHours.wed), thu: Utils.nullToZero(budgetedLabourHours.thu), fri: Utils.nullToZero(budgetedLabourHours.fri), sat: Utils.nullToZero(budgetedLabourHours.sat), sun: Utils.nullToZero(budgetedLabourHours.sun), total: Utils.nullToZero(budgetedLabourHours.total) })
            } else {
              this.weeklyLabourHours.push({ type: 'hour', left: 'Rostered Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
            }
            if (data.targetPOJO.labourPOJO.cost && !this.isEmptyObject(data.targetPOJO.labourPOJO.cost)) {
              let budgetedLabourCost = data.targetPOJO.labourPOJO.cost
              this.weeklyLabourCost.push({ type: 'cost', left: 'Rostered Labour', mon: Utils.checkValueExists(budgetedLabourCost.mon), tue: Utils.checkValueExists(budgetedLabourCost.tue), wed: Utils.checkValueExists(budgetedLabourCost.wed), thu: Utils.checkValueExists(budgetedLabourCost.thu), fri: Utils.checkValueExists(budgetedLabourCost.fri), sat: Utils.checkValueExists(budgetedLabourCost.sat), sun: Utils.checkValueExists(budgetedLabourCost.sun), total: Utils.checkValueExists(budgetedLabourCost.total) })
            } else {
              this.weeklyLabourCost.push({ type: 'cost', left: 'Rostered Labour', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, total: null })
            }

            if (data.fullTimeCostPOJO) {
              var fullTimeCostPOJO = data.fullTimeCostPOJO

              fullTimeCostPOJO.left = 'Salary Labour'
              fullTimeCostPOJO.type = 'cost'
              fullTimeCostPOJO.isPin = true
              fullTimeCostPOJO.isHide = true
              this.weeklyLabourCost.push(fullTimeCostPOJO)
            }

            if (data.fullTimeHoursPOJO) {
              var fullTimeHourPOJO = data.fullTimeHoursPOJO
              fullTimeHourPOJO.mon = Utils.nullToZero(fullTimeHourPOJO.mon)
              fullTimeHourPOJO.tue = Utils.nullToZero(fullTimeHourPOJO.tue)
              fullTimeHourPOJO.wed = Utils.nullToZero(fullTimeHourPOJO.wed)
              fullTimeHourPOJO.thu = Utils.nullToZero(fullTimeHourPOJO.thu)
              fullTimeHourPOJO.fri = Utils.nullToZero(fullTimeHourPOJO.fri)
              fullTimeHourPOJO.sat = Utils.nullToZero(fullTimeHourPOJO.sat)
              fullTimeHourPOJO.sun = Utils.nullToZero(fullTimeHourPOJO.sun)
              fullTimeHourPOJO.total = Utils.nullToZero(fullTimeHourPOJO.total)
              fullTimeHourPOJO.left = 'Salary Labour'
              fullTimeHourPOJO.type = 'hour'
              fullTimeHourPOJO.isPin = true
              fullTimeHourPOJO.isHide = true
              this.weeklyLabourHours.push(fullTimeHourPOJO)
            }




            this.tableData1 = []
            this.labourHourlyRate = []

            if (data.actualWeeklyOperationPOJO) {
              let hours = data.actualWeeklyOperationPOJO.hours
              hours.mon = Utils.checkValueExists(hours.mon)
              hours.tue = Utils.checkValueExists(hours.tue)
              hours.wed = Utils.checkValueExists(hours.wed)
              hours.thu = Utils.checkValueExists(hours.thu)
              hours.fri = Utils.checkValueExists(hours.fri)
              hours.sat = Utils.checkValueExists(hours.sat)
              hours.sun = Utils.checkValueExists(hours.sun)

              let cost = data.actualWeeklyOperationPOJO.cost
              cost.mon = Utils.checkValueExists(cost.mon)
              cost.tue = Utils.checkValueExists(cost.tue)
              cost.wed = Utils.checkValueExists(cost.wed)
              cost.thu = Utils.checkValueExists(cost.thu)
              cost.fri = Utils.checkValueExists(cost.fri)
              cost.sat = Utils.checkValueExists(cost.sat)
              cost.sun = Utils.checkValueExists(cost.sun)

              this.tableData1.push({ type: "hourly", left: "Labour +/-", mon: Utils.formatNewHour(hours.mon), monColor: hours.mon === null ? 'white' : (hours.mon <= 0 ? 'cyan' : 'red'), fri: Utils.formatNewHour(hours.fri), friColor: hours.fri === null ? 'white' : (hours.fri <= 0 ? 'cyan' : 'red'), sat: Utils.formatNewHour(hours.sat), satColor: hours.sat === null ? 'white' : (hours.sat <= 0 ? 'cyan' : 'red'), sun: Utils.formatNewHour(hours.sun), sunColor: hours.sun === null ? 'white' : (hours.sun <= 0 ? 'cyan' : 'red'), thu: Utils.formatNewHour(hours.thu), thuColor: hours.thu === null ? 'white' : (hours.thu <= 0 ? 'cyan' : 'red'), total: Utils.formatNewHour(hours.total), totalColor: hours.total === null ? 'white' : (hours.total <= 0 ? 'cyan' : 'red'), tue: Utils.formatNewHour(hours.tue), tueColor: hours.tue === null ? 'white' : (hours.tue <= 0 ? 'cyan' : 'red'), wed: Utils.formatNewHour(hours.wed), wedColor: hours.wed === null ? 'white' : (hours.wed <= 0 ? 'cyan' : 'red'), })

              this.labourHourlyRate.push({ type: "hourly", left: "Labour +/-", mon: Utils.formatNewHour(hours.mon), monColor: hours.mon === null ? 'white' : (hours.mon <= 0 ? 'cyan' : 'red'), fri: Utils.formatNewHour(hours.fri), friColor: hours.fri === null ? 'white' : (hours.fri <= 0 ? 'cyan' : 'red'), sat: Utils.formatNewHour(hours.sat), satColor: hours.sat === null ? 'white' : (hours.sat <= 0 ? 'cyan' : 'red'), sun: Utils.formatNewHour(hours.sun), sunColor: hours.sun === null ? 'white' : (hours.sun <= 0 ? 'cyan' : 'red'), thu: Utils.formatNewHour(hours.thu), thuColor: hours.thu === null ? 'white' : (hours.thu <= 0 ? 'cyan' : 'red'), total: Utils.formatNewHour(hours.total), totalColor: hours.total === null ? 'white' : (hours.total <= 0 ? 'cyan' : 'red'), tue: Utils.formatNewHour(hours.tue), tueColor: hours.tue === null ? 'white' : (hours.tue <= 0 ? 'cyan' : 'red'), wed: Utils.formatNewHour(hours.wed), wedColor: hours.wed === null ? 'white' : (hours.wed <= 0 ? 'cyan' : 'red'), })

              this.labourHourlyRate.push({ type: "labour", left: "Labour +/-", mon: Utils.formatMoneyActual(cost.mon), monColor: cost.mon === null ? 'white' : (cost.mon <= 0 ? 'cyan' : 'red'), fri: Utils.formatMoneyActual(cost.fri), friColor: cost.fri === null ? 'white' : (cost.fri <= 0 ? 'cyan' : 'red'), sat: Utils.formatMoneyActual(cost.sat), satColor: cost.sat === null ? 'white' : (cost.sat <= 0 ? 'cyan' : 'red'), sun: Utils.formatMoneyActual(cost.sun), sunColor: cost.sun === null ? 'white' : (cost.sun <= 0 ? 'cyan' : 'red'), thu: Utils.formatMoneyActual(cost.thu), thuColor: cost.thu === null ? 'white' : (cost.thu <= 0 ? 'cyan' : 'red'), total: Utils.formatMoneyActual(cost.total), totalColor: cost.total === null ? 'white' : (cost.total <= 0 ? 'cyan' : 'red'), tue: Utils.formatMoneyActual(cost.tue), tueColor: cost.tue === null ? 'white' : (cost.tue <= 0 ? 'cyan' : 'red'), wed: Utils.formatMoneyActual(cost.wed), wedColor: cost.wed === null ? 'white' : (cost.wed <= 0 ? 'cyan' : 'red'), })
            } else {
              this.tableData1.push({ type: "hourly", left: "Labour +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
              this.labourHourlyRate.push({ type: "hourly", left: "Labour +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
              this.labourHourlyRate.push({ type: "labour", left: "Labour +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
            }
            if (data.actualWeeklyOperationPOJO) {
              let rev = data.actualWeeklyOperationPOJO.rev
              rev.mon = Utils.checkValueExists(rev.mon)
              rev.tue = Utils.checkValueExists(rev.tue)
              rev.wed = Utils.checkValueExists(rev.wed)
              rev.thu = Utils.checkValueExists(rev.thu)
              rev.fri = Utils.checkValueExists(rev.fri)
              rev.sat = Utils.checkValueExists(rev.sat)
              rev.sun = Utils.checkValueExists(rev.sun)

              const roster = this.weeklyLabourHours.find(item => item.left === 'Rostered Labour')

              if (roster) {
                if (!roster.mon || roster.mon === 0) rev.mon = null
                if (!roster.tue || roster.tue === 0) rev.tue = null
                if (!roster.wed || roster.wed === 0) rev.wed = null
                if (!roster.thu || roster.thu === 0) rev.thu = null
                if (!roster.fri || roster.fri === 0) rev.fri = null
                if (!roster.sat || roster.sat === 0) rev.sat = null
                if (!roster.sun || roster.sun === 0) rev.sun = null
                if (!roster.total || roster.total === 0) rev.total = null
              }

              this.tableData1.push({ left: "Rev +/-", mon: Utils.formatMoneyActual(rev.mon), monColor: rev.mon === null ? 'white' : (rev.mon >= 0 ? 'cyan' : 'red'), fri: Utils.formatMoneyActual(rev.fri), friColor: rev.fri === null ? 'white' : (rev.fri >= 0 ? 'cyan' : 'red'), sat: Utils.formatMoneyActual(rev.sat), satColor: rev.sat === null ? 'white' : (rev.sat >= 0 ? 'cyan' : 'red'), sun: Utils.formatMoneyActual(rev.sun), sunColor: rev.sun === null ? 'white' : (rev.sun >= 0 ? 'cyan' : 'red'), thu: Utils.formatMoneyActual(rev.thu), thuColor: rev.thu === null ? 'white' : (rev.thu >= 0 ? 'cyan' : 'red'), total: Utils.formatMoneyActual(rev.total), totalColor: rev.total === null ? 'white' : (rev.total >= 0 ? 'cyan' : 'red'), tue: Utils.formatMoneyActual(rev.tue), tueColor: rev.tue === null ? 'white' : (rev.tue >= 0 ? 'cyan' : 'red'), wed: Utils.formatMoneyActual(rev.wed), wedColor: rev.wed === null ? 'white' : (rev.wed >= 0 ? 'cyan' : 'red'), })
            } else {
              this.tableData1.push({ left: "Rev +/-", mon: '-', monColor: 'white', fri: '-', friColor: 'white', sat: '-', satColor: 'white', sun: '-', sunColor: 'white', thu: '-', thuColor: 'white', total: '-', totalColor: 'white', tue: '-', tueColor: 'white', wed: '-', wedColor: 'white' })
            }
          } else {
            Utils.alert("", res.data.message, "error");
          }
        },
        cancelToken: this.sourceWeekProfitRevenueLabour.token,
      })
    },

    // 9999
    weeklyApi(dashBoardId, monDateTime, sunDateTime) {
      if (this.dataLoading) {
        this.sourceDayProfitRevenueLabour.cancel("Operationcanceled");
        this.sourceDayProfitRevenueLabour = null;
        this.sourceDayProfitRevenueLabour = CancelToken.source();

        this.sourceWeekProfitRevenueLabour.cancel("Operationcanceled");
        this.sourceWeekProfitRevenueLabour = null;
        this.sourceWeekProfitRevenueLabour = CancelToken.source();
      }

      this.dataLoading = true

      this.zoneId = sessionStorage.getItem('zoneId');
      const current = this.weekList.find((i) => i.dashBoardId == this.week || i.value == this.week)

      if (current) {
        this.startDate = current.startDate;
      }

      this.clearIntervalOfTenMinutes()
      this.clearIntervalOfTowMinutes()

      if (this.isDashboardV2 && env.NAME != 'lucas') {
        this.getWeeklyProfitRevenueLabourV2(this.startDate)
      } else {
        this.getWeeklyProfitRevenueLabour(dashBoardId, monDateTime, sunDateTime)
      }

    },
    // 9999
    isCurrentDay() {
      // var dayNum = new Date().getDay() == 0 ? 7 : new Date().getDay()
      let current
      current = this.weekList.find((item) => {
        return item.dashBoardId === this.week || item.value === this.week;
      });

      var dayNum = this.weekDay;
      var isCurrentDay = dayNum == this.dailyTrendDay ? 1 : 0

      if (current && current.value != 'THIS WEEK') {
        isCurrentDay = 0;
      }

      return isCurrentDay
    },

    getInfoDashboardV2(res) {

        this.isPastWeek = res.past;
        // Revenue
        if (this.isPastWeek || res.predictedRevenue.netAmount == null) {
           // show actual
          this.actualRevenue = res.actualRevenue.netAmount;
          this.infoActualRevenue.title = 'Actual Revenue';
        } else {
           // show predicted
          this.actualRevenue = res.predictedRevenue.netAmount;
          this.infoActualRevenue.title = 'Predicted Revenue';
        }

        // Labour
        if (this.isPastWeek || res.predictedLabour.amount == null) {
          // show actual
          this.actualRoster =   Utils.checkValueExists(res.actualLabour.amount);
          this.actualHourRoster = Utils.checkValueExists(res.actualLabour.hours);
          this.actualPercentRoster = Utils.formatSplit(res.actualLabour.revenueRatio ? (res.actualLabour.revenueRatio * 100) : 0);
          this.infoActualRoster.title = 'Actual Roster';
        } else {
          // show predicted
          this.actualRoster = Utils.checkValueExists(res.predictedLabour.amount);
          this.actualHourRoster = Utils.checkValueExists(res.predictedLabour.hours);
          this.actualPercentRoster = Utils.formatSplit(res.predictedLabour.revenueRatio ? (res.predictedLabour.revenueRatio * 100) : 0);
          this.infoActualRoster.title = 'Predicted Roster';
        }

        this.revenueTarget = Utils.checkValueExists(res.targetRevenue.netAmount);
        this.targetRoster = Utils.checkValueExists(res.targetLabour.amount);
        this.targetHourRoster = Utils.checkValueExists(res.targetLabour.hours);
        this.targetPercentRoster = Utils.formatSplit(res.targetLabour.revenueRatio ? (res.targetLabour.revenueRatio * 100) : 0);

        this.infoActualRevenue.value = Utils.formatMoney5(this.actualRevenue)
        this.infoTargetRevenue.value = Utils.formatMoney5(this.revenueTarget)
        this.infoTargetRoster.value = Utils.formatMoney5(this.targetRoster)
        this.infoActualRoster.value = Utils.formatMoney5(this.actualRoster)

        this.infoActualRoster.hours = this.actualHourRoster ? `${this.actualHourRoster}hrs` : '0hrs'
        this.infoActualRoster.percentage = this.targetPercentRoster ? `${Utils.formatSplit(this.actualPercentRoster)}%` : '0%'
        this.infoTargetRoster.hours = this.targetHourRoster ? `${this.targetHourRoster}hrs` : '0hrs'
        this.infoTargetRoster.percentage = this.targetPercentRoster ? `${Utils.formatSplit(this.targetPercentRoster)}%` : '0%'

        this.revenueMessage = res.revenueGuidance
        this.labourMessage = res.labourGuidance

        this.infoGuidance.revenueGuidance = this.revenueMessage
        this.infoGuidance.labourGuidance = this.labourMessage

        this.infoGuidance.revenueWarn = this.actualRevenue >= this.revenueTarget ? 1 : 0
        this.infoGuidance.labourWarn = this.targetRoster <= this.actualRoster ? 0 : 1
    },

    async getDayProfitRevenueLabourV2(date) {
      try {
        const res = await api.profitRevenueLabourV2(date, 'daily')

        this.$root.$emit('set-roster-display', 1)

        this.infoGuidance.title = 'Daily Guidance'

        if (res) {
          this.getInfoDashboardV2(res)
        }

        this.dataLoading = false

      } catch (error) {
        this.dataLoading = false

        this.infoTargetRoster.value = Utils.formatMoney5(null)
        this.infoTargetRevenue.value = Utils.formatMoney5(null)
        this.infoActualRevenue.value = Utils.formatMoney5(null)

        Utils.alert2('', 'Something went wrong, please contact administrator.', 'error')
      }

    },

    getDayProfitRevenueLabour(day, weekname, dashBoardId, monDateTime, sunDateTime) {
      api.dayProfitRevenueLabour({
          params: {
            weekname, dashBoardId, monDateTime, sunDateTime
          },
          callback: (res) => {
            this.dataLoading = false
            if (res.data.code === 0) {
              this.zoneId = res.data.data.zoneId

              let data = res.data.data
              if (!this.isThisWeek && data.actualPOJO.actualRevenue) {
                this.actualRevenue = data.actualPOJO.actualRevenue
              } else if (this.isThisWeek && !this.isCurrentDay()) {
                // this.actualRevenue = data.actualPOJO.actualRevenue
              }

              this.actualRevenue = (data && data.targetPOJO) ? data.actualPOJO.actualRevenue : null
              this.revenueTarget = (data && data.targetPOJO) ? data.targetPOJO.revenueTarget : null

              this.targetRoster = (data && data.targetPOJO) ? data.targetPOJO.rosterTargetPOJO.cost : null
              if (this.targetRoster) {
                data.targetPOJO.labourPOJO.cost
              }
              this.targetHourRoster = (data && data.targetPOJO) ? data.targetPOJO.rosterTargetPOJO.hours : null
              this.actualRoster = (data && data.actualPOJO) ? data.actualPOJO.labourPOJO.cost : null
              this.actualHourRoster = (data && data.actualPOJO) ? data.actualPOJO.labourPOJO.hours : null

              if (data.todayCloseFlag && !this.isCurrentDay()) {
                if (this.actualRoster === null || this.actualRevenue === null)
                  this.actualPercentRoster = null
                else if (this.actualRoster === 0 || this.actualRevenue === 0)
                  this.actualPercentRoster = '0.00'
                else

                  this.actualPercentRoster = Utils.formatSplit((this.actualRoster / this.actualRevenue) * 100)
              } else {
                if (this.actualRoster === null || this.revenueTarget === null)
                  this.actualPercentRoster = null
                else if (this.actualRoster === 0 || this.revenueTarget === 0)
                  this.actualPercentRoster = '0.00'
                else
                  // var actualPercentRoster = Utils.checkValueExists(data.targetPercentRoster)
                  var actualPercentRoster = ((this.actualRoster / this.revenueTarget) * 100)
                // if (!actualPercentRoster) {
                //   actualPercentRoster = this.actualRoster / this.actualRevenue * 100
                // }
                this.actualPercentRoster = Utils.formatSplit(actualPercentRoster)
              }

              if (data.todayCloseFlag && !this.isCurrentDay()) {
                if (this.targetRoster === null || this.actualRevenue === null)
                  this.targetPercentRoster = null
                else if (this.targetRoster === 0 || this.actualRevenue === 0)
                  this.targetPercentRoster = '0.00'
                else
                  this.targetPercentRoster = Utils.formatSplit((this.targetRoster / this.actualRevenue) * 100)
              } else {
                if (this.targetRoster === null || this.revenueTarget === null)
                  this.targetPercentRoster = null
                else if (this.targetRoster === 0 || this.revenueTarget === 0)
                  this.targetPercentRoster = '0.00'
                else
                  // var targetPercentRoster = Utils.checkValueExists(data.targetPercentRoster)
                  var targetPercentRoster = ((this.targetRoster / this.revenueTarget) * 100)
                // if (!targetPercentRoster) {
                //   targetPercentRoster = this.targetRoster / this.revenueTarget * 100
                // }
                this.targetPercentRoster = Utils.formatSplit(targetPercentRoster)
              }

              this.infoActualRevenue.title = 'Actual Revenue'
              if (this.isCurrentDay()) {
                this.infoActualRoster.title = 'Predicted Roster'
              } else {
                this.infoActualRoster.title = 'Actual Roster'
              }

              if (this.currentWeekType == 'THIS WEEK') {
                if (day <= this.weekDay) {
                  this.infoActualRevenue.title = 'Actual Revenue'
                } else {
                  this.infoActualRevenue.title = 'Predicted Revenue'
                }

                if (day < this.weekDay) {
                  this.infoActualRoster.title = 'Actual Roster'
                } else {
                  this.infoActualRoster.title = 'Predicted Roster'
                }
              }

              this.$root.$emit('set-roster-display', 1)
              this.infoActualRoster.value = Utils.formatMoney5(this.actualRoster)
              this.infoTargetRoster.value = Utils.formatMoney5(this.targetRoster)
              this.infoTargetRevenue.value = Utils.formatMoney5(this.revenueTarget)
              this.infoActualRevenue.value = Utils.formatMoney5(this.actualRevenue)
              this.infoTargetRoster.title = 'Roster'

              this.infoActualRoster.hours = this.actualHourRoster ? `${this.actualHourRoster}hrs` : '0hrs'
              this.infoActualRoster.percentage = this.targetPercentRoster ? `${Utils.formatSplit(this.actualPercentRoster)}%` : '0%'
              this.infoTargetRoster.hours = this.targetHourRoster ? `${this.targetHourRoster}hrs` : '0hrs'
              this.infoTargetRoster.percentage = this.targetPercentRoster ? `${Utils.formatSplit(this.targetPercentRoster)}%` : '0%'

              this.labourHoursGuidance = data.labourHoursGuidance
              this.revenueGuidance = data.revenueGuidance
              this.revenueMessage = data.revenueMessage
              this.labourMessage = data.labourMessage

              this.infoGuidance.title = 'Daily Guidance'
              this.infoGuidance.revenueGuidance = this.revenueMessage
              this.infoGuidance.labourGuidance = this.labourMessage
              this.infoGuidance.revenueWarn = this.revenueGuidance > 0 ? 1 : 0
              // this.infoGuidance.labourWarn = this.labourHoursGuidance <= 0 ? 1 : 0

              // this.infoGuidance.revenueWarn = this.actualRevenue >= this.revenueTarget ? 1 : 0
              this.infoGuidance.labourWarn = this.targetRoster <= this.actualRoster ? 0 : 1


              //   this.infoGuidance.revenueWarn = this.revenueGuidance > 0 ? 1 : 0
              // this.infoGuidance.labourWarn = this.labourHoursGuidance <= 0 ? 1 : 0
              // 按钮的显示与否
              if (data.isQueryTemporary !== undefined && data.isQueryTemporary !== null)
                this.showButton = data.isQueryTemporary === 0 ? true : false;
            } else {
              this.infoActualRoster.value = Utils.formatMoney5(null)
              this.infoTargetRoster.value = Utils.formatMoney5(null)
              this.infoTargetRevenue.value = Utils.formatMoney5(null)
              this.infoActualRevenue.value = Utils.formatMoney5(null)
              Utils.alert("", res.data.message, "error");
            }
          },
          cancelToken: this.sourceDayProfitRevenueLabour.token,
        })
    },

    async dayChangeEvt(day, dashBoardId, monDateTime, sunDateTime, partialFresh) {

      this.dailyTrendDay = day

      this.eodParams = {
        day: day,
        dashBoardId: dashBoardId,
        monDateTime: monDateTime,
        sunDateTime: sunDateTime,
      }

      this.zoneId = sessionStorage.getItem('zoneId');
      const current = this.weekList.find((i) => i.dashBoardId == this.week || i.value == this.week)

      if (current) {
        const startDate = current.startDate;
        const dayToAdd = (day - 1);
        this.startDate = startDate;
        this.currentSelectedDate = Utils.addDaysToDate(startDate, dayToAdd, this.zoneId)
        this.currentWeekType = current.value;
      }

      this.initUpdateWeeklyRevenue();
      this.initUpdateTargetRevenue();
      this.clearDatum(partialFresh)
      if (!monDateTime)
        return
      // 如果正在加载，终止之前的请求
      if (this.dataLoading) {
        this.sourceDayProfitRevenueLabour.cancel("Operationcanceled");
        this.sourceDayProfitRevenueLabour = null;
        this.sourceDayProfitRevenueLabour = CancelToken.source();

        this.sourceWeekProfitRevenueLabour.cancel("Operationcanceled");
        this.sourceWeekProfitRevenueLabour = null;
        this.sourceWeekProfitRevenueLabour = CancelToken.source();
      }
      let weekname = Utils.getWeekname(day)
      if (!partialFresh || partialFresh !== 'onlyFreshChartNotIncludingDatum') {
        this.dataLoading = true

        // Clear previous polling and restart with 10 seconds
        if (this.intervalOfTenMinutes) {
          this.clearIntervalOfTenMinutes()
          this.openIntervalOfTenMinutes()
        }

        if (this.isDashboardV2 && env.NAME != 'lucas') {
          this.getDayProfitRevenueLabourV2(this.currentSelectedDate)
        } else {
          this.getDayProfitRevenueLabour(day, weekname, dashBoardId, monDateTime, sunDateTime)
        }


      }

      // 图表也要变化
      if (!partialFresh || partialFresh !== 'onlyFreshDatumNotIncludingChart') {
        this.$root.$emit('show-revenue-graph')
        const data = {
          dashBoardId: dashBoardId,
          monDateTime: monDateTime,
          sunDateTime: sunDateTime
        }
        // this.dailyTrendDatum(day, null, data)

        this.labourDailyTrendData(day, data);
        this.revenueDailyTrendData(day, data);
      }
    },
    // 把页面数据清空的方法
    clearDatum(partialFresh) {
      var that = this;
      if (!partialFresh || partialFresh !== 'onlyFreshChartNotIncludingDatum') {
        that.labourHoursGuidance = null //
        that.revenueMessage = null //
        that.revenueGuidance = null //
        that.labourMessage = null //
        that.revenueTarget = null//
        that.actualRevenue = null//
        that.actualPercentRoster = null //

        that.targetHourRoster = null//
        that.targetRoster = null//
        that.targetPercentRoster = null //

        that.actualHourRoster = null//
        that.actualRoster = null//
        that.tableData1 = [] //
        that.labourHourlyRate = [] //
        that.weeklyLabourHours = [] //
        that.weeklyLabourCost = []//
        that.showButton = false; //
      }
      if (!partialFresh || partialFresh !== 'onlyFreshDatumNotIncludingChart')
        that.dailyTrendChartDatum = {}
      that.dailyTrendLabourChartDatum = {}
      if (!partialFresh) {
        that.showLastWeekEstimateButton = false
        that.showSecondSentance = false
        that.loading = false;
        that.showTargetHourRoster = 1
        that.showActualRosterHour = 1
      }
    },

    typeChangeEvt(type, toRequest, partialFresh, day) {
      this.currentChosen = type
      this.clearDatum(partialFresh)
      if (this.week === -1 || this.week === -2 || this.week === -3 || !this.current_params.monDateTime) {
        return
      }
      let current
      current = this.weekList.find((item) => {
        return item.dashBoardId === this.week || item.value === this.week;
      });

      if (!current.monDateTime)
        return
      // 如果选中daily，要判断当前是什么周，last 还是 this
      if (this.currentChosen === 0) {
        // 判断当前是什么周，last week
        if (current.value === 'THIS WEEK') {
          // const nowDay = new Date(), curDay = nowDay.getDay() === 0 ? 7 : nowDay.getDay();//获取当天是周几
          const nowDay = new Date(), curDay = this.weekDay;//获取当天是周
          this.dayChangeEvt(day !== null && day !== undefined ? day : curDay, this.week, this.current_params.monDateTime, this.current_params.sunDateTime, partialFresh)
        } else if (current.value === 'LAST WEEK' || current.value !== 'NEXT WEEK') {

          this.dayChangeEvt(this.dailyTrendDay, this.week, this.current_params.monDateTime, this.current_params.sunDateTime, partialFresh)
        }
              } else {
        // 调用weekly 接口
        if (toRequest === 'no')
          return
        if (!this.current_params.monDateTime && (this.week === 'THIS WEEK' || this.week === 'LAST WEEK' || this.week === 'LAST WEEK'))
          return
        this.weeklyApi(this.week, this.current_params.monDateTime, this.current_params.sunDateTime)
      }
    },
    requestDatum(list, val) {

      let current
      current = list.find((item) => {
        return (item.dashBoardId === val || item.value === val);
      });

      this.selectedWeek = current
      this.eodEnable = current.value == 'THIS WEEK' || current.value == 'LAST WEEK' ? true : false
      this.isThisWeek = current.value == 'THIS WEEK' ? true : false

      if (!current) {
        this.reload()
        return
      }
      this.fourWeeksAvg = null;
      this.$emit("fourWeeksAvgEvt", null);

      let request_params = {
        dashBoardId: val,
        monDateTime: current.monDateTime,
        sunDateTime: current.sunDateTime,
        value: current.value
      }
      this.current_params = request_params
      this.loading = true


      this.weekList = list
      // 只有last week / this week 能选择具体天
      // 切换周，自动回到daily，this week默认今天，Last week默认周一
      // 判断当天是this week / last week，或者其他周
      if (current.value === 'THIS WEEK') {
        // const nowDay = new Date(), curDay = nowDay.getDay() === 0 ? 7 : nowDay.getDay();//获取当天是周几
        const nowDay = new Date(), curDay = this.weekDay;
        this.dayChangeEvt(curDay, val, current.monDateTime, current.sunDateTime)
      } else if (current.value === 'LAST WEEK' || current.value !== 'NEXT WEEK') {
        this.dayChangeEvt(1, val, current.monDateTime, current.sunDateTime)
      } else {
        // 调用weekly 接口
        this.weeklyApi(val, current.monDateTime, current.sunDateTime)
      }

      // 获取Sync latest按钮下面的时间，以及判断Sync latest按钮是否可以点击
      api.getSycLastTime({
        callback: this.sycLastTimeCallback
      })
      // 首页重构后新加的接口
      /*api.getDashBoardTargetActual({
        params: request_params,
        callback: this.dashBoardTargetActualCallback
      })
      api.getDashBoardThirdParty({
        params: request_params,
        callback: this.dashBoardThirdPartyCallback
      })*/

      /*if (!this.showDeputyCycle) {
        this.revenueWeekDatum(1, null, request_params)
        this.d1ailyTrendDatum(lastOrThisDay ? lastOrThisDay : null, null, request_params)
      } else {
        this.revenueWeekDatum(this.weekStart, null, request_params)
        this.d1ailyTrendDatum(lastOrThisDay ? lastOrThisDay : null, null, request_params)
      }*/
      if (this.isShowDeputyCycleChecked) {
        var data = {
          list: this.options,
          current: current.value,
          weekStart: this.weekStart,
          isShowDeputyCycleChecked: this.isShowDeputyCycleChecked
        }
        this.currentWeek = Utils.calculateWeeks(data)
      } else {
        this.currentWeek = this.$box.loadWeekDatum(current.monDateTime)
      }

      if (current.value === 'THIS WEEK')
        this.loadDatum(current)
    },
    evtFromChart(from, value, day) {
      if (from === 'actualEhart') {
        this.revenueWeekTrendValue = value
        // this.revenueWeekDatum(null, value, this.current_params)
      } else if (from === 'echart') {
        this.dailyTrendTrendValue = value
        // this.dailyTrendDatum(day, value, this.current_params)
        this.labourDailyTrendData(day, this.current_params);
        this.revenueDailyTrendData(day, this.current_params);
      }
    },
    // 请求数据每周收入-劳动力趋势图
    /*revenueWeekDatum(w, t, request_params){
      let weekStart = w ? w : this.weekStart
      let type = t ? t : this.revenueWeekTrendValue
      this.revenueWeekTrendLoading = true
      api.revenueWeekTrendApi({
        params: {
          type,
          // weekDayIndex: weekStart,
          data: request_params
        },
        callback: (res) => {
          this.revenueWeekTrendLoading = false
          if (res.data.code === 0) {
            this.revenueWeekChartDatum = res.data.data
          } else {
            Utils.alert("", res.data.message, "error");
          }
        }
      })
    },*/

    getActualLabourOnGraph(actualDataList = []) {
      const result = actualDataList.filter(item => {
        if (item.cost && item.isOpen) {

          var getTimeOfTimezone = Utils.getTimeOfTimezone(new Date(), this.zoneId);
          getTimeOfTimezone = getTimeOfTimezone.replace(':', '')
          getTimeOfTimezone = parseInt(getTimeOfTimezone)

          var graphTime = Utils.dateTimeGeneratorWithDay(new Date(), this.zoneId)

          var getCurrentDay = new Date(graphTime).getDay() != 0 ? new Date(graphTime).getDay() : 7

          var labelHoursTime = item.labelHours.replace(':', '')
          labelHoursTime = parseInt(labelHoursTime) - 15

          if (this.dailyTrendDay == getCurrentDay && this.isThisWeek) {

            if (getTimeOfTimezone >= labelHoursTime) {
              return true;
            } else {
              return false;
            }
          } else {
            return true
          }
        } else {
          return false;
        }
      });

      if (result.length > 0) {
        return result[result.length - 1]
      }
      return 0;
    },
    revenueDailyTrendData(w, request_params) {
      if (this.dailyTrendLoading) {
        this.sourceDailyTrendApi.cancel("Operationcanceled");
        this.sourceDailyTrendApi = null;
        this.sourceDailyTrendApi = CancelToken.source();
      }

      let day = w ? w : this.dailyTrendDay

      this.dailyTrendLoading = true
      this.dailyTrendData('revenue', day, request_params)
    },

    labourDailyTrendData(w, request_params) {
      if (this.dailyTrendLoadingLabour) {
        this.sourceDailyLabourTrendApi.cancel("Operationcanceled");
        this.sourceDailyLabourTrendApi = null;
        this.sourceDailyLabourTrendApi = CancelToken.source();
      }

      let day = w ? w : this.dailyTrendDay

      this.dailyTrendLoadingLabour = true
      this.dailyTrendData('labour', day, request_params)
    },

    dailyTrendData(type, day, request_params) {
      let currentDay = this.weekDay
      api.dailyTrendApi({
        params: {
          type,
          weekDayIndex: day,
          data: request_params
        },
        callback: (res) => {

          if (res.data && res.data.code === 0) {

            if (type == 'labour') {

              // this.dailyTrendLoadingLabour = false;

              if (res.data.data && res.data.data.actualHoursCostPOJOList && res.data.data.actualHoursCostPOJOList.length > 0) {
                const actualLabourRes = this.getActualLabourOnGraph(res.data.data.actualHoursCostPOJOList);
                if (actualLabourRes) {
                  this.actualLabourCost = actualLabourRes.cost;
                }
              }
            }

            if (type == 'revenue') {
              // this.dailyTrendLoading = false

              if (day != currentDay) {
                this.actualRevenue = res.data.data.actualRevenue_today
              }
              this.revenueTarget = res.data.data.revenueTarget_today
            }

            // changes
            let result = res.data.data;

            if (result.actualHoursCostPOJOList && result.actualHoursCostPOJOList.length > 0) {
              result.actualHoursCostPOJOList = this.filterUniqueItems(result.actualHoursCostPOJOList, 'labelHours')
            }

            if (result.revenueTargetPOJOList_today && result.revenueTargetPOJOList_today.length > 0) {
              result.revenueTargetPOJOList_today = this.filterUniqueItems(result.revenueTargetPOJOList_today, 'labelHours')
            }

            if (type == 'labour') {
              this.dailyTrendLabourChartDatum = result;
            } else {
              this.dailyTrendChartDatum = result;
            }
          } else {
            if (res.data) {
              Utils.alert("", res.data.message, "error");
            }
          }
        },
        cancelToken: type == 'labour' ? this.sourceDailyLabourTrendApi.token : this.sourceDailyTrendApi.token,
      })
    },

    dailyTrendDatum(w, t, request_params) {

      if (this.dailyTrendLoading) {

        this.sourceDailyTrendApi.cancel("Operationcanceled");
        this.sourceDailyTrendApi = null;
        this.sourceDailyTrendApi = CancelToken.source();
      }

      let day = w ? w : this.dailyTrendDay

      let type = t ? t : this.dailyTrendTrendValue
      let currentDay = this.weekDay



      this.dailyTrendLoading = true




      api.dailyTrendApi({
        params: {
          type,
          weekDayIndex: day,
          data: request_params
        },
        callback: (res) => {

          if (res.data.code === 0) {

            if (type == 'labour') {

              this.dailyTrendLoadingLabour = false;
              if (res.data.data && res.data.data.actualHoursCostPOJOList.length > 0) {
                const actualLabourRes = this.getActualLabourOnGraph(res.data.data.actualHoursCostPOJOList);
                if (actualLabourRes) {
                  this.actualLabourCost = actualLabourRes.cost;
                }
              }
            }


            if (type == 'revenue') {
              this.dailyTrendLoading = false
              if (day != currentDay) {
                this.actualRevenue = res.data.data.actualRevenue_today
              }
              this.revenueTarget = res.data.data.revenueTarget_today
            }
            // 清掉之前的轮询，重新开启10秒
            if (this.intervalOfTowMinutes)
              this.clearIntervalOfTowMinutes()
            if (this.currentChosen === 0)
              this.openIntervalOfTowMinutes()

            // changes
            let result = res.data.data;

            if (result.actualHoursCostPOJOList && result.actualHoursCostPOJOList.length > 0) {
              result.actualHoursCostPOJOList = this.filterUniqueItems(result.actualHoursCostPOJOList, 'labelHours')
            }

            if (result.revenueTargetPOJOList_today && result.revenueTargetPOJOList_today.length > 0) {
              result.revenueTargetPOJOList_today = this.filterUniqueItems(result.revenueTargetPOJOList_today, 'labelHours')
            }
            if (type == 'labour') {
              this.dailyTrendLabourChartDatum = result;
            } else {
              this.dailyTrendChartDatum = result;
            }
            // this.dailyTrendChartDatum = result;

            // 清掉之前的轮询，重新开启10秒
            if (!this.intervalOfTowMinutes) {
              this.openIntervalOfTowMinutes()
            }
            // if (this.currentChosen === 0) {
            //   this.openIntervalOfTowMinutes()
            //   console.log(this.currentChosen, 'this.currentChosen 2')
            // }

          } else {
            Utils.alert("", res.data.message, "error");
          }
        },
        cancelToken: this.sourceDailyTrendApi.token,
      })


    },

    async getActualLabour(w, t, request_params) {
      if (this.dailyTrendLoadingLabour) {
        this.sourceDailyTrendApi.cancel("Operationcanceled");
        this.sourceDailyTrendApi = null;
        this.sourceDailyTrendApi = CancelToken.source();
      }

      let day = w ? w : this.dailyTrendDay

      let type = t ? t : this.dailyTrendTrendValue

      const result = await api.getActualRevenueLabour({
        params: {
          type,
          weekDayIndex: day,
          data: request_params
        },
        cancelToken: this.sourceDailyTrendApi.token,
      })

      var res = result
      if (res.data.code === 0) {

        if (type == 'labour') {
          if (res.data.data && res.data.data.actualHoursCostPOJOList && res.data.data.actualHoursCostPOJOList.length > 0) {
            const actualLabourRes = this.getActualLabourOnGraph(res.data.data.actualHoursCostPOJOList);
            if (actualLabourRes) {
              this.actualLabourCost = actualLabourRes.cost;
            }
          }
        }

      } else {
        Utils.alert("", res.data.message, "error");
      }

      // api.dailyTrendApi({

      //   callback: (res) => {
      //     if (res.data.code === 0) {

      //       if (type == 'labour') {
      //         if (res.data.data && res.data.data.actualHoursCostPOJOList.length > 0) {
      //           const actualLabourRes = this.getActualLabourOnGraph(res.data.data.actualHoursCostPOJOList);
      //           if (actualLabourRes) {
      //             this.actualLabourCost = actualLabourRes.cost;
      //           }
      //         }
      //       }

      //     } else {
      //       Utils.alert("", res.data.message, "error");
      //     }
      //   },
      //   cancelToken: this.sourceDailyTrendApi.token,
      // })
    },

    filterUniqueItems(arr, prop) {
      return arr.filter((obj, index, self) => {
        return self.findIndex((o) => o[prop] === obj[prop]) === index;
      });
    },

    syncLatestOperate() {
      if (this.getSycLastTime.enableFlag !== 'true')
        return
      this.getSycLastTime.enableFlag = false
      api.syncLatestApi({
        callback: (res) => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Utils.alert("", res.data.message, "error");
          }
        }
      })
    },
    sycLastTimeCallback(res) {
      if (res.data.code === 0) {
        let data = res.data.data
        let now = (new Date()).getTime() / 1000
        let text = ''
        if (now - Number(data.sycLastTime) < 120)
          text = '1 minute ago'
        else if ((now - Number(data.sycLastTime) >= 120) && (now - Number(data.sycLastTime) < 3600))
          text = `${parseInt((now - Number(data.sycLastTime)) / 60)} minutes ago`
        else {
          let hour = parseInt((now - Number(data.sycLastTime)) / 3600)
          text = `${hour} hour${hour > 1 ? 's' : ''} ago`
        }
        //console.log(text)
        this.getSycLastTime = {
          // sycLastTime: Utils.timeFotmatDetail(data.sycLastTime),
          sycLastTime: text,
          enableFlag: data.enableFlag
        }
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },
    /*dashBoardTargetActualCallback(res) {
      var that = this;
      if (res.data.code === 0) {
        let data = res.data.data
        that.actualRevenue_today = data.actualRevenue_today
        that.actualRoster_today = data.actualRoster_today
        that.revenueTarget_today = data.revenueTarget_today
        that.targetRoster_today = data.targetRoster_today

        that.actualRevenue = data.actualRevenue
        that.revenueTarget = data.revenueTarget
        that.targetRoster = data.targetRoster
        that.actualRoster = data.actualRoster
        if (data.actualRoster !== null && data.revenueTarget !== null)
          that.actualHourRoster = Utils.formatSplit((data.actualRoster / data.revenueTarget) * 100) + '%'
        else
          that.actualHourRoster = '-'

        that.revenueDeviationTarget = data.revenueDeviationTarget
        that.revenueDeviationProportion = data.revenueDeviationProportion
        that.labourDeviation = data.labourDeviation
        that.labourDeviationProportion = data.labourDeviationProportion

        that.dailyGGuidancePojo = data.dailyGGuidancePojo
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },*/
    changeShowActualRoster() {
      var that = this
      if (that.showActualRosterHour === 3)
        that.showActualRosterHour = 1
      else
        that.showActualRosterHour++
    },
    changeShowTargetRoser() {
      var that = this
      if (that.showTargetHourRoster === 3)
        that.showTargetHourRoster = 1
      else
        that.showTargetHourRoster++
    },

    openWeeklyReport(weeklyReportType, weeklyReportLabel) {
      this.weeklyReportVisibility = true;
      this.weeklyReportType = weeklyReportType
      this.weeklyReportLabel = weeklyReportLabel
    },


    async openEod(type) {
      if (!type) {
        type = this.isEodSplitActivated ? 'lunch' : 'dinner'
      }
      this.isLoadingEod = true

      var current = this.eodParams
      var weekname = Utils.getWeekname(current.day)
      var dashBoardId = current.dashBoardId
      var monDateTime = current.monDateTime
      var sunDateTime = current.sunDateTime
      current.weekname = weekname
      this.currentEodParams = current

      this.getEmployeeVariance(weekname, dashBoardId, monDateTime, sunDateTime)

      const eodSetting = await api.getEodSetting()
      if (eodSetting.data.code == 0) {
        var n = eodSetting.data.data
        var settings = {
          bevService: n.bevService ? 1 : 0,
          compExp: n.compExp ? 1 : 0,
          compValue: n.compValue ? 1 : 0,
          largeParties: n.largeParties ? 1 : 0,
          managerService: n.managerService ? 1 : 0,
          labourWeekToDate: n.labourWeekToDate ? 1 : 0,
          others: n.others ? 1 : 0,
          repairs: n.repairs ? 1 : 0,
          staff: n.staff ? 1 : 0,
          training: n.training ? 1 : 0,
          uploadImage: n.uploadImage ? 1 : 0,
          venueVibe: n.venueVibe ? 1 : 0,
          vip: n.vip ? 1 : 0,
          whs: n.whs ? 1 : 0,
          isEditCover: n.isEditCover ? 1 : 0,
          accommodationRevenue: n.accommodationRevenue ? 1 : 0,
          accommodationRate: n.accommodationRate ? 1 : 0,
          purchases: n.purchases ? 1 : 0,
          weekToDate: n.weekToDate ? 1 : 0,
          weatherRecords: n.weatherRecords ? 1 : 0,
          execSummary: n.execSummary ? true : false,
          usedRoomsCountToggle: n.usedRoomsCountToggle ? true : false,
          availableRoomsCountToggle:  n.availableRoomsCountToggle ? true : false,
          accommodationRevenueLabel: n.accommodationRevenueLabel ? n.accommodationRevenueLabel : 'Purchases',
          accommodationRateLabel: n.accommodationRateLabel ? n.accommodationRateLabel : 'Week to date total',
          execSummaryLabel: n.execSummaryLabel ? n.execSummaryLabel : 'Exec Summary',
          managerServiceLabel: n.managerServiceLabel ? n.managerServiceLabel : 'Manager Service Notes',
          labourWeekToDateLabel: n.labourWeekToDateLabel ? n.labourWeekToDateLabel : 'Labour WTD',
          bevServiceLabel: n.bevServiceLabel ? n.bevServiceLabel : 'Bev Service Notes',
          venueVibeLabel: n.venueVibeLabel ? n.venueVibeLabel : 'Venue Vibe / Energy FOH',
          weatherRecordsLabel: n.weatherRecordsLabel ? n.weatherRecordsLabel : 'Weather record',
          largePartiesLabel: n.largePartiesLabel ? n.largePartiesLabel : 'Large Parties / Events',
          vipLabel: n.vipLabel ? n.vipLabel : 'VIP',
          staffLabel: n.staffLabel ? n.staffLabel : 'Staff',
          trainingLabel: n.trainingLabel ? n.trainingLabel : 'Training',
          compExpLabel: n.compExpLabel ? n.compExpLabel : 'Comp Explanations',
          whsLabel: n.whsLabel ? n.whsLabel : 'WHS, Employee Incidental, & Safety Notes',
          repairsLabel: n.repairsLabel ? n.repairsLabel : 'Repairs & Maint / IT Issues',
          othersLabel: n.othersLabel ? n.othersLabel : 'OTHER: any other feedback etc.',
          purchasesLabel: n.purchasesLabel ? n.purchasesLabel : 'Purchases',
          weekToDateLabel: n.weekToDateLabel ? n.weekToDateLabel : 'Week to date total',
          weekToDateLabel: n.weekToDateLabel ? n.weekToDateLabel : 'Week to date total',
          usedRoomsCountLabel: n.usedRoomsCountLabel ? n.usedRoomsCountLabel : 'Room Used',
          availableRoomsCountLabel: n.availableRoomsCountLabel ? n.availableRoomsCountLabel : 'Available Rooms'
        }

        this.eodSettings = settings

      } else {
        var data = {
          bevService: 1,
          compExp: 1,
          compValue: 1,
          largeParties: 1,
          managerService: 1,
          labourWeekToDate: 1,
          others: 1,
          repairs: 1,
          staff: 1,
          training: 1,
          uploadImage: 1,
          venueVibe: 1,
          vip: 1,
          whs: 1,
          isEditCover: 1,
          accommodationRevenue: 1,
          accommodationRate: 1,
          purchases: 1,
          weekToDate: 1,
          weatherRecords: 1,
          managerServiceLabel: 'Manager Service Notes',
          labourWeekToDateLabel: 'Labour WTD',
          bevServiceLabel: 'Bev Service Notes',
          venueVibeLabel: 'Venue Vibe / Energy FOH',
          weatherRecordsLabel: 'Weather record',
          largePartiesLabel: 'Large Parties / Events',
          vipLabel: 'VIP',
          staffLabel: 'Staff',
          trainingLabel: 'Training',
          compExpLabel: 'Comp Explanations',
          whsLabel: 'WHS, Employee Incidental, & Safety Notes',
          repairsLabel: 'Repairs & Maint / IT Issues',
          othersLabel: 'OTHER: any other feedback etc.',
          accommodationRevenueLabel: 'Purchases',
          accommodationRateLabel: 'Accommodation Revenue',
          purchasesLabel: 'Purchases',
          weekToDateLabel: 'Week to date total',
        }

        this.eodSettings = data
      }

      var dateParam = Utils.getCurrentDate(current, this.dailyTrendDay, this.zoneId, 'yyyyMMDD')

      this.eodData = {
        actualRoster: this.actualRoster,
        revenueTarget: this.revenueTarget,
        targetRoster: this.targetRoster,
        actualRevenue: this.actualRevenue
      }

      let eodHistory = null
      //api.getEodData - old get eod data

      api.getEodDataNew(dateParam, type).then((res) => {
        this.eodData.periodicData = this.getPeriodicHistory(res.data.data.periodicReportHistoryList)
        this.eodData.triggerData = this.getPeriodicHistory(res.data.data.periodicReportHistoryList, 1)
        this.eodData.reportDate = Utils.getCurrentDate(current, this.dailyTrendDay, this.zoneId, 'ddd MMMM DD, yyyy')
        this.eodData.reportDateFormatted = Utils.getCurrentDate(current, this.dailyTrendDay, this.zoneId, 'yyyyMMDD')
        this.eodParams.reportDate = Utils.getCurrentDate(current, this.dailyTrendDay, this.zoneId, 'ddd MMMM DD, yyyy')
        if (res.data.data.eodHistory) {
          eodHistory = res.data.data.eodHistory
          eodHistory.fileList = res.data.data.reportDocumentsList ? res.data.data.reportDocumentsList : [];
        } else {

        }

        const incomeType = 0
        api.getActualIncome({
          params: {
            incomeType, monDateTime, sunDateTime
          },
          callback: async (actualIncomeResult) => {
            if (actualIncomeResult.data.code == 0) {
              const response = actualIncomeResult.data.data.list
              const revenueList = response.find((n) => n.expensesType == 1)

              let calculatedRevenueTotal = 0
              this.calculatedRevenue = 0
              if (revenueList) {
                let total = {
                  mon: 0, tue: 0, wed: 0, thu: 0, fri: 0, sat: 0, sun: 0
                }
                revenueList.actualIncomeList.forEach(item => {
                  if (item.incomeName != 'Tips' && item.incomeName != 'Gratuity' && item.incomeName != 'Mr Yum') {
                    if (!item.parentRevenue) {
                      total.mon += Utils.nullToZero(item.mon)
                      total.tue += Utils.nullToZero(item.tue)
                      total.wed += Utils.nullToZero(item.wed)
                      total.thu += Utils.nullToZero(item.thu)
                      total.fri += Utils.nullToZero(item.fri)
                      total.sat += Utils.nullToZero(item.sat)
                      total.sun += Utils.nullToZero(item.sun)
                    }
                  }
                });
                if (current.day >= 1) {
                  for (var i = 1; i <= current.day; i++) {
                    const revenue = total[Utils.getWeekname(i)] ? total[Utils.getWeekname(i)] : 0
                    calculatedRevenueTotal += revenue
                  }
                }
              }
              this.calculatedRevenue = calculatedRevenueTotal
            }

            this.eodVisibility = true
            this.isLoadingEod = false
            this.eodHistory = eodHistory
          }
        })

      })


      var day = this.dailyTrendDay ? this.dailyTrendDay : 7
      // Run daily trend Datum
      this.getActualLabour(day, 'labour', this.current_params)

      // Get weekly data
      var platform = ''
      if (this.kseriesBind) {
        platform = 'kseries'
      } else if (this.oseriesFlag) {
        platform = 'oseries'
      } else if (this.deputyFlag) {
        platform = 'doshii'
      } else if (this.bindHandl) {
        platform = 'handl'
      } else if (this.redcatFlag) {
        platform = 'redcat'
      } else if (this.idealposCsvFlag) {
        platform = 'idealpos'
      } else if (this.imposCsvFlag) {
        platform = 'impos'
      } else if (this.squareFlag) {
        platform = 'square'
      } else if (this.bepozCsvFlag) {
        platform = 'bepoz'
      } else if (this.oolioFlag) {
        platform = 'oolio'
      } else if (this.swiftPosFlag) {
        platform = 'swiftpos'
      }


      var extensionParams = {
        platform: platform,
        today: Utils.getCurrentDate(current, this.dailyTrendDay, this.zoneId)
      }

      this.totalSummary = null
      api.weekProfitRevenueLabour({
        params: {
          dashBoardId,
          monDateTime,
          sunDateTime,
          extensionParams
        },
        callback: (res) => {
          this.dataLoading = false
          if (res.data.code === 0) {
            this.totalSummary = {}
            const data = res.data.data;
            this.weeklyData = data;
            if (data && data.targetPOJO.labourPOJO) {

              if (data.allTimeCostPOJO && data.allTimeCostPOJO[weekname]) {
                this.targetLabourData = data.allTimeCostPOJO[weekname];
              } else {
                this.targetLabourData = null;
              }

              this.weeklyDay = weekname
              this.weeklyFullTimeCost = data.fullTimeCostPOJO;
            }

            this.totalSummary.totalCover = Utils.checkValueExists(data.totalCover) ? data.totalCover : ''
            this.totalSummary.totalFood = Utils.checkValueExists(data.totalFood) ? data.totalFood : ''
            this.totalSummary.totalBeverage = Utils.checkValueExists(data.totalBeverage) ? data.totalBeverage : ''
          }
        }
      });


    },

    getPeriodicHistory(list, isTrigger = 0) {
      var i = 0
      var data = list.filter((res) => !res.isTrigger)
      if (isTrigger) {
        data = list.filter((res) => res.isTrigger)
      }

      data.sort((a, b) => a.id - b.id)

      data.map((n) => {
        i += 1
        var labourCost = 0
        var actualRoster = Utils.removeCommaInNumbers(n.actualRoster)
        var actualRevenue = Utils.removeCommaInNumbers(n.actualRevenue)
        if (actualRevenue) {
          if (actualRoster >= actualRevenue) {
            labourCost = `100%`
          } else {
            labourCost = (actualRoster / actualRevenue) * 100
            n.labourCost = `${labourCost.toFixed(2)}%`
          }
        }
        var timeType = n.reportTime.split(' ')
        timeType = timeType[1] == 'PM' ? 12 : 0
        var hr = n.reportTime.split(':')
        n.periodicName = n.name && n.name != '' ? n.name : Utils.getPeriodName(parseInt(hr[0]) + timeType)

        return n
      })

      return data
    },

    async refreshOpenEod() {
      this.isSaveGenerate = false
      var day = this.dailyTrendDay ? this.dailyTrendDay : 7
      await this.getActualLabour(day, 'labour', this.current_params)
      this.isSaveGenerate = true
      Utils.alert2('', 'You successfully generated an EOD report, and we will send it to the provided email addresses as soon as it available.', 'success');
    },
    closeEod() {
      this.eodVisibility = false
    },
    getEmployeeVariance(weekname, dashBoardId, monDateTime, sunDateTime) {
      api.labourApi({
        params: {
          dashBoardId, monDateTime, sunDateTime
        },
        callback: (res) => {
          var response = res.data.data
          var employeeTarget = response.targetLabourHoursList
          var employeeActual = response.actualLabourHoursList
          var isMoreTarget = employeeActual.length >= employeeTarget.length ? 1 : 0
          var allEmployees = Array.from(new Set(response.targetLabourHoursList.concat(response.actualLabourHoursList).map(n => n.employeeId)))

          var employeeVariance = allEmployees.map((n) => {
            var target = employeeTarget.find((emp) => emp.employeeId == n)
            var actual = employeeActual.find((emp) => emp.employeeId == n)
            var data = {}
            data.employeeId = n

            if (actual && target) {
              data.employee = isMoreTarget ? target.employee : actual.employee
              data.target = `${target[weekname]}h`
              data.actual = `${actual[weekname]}h`

              if (target[weekname] > actual[weekname]) {
                var total = target[weekname] - actual[weekname]
                data.variance = total.toFixed(2)
                data.varianceString = `${total.toFixed(2)}h`
              } else {
                data.variance = 0
              }
              data.isWithVariance = target[weekname] > actual[weekname] ? 1 : 0
            } else {
              if (target) {
                data.employee = target.employee
                data.target = `${target[weekname]}h`
                data.actual = 0

                data.variance = target[weekname]
                data.varianceString = `${target[weekname]}h`
                data.isWithVariance = target[weekname] ? 1 : 0
              }

              if (actual) {
                data.actual = `${actual[weekname]}h`
                data.target = 0
                data.variance = 0
                data.isWithVariance = 0
              }
            }

            return data
          })

          employeeVariance = employeeVariance.filter(n => n.isWithVariance)
          this.employeeVariance = employeeVariance
        }
      })


    },
    generateReport(eod, type) {
      this.eodPayloads = eod
      if (type == 1) {
        // this.isLoadingSaveEod = true
        // this.isLoadingType = 1
        // this.htmlToPdfOptions.filename = Math.random().toString(36).slice(2)
        // this.$refs.html2Pdf.generatePdf()
        this.eodVisibility = false
      } else if (type == 2) {
        // this.eodPayloads.withPdf = 0
        var eod = this.eodPayloads
      }

      this.saveEodReport(this.eodFormDataNew(eod))
    },
    onProgress(e) {
      this.loadingProgressValue = e
    },
    hasStartedGeneration(e) {
      // console.log(e, 'hasStartedGeneration')
    },

    hasGenerated(e) {
      // console.log(e, 'hasGenerated')
    },
    hasDownloaded(e) {
      this.eodPayloads.pdfFile = e
      this.eodPayloads.withPdf = 1
      this.isLoadingType = 2
      var eod = this.eodPayloads
      // Old eod save
      // this.saveEodReport(this.eodFormData(eod))
      // new eod save
      this.saveEodReport(this.eodFormDataNew(eod))
    },

    emptyEod(convertDate) {

      let bodyFormData = new FormData()

      const eodRequestJson = {
        reportDate: Utils.dateTimeGeneratorWithDay(convertDate, this.zoneId, 'yyyyMMDD'),
        managerOnDuty: '',
        food: '',
        beverage: '',
        cover: '',
        sph: '',
        manageServiceNote: '',
        bevServiceNote: '',
        venueVibe: '',
        weatherRecord: '',
        largeParties: '',
        vip: '',
        staff: '',
        training: '',
        compExp: '',
        whs: '',
        repairs: '',
        otherFeedback: '',
        compValue:0,
        cashTips: '',
        tillVariance: '',
        summary: '',
        guestFeedback: '',
        staffFeddback: '',
        mainternace: '',
        weekDay: this.currentEodParams.weekname,
        dashboardId: this.currentEodParams.dashBoardId,
        monDateTime: this.currentEodParams.monDateTime,
        sunDateTime: this.currentEodParams.sunDateTime,
        isGenerate: false,
        type: 'lunch',
        items86: '',
        accommodationRevenue: '',
        accommodationRate: ''
      }
      bodyFormData.append('eodRequestJson', JSON.stringify(eodRequestJson));

      return bodyFormData
    },

    eodFormDataNew(eod) {
      let bodyFormData = new FormData()

      const eodRequestJson = {
        reportDate: eod.reportDateFormatted,
        managerOnDuty: eod.manager,
        food: parseFloat(eod.food) ? parseFloat(eod.food) : '',
        beverage: parseFloat(eod.beverage) ? parseFloat(eod.beverage) : '',
        cover: parseFloat(eod.cover) ? parseFloat(eod.cover) : '',
        sph: parseFloat(eod.sph) ? parseFloat(eod.sph) : 0,
        manageServiceNote: eod.manageServiceNote,
        bevServiceNote: eod.bevServiceNote,
        venueVibe: eod.venueVibe,
        weatherRecord: eod.weatherRecord,
        largeParties: eod.largeParties,
        vip: eod.vip,
        staff: eod.staff,
        training: eod.training,
        compExp: eod.compExp,
        whs: eod.whs,
        repairs: eod.repairs,
        otherFeedback: eod.otherFeedback,
        compValue: parseFloat(eod.compValue) ? parseFloat(eod.compValue) : 0,
        cashTips: '',
        tillVariance: '',
        summary: '',
        guestFeedback: '',
        staffFeddback: '',
        mainternace: '',
        weekDay: this.currentEodParams.weekname,
        dashboardId: this.currentEodParams.dashBoardId,
        monDateTime: this.currentEodParams.monDateTime,
        sunDateTime: this.currentEodParams.sunDateTime,
        isGenerate: eod.isGenerate,
        type: eod.type,
        items86: this.instance_type == 'lucas' ? eod.items86 : '',
        accommodationRevenue: eod.accommodationRevenue,
        accommodationRate: eod.accommodationRate,
        labourWeekToDate: eod.labourWeekToDate,
        execSummary: eod.execSummary,
        purchases: eod.purchases,
        weekTodate: eod.weekTodate,
        usedRoomsCount: eod.usedRoomsCount,
        availableRoomsCount: eod.availableRoomsCount
      }

      bodyFormData.append('eodRequestJson', JSON.stringify(eodRequestJson));

      if (eod.fileList) {
        eod.fileList.map((file, i) => {
          bodyFormData.append(`file`, file.raw)
        })
      }

      return bodyFormData

    },

    eodFormData(eod) {
      let bodyFormData = new FormData()

      if (eod.withPdf) {
        bodyFormData.append('file', eod.pdfFile)
      }


      // bodyFormData.append('periodicData', eod.periodicData)

      bodyFormData.append('reportDate', eod.reportDateFormatted)
      bodyFormData.append('managerOnDuty', eod.manager)
      bodyFormData.append('food', parseFloat(eod.food) ? parseFloat(eod.food) : '')
      bodyFormData.append('beverage', parseFloat(eod.beverage) ? parseFloat(eod.beverage) : '')
      bodyFormData.append('cover', parseFloat(eod.cover) ? parseFloat(eod.cover) : '')
      bodyFormData.append('sph', parseFloat(eod.sph) ? parseFloat(eod.sph) : 0)
      bodyFormData.append('manageServiceNote', eod.manageServiceNote)
      bodyFormData.append('bevServiceNote', eod.bevServiceNote)
      bodyFormData.append('venueVibe', eod.venueVibe)
      bodyFormData.append('weatherRecord', eod.weatherRecord)
      bodyFormData.append('largeParties', eod.largeParties)
      bodyFormData.append('vip', eod.vip)
      bodyFormData.append('staff', eod.staff)
      bodyFormData.append('training', eod.training)
      bodyFormData.append('compExp', eod.compExp)
      bodyFormData.append('whs', eod.whs)
      bodyFormData.append('repairs', eod.repairs)
      bodyFormData.append('otherFeedback', eod.otherFeedback)
      bodyFormData.append('compValue', parseFloat(eod.compValue) ? parseFloat(eod.compValue) : 0)
      bodyFormData.append('cashTips', '')
      bodyFormData.append('tillVariance', '')
      bodyFormData.append('summary', '')
      bodyFormData.append('guestFeedback', '')
      bodyFormData.append('staffFeddback', '')
      bodyFormData.append('mainternace', '')
      bodyFormData.append('weekDay', this.currentEodParams.weekname)
      bodyFormData.append('dashBoardId', this.currentEodParams.dashBoardId)
      bodyFormData.append('monDateTime', this.currentEodParams.monDateTime)
      bodyFormData.append('sunDateTime', this.currentEodParams.sunDateTime)
      bodyFormData.append('isGenerate', eod.isGenerate)
      // bodyFormData.append('document', eod.file);
      bodyFormData.append('type', eod.type);

      if (eod.fileList) {
        eod.fileList.map((file, i) => {
          bodyFormData.append(`file`, file.raw)
        })
      }

      return bodyFormData
    },

    saveEodReport(data, type) {
      // api.saveEodReport - old eod report api
      api.saveEodReportNew(data).then((res) => {
        var data = res.data
        if (data.code == 0) {

          // if (res.data.data.eodHistory) {
          //     this.eodHistory = res.data.data.eodHistory
          //     this.eodHistory.fileList = res.data.data.reportDocumentsList ? res.data.data.reportDocumentsList : [];
          // }

          setTimeout(() => {
            if (this.eodPayloads.withPdf) {
              this.eodPayloads = {}
              this.isLoadingSaveEod = false
              this.eodVisibility = false
            }
          }, 1000)
        } else {
          Utils.alert2('', data.message, 'error')
        }
      })

    },

    setActualRevenue(revenue, isCurrent) {
      if (revenue) {
        if (this.actualRevenue == null) {
          this.actualRevenue = 0
        }

        if (this.actualRevenue < revenue) {
          this.actualRevenue = revenue
        }
        if (isCurrent) {
          sessionStorage.setItem('revenueToday', revenue)
        }

      }
    },

    getDayTimezone(timezone) {
      this.timezone = timezone;
      this.weekDay = parseInt(sessionStorage.getItem('currentWeekIndex'));
    },

    getWeekData(val) {
      if (!val)
        return
      // UE确认：每次选择的周变化，都要重新默认回daily
      this.currentChosen = 0

      this.options.forEach((i) => {
        if (i.dashBoardId === this.week || i.value === this.week) {
          this.currentWeekType = i.value;
        }
      });


      // UE：除了this next last，其他周都是未来的周，所以全部都把Daily吃掉
      if (val === -1 || val === -2 || val === -3) {
        var that = this
        that.clearDatum()
        that.currentWeek = [];
        const nowTime = that.$box.getToday().time
        const day = that.$box.getToday().day
        const oneDayTime = 24 * 60 * 60 * 1000

        var MondayTime = nowTime - (day - 1) * oneDayTime
        if (val === -2) {
          MondayTime = (nowTime - (day - 1) * oneDayTime) - 7 * oneDayTime
        } else if (val === -3) {
          MondayTime = (nowTime - (day - 1) * oneDayTime) + 7 * oneDayTime
        }

        // 本周一时间戳
        if (this.weekStart === 1) {
          this.currentWeek = this.$box.loadWeekDatum(MondayTime / 1000)
        }
        else {
          this.currentWeek = this.$box.loadWeekDatum(MondayTime / 1000 + (this.weekStart - 1) * 86400)
        }

        if (val === -2) {
          this.showLastWeekEstimateButton = true
        }
        return;
      }

      // 首页数据 8989
      if (this.options.length > 0) {

        this.requestDatum(this.options, val);
      } else {
        Api.getTimeList((res) => {
          if (!res || !res.data) return;
          if (res.data.code == 0) {
            this.getDayTimezone(res.data.data.zoneId)
            res.data.data.list.forEach((item => {
              if (item.dashBoardId === null)
                item.dashBoardId = item.value
            }))
            this.requestDatum(res.data.data.list, val);
          } else if (res.data.code == 8902) {
            sessionStorage.clear();
            this.$router.push("/login");
          } else {
            Utils.alert("", res.data.message, "error");
          }
        });
      }

      this.loading = true;
      this.rosterFeedback = null;

      this.revenueTarget = null;
      this.targetRoster = null;
      this.targetHourRoster = null;
      this.actualRoster = null;
      this.actualHourRoster = null;
      this.actualPercentRoster = null;
      this.targetPercentRoster = null;
    },

    initializeThirdPartyAPI() {
      var apiType = localStorage.getItem('apiType') ? localStorage.getItem('apiType') : ''
      if (this.$route.query.code && apiType == 'kseries') {
        localStorage.setItem('kseriesCode', this.$route.query.code)
        localStorage.setItem('kseriesState', this.$route.query.state)
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
          window.open('', '_self').close()
          login
        } else {
          window.opener = null;
          window.open("about:blank", "_self");
          window.close();
        }
      } else if (this.$route.query.code && apiType == 'oseries') {
        localStorage.setItem('oseriesCode', this.$route.query.code)
        localStorage.setItem('oseriesState', this.$route.query.state)
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
          window.open('', '_self').close()
          window.location.href = "about:blank"
        } else {
          window.opener = null;
          window.open("about:blank", "_self");
          window.close();
        }
      }
    },

    websocketConnection() {
      this.webSocket = new WebSocket(process.env.WEBSOCKET_URL)

      if (this.webSocket) {
        this.webSocket.onmessage = (event) => {
          var webSocketMessage = event.data
          var isGetMessage = webSocketMessage.toLowerCase().includes('refresh@websocket')
          if (isGetMessage) {
            this.typeChangeEvt(this.currentChosen, 'yes', 'onlyFreshDatumNotIncludingChart', this.dailyTrendDay)
            this.typeChangeEvt(this.currentChosen, 'yes', 'onlyFreshChartNotIncludingDatum', this.dailyTrendDay)
            // console.log('refresh')
          }
        }

        this.webSocket.onopen = (event) => {
          // console.log("Successfully connected to the echo websocket server...")
        }

        this.webSocket.onerror = (event) => {
          // console.log(event.data)
        }
      }
    },

    setSelectedRevenue(idx) {
      this.revenueList = this.revenueList.map((n) => {
        n.checked = false
        return n
      })
      this.revenueList[idx].checked = true
    },

    revenueJumpTo() {
      this.isLoadingRevenuePlatform = true
      const rev = this.revenueList.find(n => n.checked)

      this.selectedRevenuePlatform = rev.abbr;

      if (rev.abbr == 'Doshii') {
        this.jumpDoshii()
      } else if (rev.abbr == 'k-series') {
        localStorage.setItem('apiType', 'kseries')
        this.jumpLightSpeedKseries()
        // this.businessLocationVisible = true
        // this.isLoadingRevenuePlatform = false
        // this.loadingVisibility = true
      } else if (rev.abbr == 'o-series') {
        localStorage.setItem('apiType', 'oseries')
        localStorage.removeItem('oseriesCode')
        localStorage.removeItem('oseriesState')
        this.integrationType = 'oseries'
        this.jumpLightSpeedOseries()
      } else if (rev.abbr == 'tevalis') {
        this.isOpenTevalisConfiguration = true
        this.showRevenueSelect = false
        this.isLoadingRevenuePlatform = false
        this.isLoadingTevalis = false
      } else if (rev.abbr == 'redcat') {
				this.integrationType = 'redcat'
				this.isOpenRedcatConfiguration = true
				this.isLoadingRevenuePlatform = false
      } else if (rev.abbr == 'square') {
        this.jumpSquare();
      } else if (rev.abbr == 'idealpos') {
        this.isOpenCsvUploadConfiguration = true
        this.isLoadingRevenuePlatform = false
        this.csvTitle = 'IdealPOS Configuration'
      } else if (rev.abbr == 'impos') {
        this.isOpenCsvUploadConfiguration = true
        this.isLoadingRevenuePlatform = false
        this.csvTitle = 'Impos Configuration'
      } else if (rev.abbr == 'bepoz') {
				this.isOpenCsvUploadConfiguration = true
				this.isLoadingRevenuePlatform = false
				this.csvTitle = 'Bepoz Configuration'
			} else if (rev.abbr == 'oolio') {
				this.jumpOolio();
			} else if (rev.abbr == 'handl') {
				this.isOpenHandlConfiguration = true
				this.isLoadingRevenuePlatform = false
      } else if (rev.abbr == 'swiftpos') {
        this.isOpenSwiftPosConfiguration = true
        this.isLoadingRevenuePlatform = false
			}
      // this.showRevenueSelect = false
    },

    jumpSquare () {
			window.open(process.env.SQUARE_URL, "_blank")
      clearInterval(this.timer)

			this.timer = setInterval(this.squareLongpoll, 3000)
		},

    jumpOolio() {
      window.open(process.env.OOLIO_URL, "_blank")
      clearInterval(this.timer)
      this.timer = setInterval(this.oolioLongpoll, 1000)
      console.log('jumpOolio', process.env.OOLIO_URL)
    },

  	oolioLongpoll() {
      console.log('oolioLongpoll', localStorage.getItem('oolioCode'))
			if (localStorage.getItem('oolioCode')) {
				clearInterval(this.timer)
				this.oolioCode = localStorage.getItem('oolioCode')
				this.integrationType = 'oolio'

				this.isOpenOolioConfiguration = true
				this.showRevenueSelect = false

				localStorage.removeItem('oolioCode')
			}
		},

    jumpLightSpeedKseries() {
      const urlType = `${process.env.WEB_URL}/`
      Api.getKseriesAuthorization({ url: urlType }).then((res) => {
        let url = res.data.data
        window.open(url, "_blank")

        clearInterval(this.timer4);
        this.timer4 = setInterval(this.longPollLightSpeedKseries, 3000);
      }).catch((err) => {
        // Utils.alert2('', err, 'error')
      })
    },
    jumpLightSpeedOseries() {
      let oseriesUrl = process.env.LIGHTSPEED_OSERIES
      window.open(oseriesUrl, '_blank')

      localStorage.setItem('apiType', 'oseries')

      this.timer5 = setInterval(this.longPollLightSpeedOseries, 3000)
    },
    longPollLightSpeedOseries() {
      if (!localStorage.getItem('oseriesCode')) {
        return
      }
      var data = {}
      data.code = localStorage.getItem('oseriesCode')
      data.state = localStorage.getItem('oseriesState')

      this.showRevenueSelect = false
      this.loadingVisibility = true
      this.loadingLabel = 'Authenticating...'
      this.loadingPecentage = 30

      Api.oseriesBind(data).then((res) => {
        var result = res.data
        this.loadingLabel = 'Connecting to Lightspeed O-series...'
        setTimeout(() => {
          this.loadingPecentage = 80
          setTimeout(() => {
            this.loadingPecentage = 100
            this.siteLocationVisible = true
            this.loadingVisibility = false
          }, 500);
        }, 500);
        if (result.code == 0) {
          var result = res.data
          this.siteData = result.data
        } else if (result.code == 10000) {
          var data = [
            {
              id: 117946,
              name: 'Lucia',
              code: 'Lucia'
            }
          ]
          this.siteData = data
        }
        else {
          Utils.alert("", res.data.message, "error");
        }
        clearInterval(this.timer5)
      })

    },
    longPollLightSpeedKseries() {

      if (!localStorage.getItem('kseriesCode')) {
        return
      }
      var data = {}
      data.code = localStorage.getItem('kseriesCode')
      data.state = localStorage.getItem('kseriesState')
      data.redirect_uri = `${process.env.WEB_URL}/`

      this.showRevenueSelect = false
      this.loadingVisibility = true
      this.loadingLabel = 'Authenticating...'
      this.loadingPecentage = 30

      Api.kseriesHandShake(data).then((res) => {
        var result = res.data
        if (result.code == 0) {
          // console.log(res)
          this.loadingLabel = 'Connecting to Lightspeed K-series...'
          this.loadingPecentage = 80
          Api.kseriesBusinesses().then((res) => {
            this.businessData = res.data.data
            this.businessLocationVisible = true
            this.loadingLabel = 'Successfully connected, Opening businesses list...'
            this.loadingPecentage = 99
            setTimeout(() => {
              this.loadingVisibility = false
            }, 1000);
          })
          clearInterval(this.timer4)
        } else {
          // Utils.alert2('', result.message, 'error')
        }
      })
    },

    flaggedToLightSpeed(flaggedType) {
      this.fristdisable = false
      this.kseriesBind = false
      this.oseriesFlag = false
      if (flaggedType == 'kseries') {
        this.kseriesBind = true
      } else if (flaggedType == 'oseries') {
        this.oseriesFlag = true
      }
    },

    setSelectedWeek(name) {
      const option = this.options.find((item) => item.dashBoardId == this.week || item.value == this.week);
      if (option) {

        this.startDate = option.startDate;

        if (name == 'RevenueTarget') {

          if (option.value == 'THIS WEEK') {
            return true
          } else if (option.value == 'NEXT WEEK') {
            return true
          } else if (option.value == 'LAST WEEK') {
            return false;
          }

        } else if (name == 'ActualRevenue') {
          if (option.value == 'THIS WEEK' || option.value == 'LAST WEEK') {
            return true
          } else {
            return false;
          }
        }
      }

      return true;
    },

    openCab() {
      if (!this.eodParams) {
        Utils.alert2('', 'Unable to open cashup. please connect to your revenue and scheduling platform')
        return
      }

      if (this.eodParams.day) {
        var cashupDate = Utils.getCurrentDate(this.eodParams, this.dailyTrendDay, this.zoneId)
        this.cashupReportDate = cashupDate
        this.reportDateWithFormat = Utils.dateTimeGeneratorWithDay(cashupDate, this.zoneId)
      } else {
        this.cashupReportDate = Utils.dateTimeGeneratorWithDay(new Date(), 'Australia/sydney', 'yyyy-MM-DD');
      }
      // if (this.cashupReportDate == 'Invalid date') {
      //   this.cashupReportDate = Utils.dateTimeGeneratorWithDay(new Date(), this.zoneId, 'yyyy-MM-DD')
      // }
      this.cashupv2 = true

      // this.cabVisibility = true
    },

    openJournal() {
      this.isOpenJournal = true
      this.journalReportDate = Utils.getCurrentDate(this.eodParams, this.dailyTrendDay, this.zoneId)

    },

    closeCap() {
      this.cabVisibility = false
    },

    closeOrLogoutVenue(isSubscribe) {
      if (isSubscribe) {
        this.isTrialEnd = false
        return
      }
      if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
        this.$root.$emit('logout-venue')
      } else {
        const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
        if (isContUsingTrial == '0') {
          sessionStorage.setItem('isContUsingTrial', '1')
        }
        this.isTrialEnd = false
      }
    },

    cashupAction(action) {
      if (action == 'cancel') {
        this.pinDialogVisibile = false
        this.cashupv2 = false
      } else {
        this.pinDialogVisibile = false
      }
    },


    connectToRevenue() {
      const isAllowedUnlinking = sessionStorage.getItem('isAllowedUnlinking') ? 1 : 0
      this.showRevenueSelect = true

      if (!this.revenueList.length) {
        this.revenueList = [
					{
						title: 'Bepoz',
						description: 'Please go to Bepoz configuration to complete the integration',
						class: 'bepoz',
						abbr: 'bepoz',
						checked: false,
						isDisplayed: this.instance_type == 'sandbox' && isAllowedUnlinking ? true : false,
					},
          {
						title: 'Doshii',
						description: 'Please go to the Doshii management background to initiate a connection<br />request to Peiso',
						class: 'doshii',
						abbr: 'Doshii',
						checked: false,
						isDisplayed: this.isPro && isAllowedUnlinking ? true : false,
					},
          {
						title: 'H&L',
						description: 'Please go to H&L configuration to complete the integration',
						class: 'handl',
						abbr: 'handl',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'IdealPOS',
						description: 'Please go to IdealPOS configuration to complete the integration',
						class: 'idealpos',
						abbr: 'idealpos',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Impos',
						description: 'Please go to Impos configuration to complete the integration',
						class: 'impos',
						abbr: 'impos',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Lightspeed Restaurant (K-Series)',
						description: 'Please go to the Lightspeed  management background to initiate a connection<br />request to Peiso',
						class: 'k-series',
						abbr: 'k-series',
						checked: false,
						isDisplayed: true,
					},
					{
						title: 'Lightspeed Restaurant (O-Series)',
						description: 'Please go to the Lightspeed  management background to initiate a connection<br />request to Peiso',
						class: 'o-series',
						abbr: 'o-series',
						checked: false,
						isDisplayed: true,
					},
          {
						title: 'Oolio',
						description: 'Please go to Oolio configuration to complete the integration',
						class: 'oolio',
						abbr: 'oolio',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Redcat',
						description: 'Please go to Redcat configuration to complete the integration',
						class: 'redcat',
						abbr: 'redcat',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					},
					{
						title: 'Square',
						description: 'Please go to the Square management background to initiate a connection<br />request to Peiso',
						class: 'square',
						abbr: 'square',
						checked: false,
						isDisplayed: true,
					},
					{
						title: 'SwiftPOS',
						description: 'Please go to SwiftPOS configuration to complete the integration',
						class: 'swiftpos',
						abbr: 'swiftpos',
						checked: false,
						isDisplayed: this.instance_type == 'sandbox' && isAllowedUnlinking ? true : false,
					},
					{
						title: 'Tevalis',
						description: 'Please go to Tevalis configuration to complete the integration',
						class: 'tevalis',
						abbr: 'tevalis',
						checked: false,
						isDisplayed: isAllowedUnlinking ? true : false,
					}
        ]
      }
    },
    getTevalisCategories(siteId) {
      Api.tevalisCategories(siteId).then((category) => {

        if (category.data.code == 0) {
          this.categories = category.data.data
          this.configurationStep = 2
        } else {
          Utils.alert2("", res.data.message, 'error')
        }
        this.isLoadingTevalis = false
      })
    },
    connectToTevalis(data) {
      this.isLoadingTevalis = true

      Api.tevalisBind(data).then((res) => {
        if (res.data.code == 0) {
          this.sites = res.data.data
          Api.tevalisCategories(this.sites[0].id).then((category) => {

            if (category.data.code == 0) {
              this.categories = category.data.data
              this.configurationStep = 2
            } else {
              Utils.alert2("", res.data.message, 'error')
            }
            this.isLoadingTevalis = false
          })
        } else {
          Utils.alert2("", res.data.message, 'error')
          this.isLoadingTevalis = false
        }
        // this.isOpenTevalisConfiguration = false
      }).catch((err) => {
        Utils.alert2('', 'Connection failt in tevalis integration binding', 'error')
        this.isLoadingTevalis = false
        this.isOpenTevalisConfiguration = false
      })

    },

    async completeSquareBinding (data) {
			this.isLoadingSquare = false
			this.isOpenSquareConfiguration = false
			this.getStatus();

			setTimeout(() => {
				window.location.reload();
			}, 1000);
		},

    	completeOolioBinding(data) {
        this.isLoadingOolio = false
        this.isOpenOolioConfiguration = false
        this.getStatus();

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },

    completeSwiftPosBinding(data) {
      this.isOpenSwiftPosConfiguration = false

      if (data) {
        this.swiftPosFlag = true
      }

      this.getStatus()

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },

    async completeHandlBinding(data) {
			this.isLoadingHandl = false
			this.isOpenHandlConfiguration = false
			this.getStatus();

			setTimeout(() => {
				window.location.reload();
			}, 1000);

		},



    completeTevalisBinding(data) {
      this.isLoadingTevalis = true
      Api.tevalisCompleteBinding(data).then((res) => {
        if (res.data.code == 0) {
          this.isLoadingTevalis = false
          this.isOpenTevalisConfiguration = false
          this.tevalisFlag = true
          Utils.alert2("", 'Tevalis successfully connected.', 'success')
        } else {
          Utils.alert2("", res.data.message, 'error')
        }
      })
    },

    csvBinding(value) {
      this.showRevenueSelect = false
      this.isOpenCsvUploadConfiguration = false;
      this.getStatus()

      setTimeout(() => {
          window.location.reload();
      }, 1000);
    },

    redCatSiteSelectio(isOpen, siteData) {
			this.siteLocationVisible = isOpen
			this.siteData = siteData
		},

		completeRedcatBinding(data) {
			this.showRevenueSelect = false
			this.getStatus()

      setTimeout(() => {
          window.location.reload();
      }, 1000);
		},

    async refreshLabour() {
      this.refreshRosterLoading = true;

      let weekType = -1;

      if (this.currentWeekType == 'NEXT WEEK') {
        weekType = 1;
      }

      try {
        await api.refreshLabourData(weekType)
        Utils.alert2("", "Successfully re-run the roster", 'success')

        this.refreshRosterLoading = false;

        setTimeout(() => {
          window.location.reload();
        }, 1000);

      } catch (error) {
        Utils.alert2('', 'Something went wrong, please contact administrator.', 'error');


        this.refreshRosterLoading = false;
      }

    },

    openCashupSetting() {
      this.cashupSetting = true
    }

  },
  computed: {
    ...mapState({
      open: (state) => state.open,
    }),

    formattedWeekStartDate() {
      return this.startDate ? Utils.dateTimeGeneratorWithDay(this.startDate, this.zoneId, 'DD/MM') : '';
    },

    newSelLists() {
      let result = this.newSelList;

      if (this.newSelList.length > 0) {
        result = this.newSelList.filter((res) => {
          return res.companyName.toLowerCase().includes(this.searchVenue.toLowerCase())
        })
      }

      return result
    }
  },
  watch: {
    week: {
      deep: true,
      handler: function (val) {
        this.getWeekData(val)
      },
    },
    open: {
      deep: true,
      handler: function (val) {
        if (val === true) {
          this.queryTemporary();
        }
      },
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer2);
    clearInterval(this.agreeTimer);
    clearInterval(this.pinTimer);
    clearInterval(this.nextimer);
    this.clearIntervalOfTenMinutes();
  },
  components: {
    xero, Terms: terms, TreeTable: treeTable,
    DoshiiAlert: doshiiAlert, Echart: echart, RevenueChart: revenueChart, LabourChart: labourChart, Chart: Chart,
    WeeklyLabourTable: weeklyLabourTable, dayChoice: dayChoice,
    ActualWeeklyOperation: actualWeeklyOperation, xerobindpop, Bluesheets: bluesheets,
    eodOld: eodOld,
    eod: eod, VueHtml2pdf,
    modalBusinessLocation: modalBusinessLocation,
    modalLoading: modalLoading,
    modalSitesLocation: modalSitesLocation,
    modalLabourTarget: modalLabourTarget,
    modalMessageDialog,
    cashupBanking: cashupBanking,
    transactionSelection: transactionSelection,
    weeklyReport: confirmWeeklyReport,
    dashboardOverview: dashboardOverview,
    freeTrialNotice: freeTrialNotice,
    cashUpBankingV2: cashUpBankingV2,
    cashup,
    cashupOtto,
    pinDialog: pinDialog,
    journalManualEntry: journalManualEntry,
    tevalisConfiguration: tevalisConfiguration,
    redcatConfiguration: redcatConfiguration,
    cashupSetting: cashupSetting,
    CsvUploadConfiguration,
    SquareConfiguration,
    oolioConfiguration,
    handlConfiguration,
    SwiftPosConfiguration
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/dashboard_new.scss';
@import '@/assets/css/dashborad.scss';
@import 'static/scss/eod';
</style>



// WEBPACK FOOTER //
// src/components/dashboard/index.vue